//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IFileClient {
    uploadFile(files: UploadFile[]): Observable<UploadFileResult[]>;
    downloadFile(contentType: string | null | undefined, requestedFile: DownloadFile): Observable<FileResponse>;
    externalFileDownload(request: DownloadFileExternalRequest): Observable<FileResponse>;
    downloadZip(ids: string[]): Observable<FileResponse>;
    /**
     * @deprecated
     */
    getFileLink(requestedFile: DownloadFile): Observable<DownloadFileResult>;
    getTaskDocuments(id: string): Observable<FmDocument[]>;
    getIncidentDocuments(id: string): Observable<FmDocument[]>;
    externalGetIncidentDocuments(id: string, ticketNumber: string | undefined, primaryContactEmail: string | undefined): Observable<FmDocument[]>;
    getContactDocuments(id: string): Observable<FmDocument[]>;
    getRentalContractDocuments(id: string): Observable<FmDocument[]>;
    getSpeedikonDocuments(archObjId: string): Observable<VersionedDocumentViewModel[]>;
    setFileDeleted(id: string): Observable<DownloadFileResult>;
    setFileVisibility(request: SetFileVisibility): Observable<DownloadFileResult>;
}

@Injectable()
export class FileClient implements IFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    uploadFile(files: UploadFile[]): Observable<UploadFileResult[]> {
        let url_ = this.baseUrl + "/api/File/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(files);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadFileResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadFileResult[]>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<UploadFileResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadFileResult[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFile(contentType: string | null | undefined, requestedFile: DownloadFile): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/File/DownloadFile?";
        if (contentType !== undefined && contentType !== null)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestedFile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    externalFileDownload(request: DownloadFileExternalRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/File/ExternalFileDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalFileDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalFileDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExternalFileDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    downloadZip(ids: string[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/File/DownloadZip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadZip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadZip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadZip(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * @deprecated
     */
    getFileLink(requestedFile: DownloadFile): Observable<DownloadFileResult> {
        let url_ = this.baseUrl + "/api/File/GetFileLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestedFile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResult>;
        }));
    }

    protected processGetFileLink(response: HttpResponseBase): Observable<DownloadFileResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadFileResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getTaskDocuments(id: string): Observable<FmDocument[]> {
        let url_ = this.baseUrl + "/api/File/GetTaskDocuments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FmDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FmDocument[]>;
        }));
    }

    protected processGetTaskDocuments(response: HttpResponseBase): Observable<FmDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FmDocument[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentDocuments(id: string): Observable<FmDocument[]> {
        let url_ = this.baseUrl + "/api/File/GetIncidentDocuments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FmDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FmDocument[]>;
        }));
    }

    protected processGetIncidentDocuments(response: HttpResponseBase): Observable<FmDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FmDocument[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    externalGetIncidentDocuments(id: string, ticketNumber: string | undefined, primaryContactEmail: string | undefined): Observable<FmDocument[]> {
        let url_ = this.baseUrl + "/api/File/ExternalGetIncidentDocuments/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (ticketNumber === null)
            throw new Error("The parameter 'ticketNumber' cannot be null.");
        else if (ticketNumber !== undefined)
            url_ += "ticketNumber=" + encodeURIComponent("" + ticketNumber) + "&";
        if (primaryContactEmail === null)
            throw new Error("The parameter 'primaryContactEmail' cannot be null.");
        else if (primaryContactEmail !== undefined)
            url_ += "primaryContactEmail=" + encodeURIComponent("" + primaryContactEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalGetIncidentDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalGetIncidentDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FmDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FmDocument[]>;
        }));
    }

    protected processExternalGetIncidentDocuments(response: HttpResponseBase): Observable<FmDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FmDocument[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getContactDocuments(id: string): Observable<FmDocument[]> {
        let url_ = this.baseUrl + "/api/File/GetContactDocuments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FmDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FmDocument[]>;
        }));
    }

    protected processGetContactDocuments(response: HttpResponseBase): Observable<FmDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FmDocument[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getRentalContractDocuments(id: string): Observable<FmDocument[]> {
        let url_ = this.baseUrl + "/api/File/GetRentalContractDocuments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRentalContractDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRentalContractDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FmDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FmDocument[]>;
        }));
    }

    protected processGetRentalContractDocuments(response: HttpResponseBase): Observable<FmDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FmDocument[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getSpeedikonDocuments(archObjId: string): Observable<VersionedDocumentViewModel[]> {
        let url_ = this.baseUrl + "/api/File/GetSpeedikonDocuments/{archObjId}";
        if (archObjId === undefined || archObjId === null)
            throw new Error("The parameter 'archObjId' must be defined.");
        url_ = url_.replace("{archObjId}", encodeURIComponent("" + archObjId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeedikonDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeedikonDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VersionedDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VersionedDocumentViewModel[]>;
        }));
    }

    protected processGetSpeedikonDocuments(response: HttpResponseBase): Observable<VersionedDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionedDocumentViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    setFileDeleted(id: string): Observable<DownloadFileResult> {
        let url_ = this.baseUrl + "/api/File/SetFileDeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFileDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFileDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResult>;
        }));
    }

    protected processSetFileDeleted(response: HttpResponseBase): Observable<DownloadFileResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadFileResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    setFileVisibility(request: SetFileVisibility): Observable<DownloadFileResult> {
        let url_ = this.baseUrl + "/api/File/SetFileVisibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFileVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFileVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResult>;
        }));
    }

    protected processSetFileVisibility(response: HttpResponseBase): Observable<DownloadFileResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadFileResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IHealthClient {
    get(): Observable<void>;
}

@Injectable()
export class HealthClient implements IHealthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<void> {
        let url_ = this.baseUrl + "/api/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IIncidentClient {
    createIncident(incidentDTO: CreateIncidentFromPortalDTO): Observable<string>;
    createIncidentAuthenticated(incidentDTO: CreateIncidentAuthenticatedFromPortalDTO): Observable<string>;
    createEmployeeNotification(request: CreateEmployeeNotificationRequest): Observable<IncidentIdResult>;
    createKeyServiceRequest(request: CreateServiceRequestFromPortal): Observable<ServiceRequestViewModel>;
    createFurnitureOrder(request: CreateFurnitureOrderRequest): Observable<IncidentIdResult>;
    createRelocation(request: CreateRelocationRequest): Observable<IncidentIdResult>;
    getIncidentAuthenticated(id: string | undefined): Observable<IncidentViewModel>;
    getIncidentByTicketIdAuthenticated(id: string | undefined): Observable<IncidentViewModel>;
    getIncidentsAuthenticated(searchOptions: IncidentSearchOptions): Observable<ResultWrapperOfIncidentTableEntryViewModel>;
    getDtagTickets(searchOptions: IncidentSearchOptions): Observable<ResultWrapperOfDtagIncidentTableEntryViewModel>;
    getBuildingFaultIncident(id: string | undefined): Observable<BuildingFaultIncidentViewModel>;
    getBuildingFaultIncidents(request: BuildingFaultIncidentRequest): Observable<ResultWrapperOfBuildingFaultIncidentViewModel>;
    getMyIncidents(request: MyIncidentsRequest): Observable<ResultWrapperOfMyIncidentsViewModel>;
    getOrderAccessIncident(id: string | undefined): Observable<OrderAccessIncidentViewModel>;
    getFurnitureOrderIncident(id: string | undefined): Observable<FurnitureOrderIncidentViewModel>;
    getRelocationIncident(id: string | undefined): Observable<RelocationViewModel>;
    getSpaceRequestIncident(id: string | undefined): Observable<SpaceRequestViewModel>;
    getAreaReturnIncident(id: string | undefined): Observable<AreaReturnViewModel>;
    getUserAdministrationIncident(id: string | undefined): Observable<UserAdministrationViewModel>;
    getIncidentWithEmail(getIncidentDTO: GetIncidentDTO): Observable<FmIncident>;
    getIncidentWithEmailAuthenticated(getIncidentDTO: GetIncidentDTO): Observable<FmIncident>;
    getSubIncidents(id: string | undefined): Observable<SubIncidentViewModel[]>;
    getAllIncidentClasses(): Observable<BaseSelectViewModel[]>;
    getIncidentClassesByRole(selectedRole: string | undefined): Observable<BaseSelectViewModel[]>;
    createSpaceRequest(request: RequestFileWrapperOfCreateSpaceRequestRequest): Observable<IncidentIdResult>;
    createCostCenterAreaReturnTicket(req: RequestFileWrapperOfCostCenterAreaReturnTicketRequest): Observable<IncidentIdResult>;
    createSbuAreaReturnTicket(req: RequestFileWrapperOfSbuAreaReturnTicketRequest): Observable<IncidentIdResult>;
    getIncidentClassesForDL(): Observable<BaseSelectViewModel[]>;
    generateIncidentPdf(request: IncidentPdfRequest): Observable<void>;
    getIncidentTypes(): Observable<string[]>;
    getIncidentClassesByIncidentType(incidentType: string | undefined): Observable<BaseSelectViewModel[]>;
    getConfigurationTasksByIncidentClass(incidentClassId: string | undefined): Observable<ConfigurationTaskViewModel[]>;
}

@Injectable()
export class IncidentClient implements IIncidentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createIncident(incidentDTO: CreateIncidentFromPortalDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/Incident/CreateIncident";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(incidentDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateIncident(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createIncidentAuthenticated(incidentDTO: CreateIncidentAuthenticatedFromPortalDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/Incident/CreateIncidentAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(incidentDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIncidentAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIncidentAuthenticated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateIncidentAuthenticated(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createEmployeeNotification(request: CreateEmployeeNotificationRequest): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/Incident/CreateEmployeeNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmployeeNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmployeeNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processCreateEmployeeNotification(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createKeyServiceRequest(request: CreateServiceRequestFromPortal): Observable<ServiceRequestViewModel> {
        let url_ = this.baseUrl + "/api/Incident/CreateKeyServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateKeyServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateKeyServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceRequestViewModel>;
        }));
    }

    protected processCreateKeyServiceRequest(response: HttpResponseBase): Observable<ServiceRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceRequestViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createFurnitureOrder(request: CreateFurnitureOrderRequest): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/Incident/CreateFurnitureOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFurnitureOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFurnitureOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processCreateFurnitureOrder(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createRelocation(request: CreateRelocationRequest): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/Incident/CreateRelocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRelocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRelocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processCreateRelocation(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentAuthenticated(id: string | undefined): Observable<IncidentViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetIncidentAuthenticated?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentAuthenticated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentViewModel>;
        }));
    }

    protected processGetIncidentAuthenticated(response: HttpResponseBase): Observable<IncidentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentByTicketIdAuthenticated(id: string | undefined): Observable<IncidentViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetIncidentByTicketIdAuthenticated?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentByTicketIdAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentByTicketIdAuthenticated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentViewModel>;
        }));
    }

    protected processGetIncidentByTicketIdAuthenticated(response: HttpResponseBase): Observable<IncidentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentsAuthenticated(searchOptions: IncidentSearchOptions): Observable<ResultWrapperOfIncidentTableEntryViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetIncidentsAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentsAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentsAuthenticated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfIncidentTableEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfIncidentTableEntryViewModel>;
        }));
    }

    protected processGetIncidentsAuthenticated(response: HttpResponseBase): Observable<ResultWrapperOfIncidentTableEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfIncidentTableEntryViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 424) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getDtagTickets(searchOptions: IncidentSearchOptions): Observable<ResultWrapperOfDtagIncidentTableEntryViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetDtagTickets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDtagTickets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDtagTickets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfDtagIncidentTableEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfDtagIncidentTableEntryViewModel>;
        }));
    }

    protected processGetDtagTickets(response: HttpResponseBase): Observable<ResultWrapperOfDtagIncidentTableEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfDtagIncidentTableEntryViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 424) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getBuildingFaultIncident(id: string | undefined): Observable<BuildingFaultIncidentViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetBuildingFaultIncident?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingFaultIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingFaultIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingFaultIncidentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingFaultIncidentViewModel>;
        }));
    }

    protected processGetBuildingFaultIncident(response: HttpResponseBase): Observable<BuildingFaultIncidentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingFaultIncidentViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getBuildingFaultIncidents(request: BuildingFaultIncidentRequest): Observable<ResultWrapperOfBuildingFaultIncidentViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetBuildingFaultIncidents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingFaultIncidents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingFaultIncidents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfBuildingFaultIncidentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfBuildingFaultIncidentViewModel>;
        }));
    }

    protected processGetBuildingFaultIncidents(response: HttpResponseBase): Observable<ResultWrapperOfBuildingFaultIncidentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfBuildingFaultIncidentViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getMyIncidents(request: MyIncidentsRequest): Observable<ResultWrapperOfMyIncidentsViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetMyIncidents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyIncidents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyIncidents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfMyIncidentsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfMyIncidentsViewModel>;
        }));
    }

    protected processGetMyIncidents(response: HttpResponseBase): Observable<ResultWrapperOfMyIncidentsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfMyIncidentsViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getOrderAccessIncident(id: string | undefined): Observable<OrderAccessIncidentViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetOrderAccessIncident?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderAccessIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderAccessIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderAccessIncidentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderAccessIncidentViewModel>;
        }));
    }

    protected processGetOrderAccessIncident(response: HttpResponseBase): Observable<OrderAccessIncidentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderAccessIncidentViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getFurnitureOrderIncident(id: string | undefined): Observable<FurnitureOrderIncidentViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetFurnitureOrderIncident?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFurnitureOrderIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFurnitureOrderIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FurnitureOrderIncidentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FurnitureOrderIncidentViewModel>;
        }));
    }

    protected processGetFurnitureOrderIncident(response: HttpResponseBase): Observable<FurnitureOrderIncidentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FurnitureOrderIncidentViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getRelocationIncident(id: string | undefined): Observable<RelocationViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetRelocationIncident?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelocationIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelocationIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelocationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelocationViewModel>;
        }));
    }

    protected processGetRelocationIncident(response: HttpResponseBase): Observable<RelocationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelocationViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getSpaceRequestIncident(id: string | undefined): Observable<SpaceRequestViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetSpaceRequestIncident?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpaceRequestIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpaceRequestIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpaceRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpaceRequestViewModel>;
        }));
    }

    protected processGetSpaceRequestIncident(response: HttpResponseBase): Observable<SpaceRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaceRequestViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAreaReturnIncident(id: string | undefined): Observable<AreaReturnViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetAreaReturnIncident?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaReturnIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaReturnIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaReturnViewModel>;
        }));
    }

    protected processGetAreaReturnIncident(response: HttpResponseBase): Observable<AreaReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AreaReturnViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getUserAdministrationIncident(id: string | undefined): Observable<UserAdministrationViewModel> {
        let url_ = this.baseUrl + "/api/Incident/GetUserAdministrationIncident?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAdministrationIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAdministrationIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAdministrationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAdministrationViewModel>;
        }));
    }

    protected processGetUserAdministrationIncident(response: HttpResponseBase): Observable<UserAdministrationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAdministrationViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentWithEmail(getIncidentDTO: GetIncidentDTO): Observable<FmIncident> {
        let url_ = this.baseUrl + "/api/Incident/GetIncidentWithEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getIncidentDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentWithEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentWithEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FmIncident>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FmIncident>;
        }));
    }

    protected processGetIncidentWithEmail(response: HttpResponseBase): Observable<FmIncident> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FmIncident;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentWithEmailAuthenticated(getIncidentDTO: GetIncidentDTO): Observable<FmIncident> {
        let url_ = this.baseUrl + "/api/Incident/GetIncidentWithEmailAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getIncidentDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentWithEmailAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentWithEmailAuthenticated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FmIncident>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FmIncident>;
        }));
    }

    protected processGetIncidentWithEmailAuthenticated(response: HttpResponseBase): Observable<FmIncident> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FmIncident;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getSubIncidents(id: string | undefined): Observable<SubIncidentViewModel[]> {
        let url_ = this.baseUrl + "/api/Incident/GetSubIncidents?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubIncidents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubIncidents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubIncidentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubIncidentViewModel[]>;
        }));
    }

    protected processGetSubIncidents(response: HttpResponseBase): Observable<SubIncidentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubIncidentViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAllIncidentClasses(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Incident/GetAllIncidentClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIncidentClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIncidentClasses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetAllIncidentClasses(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentClassesByRole(selectedRole: string | undefined): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Incident/GetIncidentClassesByRole?";
        if (selectedRole === null)
            throw new Error("The parameter 'selectedRole' cannot be null.");
        else if (selectedRole !== undefined)
            url_ += "selectedRole=" + encodeURIComponent("" + selectedRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentClassesByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentClassesByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetIncidentClassesByRole(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createSpaceRequest(request: RequestFileWrapperOfCreateSpaceRequestRequest): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/Incident/CreateSpaceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSpaceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSpaceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processCreateSpaceRequest(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createCostCenterAreaReturnTicket(req: RequestFileWrapperOfCostCenterAreaReturnTicketRequest): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/Incident/CreateCostCenterAreaReturnTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCostCenterAreaReturnTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCostCenterAreaReturnTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processCreateCostCenterAreaReturnTicket(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createSbuAreaReturnTicket(req: RequestFileWrapperOfSbuAreaReturnTicketRequest): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/Incident/CreateSbuAreaReturnTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSbuAreaReturnTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSbuAreaReturnTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processCreateSbuAreaReturnTicket(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentClassesForDL(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Incident/GetIncidentClassesForDL";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentClassesForDL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentClassesForDL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetIncidentClassesForDL(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    generateIncidentPdf(request: IncidentPdfRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Incident/GenerateIncidentPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateIncidentPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateIncidentPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateIncidentPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Incident/GetIncidentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetIncidentTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getIncidentClassesByIncidentType(incidentType: string | undefined): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Incident/GetIncidentClassesByIncidentType?";
        if (incidentType === null)
            throw new Error("The parameter 'incidentType' cannot be null.");
        else if (incidentType !== undefined)
            url_ += "incidentType=" + encodeURIComponent("" + incidentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentClassesByIncidentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentClassesByIncidentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetIncidentClassesByIncidentType(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getConfigurationTasksByIncidentClass(incidentClassId: string | undefined): Observable<ConfigurationTaskViewModel[]> {
        let url_ = this.baseUrl + "/api/Incident/GetConfigurationTasksByIncidentClass?";
        if (incidentClassId === null)
            throw new Error("The parameter 'incidentClassId' cannot be null.");
        else if (incidentClassId !== undefined)
            url_ += "incidentClassId=" + encodeURIComponent("" + incidentClassId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigurationTasksByIncidentClass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigurationTasksByIncidentClass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationTaskViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationTaskViewModel[]>;
        }));
    }

    protected processGetConfigurationTasksByIncidentClass(response: HttpResponseBase): Observable<ConfigurationTaskViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfigurationTaskViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface ILocationClient {
    searchArchobjForAutocomplete(searchterm: string | undefined, searchBuildings: boolean | undefined, searchOnlyWE: boolean | undefined): Observable<ResultWrapperOfLocationSearchEntryViewModel>;
    searchArchobjForAutoCompleteInexact(searchterm: string | undefined): Observable<ResultWrapperOfLocationSearchEntryViewModel>;
    getArchobjById(id: string | undefined): Observable<ArchObjHierarchyViewModel>;
    getArchobjOfCurrentUser(): Observable<ArchObjHierarchyViewModel>;
    postAddLocationInformation(model: ArchObjLocationInformationViewModel): Observable<void>;
    deleteLocationInformation(locationInformationId: string | undefined): Observable<void>;
    postUpdateLocationInformation(model: ArchObjLocationInformationViewModel): Observable<void>;
    getLocationInfo(id: string | undefined): Observable<ArchObjLocationInformationViewModel[]>;
    getLocationInfoCategories(): Observable<ArchObjInformationCategoryViewModel[]>;
    postSendLocationNotification(request: LocationNotificationRequest): Observable<void>;
    createFavorite(archobjId: string | undefined): Observable<void>;
    deleteFavorite(archobjId: string | undefined): Observable<void>;
    getFavorites(): Observable<LocationSearchEntryViewModel[]>;
    getBuildingMaintenanceInformation(archobjId: string | undefined): Observable<BuildingMaintenanceViewModel>;
    setBuildingFloorDescription(buildingFloorViewModel: BuildingFloorViewModel): Observable<void>;
    getBuildingMaintenanceRoomInformation(spaceID: string | undefined): Observable<BuildingRoomViewModel>;
    setBuildingMaintenanceRoomInformation(updateBuildingMaintenanceRoomRequest: UpdateBuildingMaintenanceRoomRequest): Observable<void>;
    addArchObjUtilHistory(request: CreateArchObjUtilHistoryRequest): Observable<void>;
    updateFloor(request: UpdateFloorRequest): Observable<void>;
    updateBuilding(request: UpdateBuildingRequest): Observable<void>;
    updateArchObjUtilHistory(updateArchObjUtilHistoryRequest: UpdateArchObjUtilHistoryRequest): Observable<void>;
    deleteArchObjUtilHistory(archObjUtilHistoryId: string | undefined): Observable<void>;
    getChangeReasons(): Observable<BaseSelectViewModel[]>;
    getWmvProducts(): Observable<BaseSelectViewModel[]>;
    getCalculationTypes(): Observable<BaseSelectViewModel[]>;
    getCentralInfos(): Observable<BaseSelectViewModel[]>;
    getWmvClusters(): Observable<BaseSelectViewModel[]>;
    getWmvClusterInfos(): Observable<BaseSelectViewModel[]>;
    getOfficeAreaTypes(): Observable<BaseSelectViewModel[]>;
    getBillingAreas(archobj: string | undefined): Observable<BaseSelectViewModel[]>;
    updateRoom(request: UpdateRoomRequest): Observable<void>;
    checkFrozenZone(): Observable<FrozenZoneViewModel>;
    getFrozenZones(): Observable<FrozenZoneViewModel[]>;
    getArchObjTree(id: string | undefined, level: number | null | undefined): Observable<ArchObjTreeViewModel>;
    getRoomInformation(spaceId: string | undefined): Observable<RoomViewModel>;
    massEditRooms(request: MassEditRoomRequest): Observable<void>;
}

@Injectable()
export class LocationClient implements ILocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchArchobjForAutocomplete(searchterm: string | undefined, searchBuildings: boolean | undefined, searchOnlyWE: boolean | undefined): Observable<ResultWrapperOfLocationSearchEntryViewModel> {
        let url_ = this.baseUrl + "/api/Location/SearchArchobjForAutocomplete?";
        if (searchterm === null)
            throw new Error("The parameter 'searchterm' cannot be null.");
        else if (searchterm !== undefined)
            url_ += "searchterm=" + encodeURIComponent("" + searchterm) + "&";
        if (searchBuildings === null)
            throw new Error("The parameter 'searchBuildings' cannot be null.");
        else if (searchBuildings !== undefined)
            url_ += "searchBuildings=" + encodeURIComponent("" + searchBuildings) + "&";
        if (searchOnlyWE === null)
            throw new Error("The parameter 'searchOnlyWE' cannot be null.");
        else if (searchOnlyWE !== undefined)
            url_ += "searchOnlyWE=" + encodeURIComponent("" + searchOnlyWE) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchArchobjForAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchArchobjForAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfLocationSearchEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfLocationSearchEntryViewModel>;
        }));
    }

    protected processSearchArchobjForAutocomplete(response: HttpResponseBase): Observable<ResultWrapperOfLocationSearchEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfLocationSearchEntryViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    searchArchobjForAutoCompleteInexact(searchterm: string | undefined): Observable<ResultWrapperOfLocationSearchEntryViewModel> {
        let url_ = this.baseUrl + "/api/Location/SearchArchobjForAutoCompleteInexact?";
        if (searchterm === null)
            throw new Error("The parameter 'searchterm' cannot be null.");
        else if (searchterm !== undefined)
            url_ += "searchterm=" + encodeURIComponent("" + searchterm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchArchobjForAutoCompleteInexact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchArchobjForAutoCompleteInexact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfLocationSearchEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfLocationSearchEntryViewModel>;
        }));
    }

    protected processSearchArchobjForAutoCompleteInexact(response: HttpResponseBase): Observable<ResultWrapperOfLocationSearchEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfLocationSearchEntryViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getArchobjById(id: string | undefined): Observable<ArchObjHierarchyViewModel> {
        let url_ = this.baseUrl + "/api/Location/GetArchobjById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchobjById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchobjById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchObjHierarchyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchObjHierarchyViewModel>;
        }));
    }

    protected processGetArchobjById(response: HttpResponseBase): Observable<ArchObjHierarchyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchObjHierarchyViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getArchobjOfCurrentUser(): Observable<ArchObjHierarchyViewModel> {
        let url_ = this.baseUrl + "/api/Location/GetArchobjOfCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchobjOfCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchobjOfCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchObjHierarchyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchObjHierarchyViewModel>;
        }));
    }

    protected processGetArchobjOfCurrentUser(response: HttpResponseBase): Observable<ArchObjHierarchyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchObjHierarchyViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchObjHierarchyViewModel;
            return _observableOf(result204);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    postAddLocationInformation(model: ArchObjLocationInformationViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/PostAddLocationInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAddLocationInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAddLocationInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostAddLocationInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 406) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result406: any = null;
            result406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteLocationInformation(locationInformationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/DeleteLocationInformation?";
        if (locationInformationId === null)
            throw new Error("The parameter 'locationInformationId' cannot be null.");
        else if (locationInformationId !== undefined)
            url_ += "locationInformationId=" + encodeURIComponent("" + locationInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLocationInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLocationInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLocationInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    postUpdateLocationInformation(model: ArchObjLocationInformationViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/PostUpdateLocationInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostUpdateLocationInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostUpdateLocationInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostUpdateLocationInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 406) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result406: any = null;
            result406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getLocationInfo(id: string | undefined): Observable<ArchObjLocationInformationViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetLocationInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchObjLocationInformationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchObjLocationInformationViewModel[]>;
        }));
    }

    protected processGetLocationInfo(response: HttpResponseBase): Observable<ArchObjLocationInformationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchObjLocationInformationViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getLocationInfoCategories(): Observable<ArchObjInformationCategoryViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetLocationInfoCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationInfoCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationInfoCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchObjInformationCategoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchObjInformationCategoryViewModel[]>;
        }));
    }

    protected processGetLocationInfoCategories(response: HttpResponseBase): Observable<ArchObjInformationCategoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchObjInformationCategoryViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    postSendLocationNotification(request: LocationNotificationRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/PostSendLocationNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSendLocationNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSendLocationNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostSendLocationNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createFavorite(archobjId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/CreateFavorite?";
        if (archobjId === null)
            throw new Error("The parameter 'archobjId' cannot be null.");
        else if (archobjId !== undefined)
            url_ += "archobjId=" + encodeURIComponent("" + archobjId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateFavorite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteFavorite(archobjId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/DeleteFavorite?";
        if (archobjId === null)
            throw new Error("The parameter 'archobjId' cannot be null.");
        else if (archobjId !== undefined)
            url_ += "archobjId=" + encodeURIComponent("" + archobjId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFavorite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getFavorites(): Observable<LocationSearchEntryViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetFavorites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationSearchEntryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationSearchEntryViewModel[]>;
        }));
    }

    protected processGetFavorites(response: HttpResponseBase): Observable<LocationSearchEntryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationSearchEntryViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getBuildingMaintenanceInformation(archobjId: string | undefined): Observable<BuildingMaintenanceViewModel> {
        let url_ = this.baseUrl + "/api/Location/GetBuildingMaintenanceInformation?";
        if (archobjId === null)
            throw new Error("The parameter 'archobjId' cannot be null.");
        else if (archobjId !== undefined)
            url_ += "archobjId=" + encodeURIComponent("" + archobjId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingMaintenanceInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingMaintenanceInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingMaintenanceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingMaintenanceViewModel>;
        }));
    }

    protected processGetBuildingMaintenanceInformation(response: HttpResponseBase): Observable<BuildingMaintenanceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingMaintenanceViewModel;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    setBuildingFloorDescription(buildingFloorViewModel: BuildingFloorViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/SetBuildingFloorDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(buildingFloorViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBuildingFloorDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBuildingFloorDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetBuildingFloorDescription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getBuildingMaintenanceRoomInformation(spaceID: string | undefined): Observable<BuildingRoomViewModel> {
        let url_ = this.baseUrl + "/api/Location/GetBuildingMaintenanceRoomInformation?";
        if (spaceID === null)
            throw new Error("The parameter 'spaceID' cannot be null.");
        else if (spaceID !== undefined)
            url_ += "spaceID=" + encodeURIComponent("" + spaceID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingMaintenanceRoomInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingMaintenanceRoomInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingRoomViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingRoomViewModel>;
        }));
    }

    protected processGetBuildingMaintenanceRoomInformation(response: HttpResponseBase): Observable<BuildingRoomViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingRoomViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingRoomViewModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    setBuildingMaintenanceRoomInformation(updateBuildingMaintenanceRoomRequest: UpdateBuildingMaintenanceRoomRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/SetBuildingMaintenanceRoomInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateBuildingMaintenanceRoomRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBuildingMaintenanceRoomInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBuildingMaintenanceRoomInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetBuildingMaintenanceRoomInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    addArchObjUtilHistory(request: CreateArchObjUtilHistoryRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/AddArchObjUtilHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddArchObjUtilHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddArchObjUtilHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddArchObjUtilHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateFloor(request: UpdateFloorRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/UpdateFloor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFloor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFloor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFloor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateBuilding(request: UpdateBuildingRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/UpdateBuilding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBuilding(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateArchObjUtilHistory(updateArchObjUtilHistoryRequest: UpdateArchObjUtilHistoryRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/UpdateArchObjUtilHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateArchObjUtilHistoryRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateArchObjUtilHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateArchObjUtilHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateArchObjUtilHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteArchObjUtilHistory(archObjUtilHistoryId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/DeleteArchObjUtilHistory?";
        if (archObjUtilHistoryId === null)
            throw new Error("The parameter 'archObjUtilHistoryId' cannot be null.");
        else if (archObjUtilHistoryId !== undefined)
            url_ += "archObjUtilHistoryId=" + encodeURIComponent("" + archObjUtilHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteArchObjUtilHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteArchObjUtilHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteArchObjUtilHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getChangeReasons(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetChangeReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangeReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangeReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetChangeReasons(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getWmvProducts(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetWmvProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmvProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmvProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetWmvProducts(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getCalculationTypes(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetCalculationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetCalculationTypes(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getCentralInfos(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetCentralInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCentralInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCentralInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetCentralInfos(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getWmvClusters(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetWmvClusters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmvClusters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmvClusters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetWmvClusters(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getWmvClusterInfos(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetWmvClusterInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmvClusterInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmvClusterInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetWmvClusterInfos(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getOfficeAreaTypes(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetOfficeAreaTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeAreaTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeAreaTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetOfficeAreaTypes(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getBillingAreas(archobj: string | undefined): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetBillingAreas?";
        if (archobj === null)
            throw new Error("The parameter 'archobj' cannot be null.");
        else if (archobj !== undefined)
            url_ += "archobj=" + encodeURIComponent("" + archobj) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetBillingAreas(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateRoom(request: UpdateRoomRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/UpdateRoom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRoom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    checkFrozenZone(): Observable<FrozenZoneViewModel> {
        let url_ = this.baseUrl + "/api/Location/CheckFrozenZone";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckFrozenZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckFrozenZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrozenZoneViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrozenZoneViewModel>;
        }));
    }

    protected processCheckFrozenZone(response: HttpResponseBase): Observable<FrozenZoneViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrozenZoneViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrozenZoneViewModel;
            return _observableOf(result204);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getFrozenZones(): Observable<FrozenZoneViewModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetFrozenZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFrozenZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFrozenZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrozenZoneViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrozenZoneViewModel[]>;
        }));
    }

    protected processGetFrozenZones(response: HttpResponseBase): Observable<FrozenZoneViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrozenZoneViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getArchObjTree(id: string | undefined, level: number | null | undefined): Observable<ArchObjTreeViewModel> {
        let url_ = this.baseUrl + "/api/Location/GetArchObjTree?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (level !== undefined && level !== null)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchObjTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchObjTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchObjTreeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchObjTreeViewModel>;
        }));
    }

    protected processGetArchObjTree(response: HttpResponseBase): Observable<ArchObjTreeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchObjTreeViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getRoomInformation(spaceId: string | undefined): Observable<RoomViewModel> {
        let url_ = this.baseUrl + "/api/Location/GetRoomInformation?";
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomViewModel>;
        }));
    }

    protected processGetRoomInformation(response: HttpResponseBase): Observable<RoomViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoomViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    massEditRooms(request: MassEditRoomRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Location/MassEditRooms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMassEditRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMassEditRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMassEditRooms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IMaintenanceClient {
    get(): Observable<string>;
}

@Injectable()
export class MaintenanceClient implements IMaintenanceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<string> {
        let url_ = this.baseUrl + "/api/Maintenance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOptionSetClient {
    getOptionSetAnonymous(type: EnumType | undefined): Observable<SysEnum[]>;
    getOptionSetByString(type: string | undefined): Observable<SysEnum[]>;
    getHolidayList(): Observable<string[]>;
}

@Injectable()
export class OptionSetClient implements IOptionSetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOptionSetAnonymous(type: EnumType | undefined): Observable<SysEnum[]> {
        let url_ = this.baseUrl + "/api/OptionSet/GetOptionSetAnonymous?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOptionSetAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptionSetAnonymous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SysEnum[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SysEnum[]>;
        }));
    }

    protected processGetOptionSetAnonymous(response: HttpResponseBase): Observable<SysEnum[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SysEnum[];
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getOptionSetByString(type: string | undefined): Observable<SysEnum[]> {
        let url_ = this.baseUrl + "/api/OptionSet/GetOptionSetByString?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOptionSetByString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptionSetByString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SysEnum[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SysEnum[]>;
        }));
    }

    protected processGetOptionSetByString(response: HttpResponseBase): Observable<SysEnum[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SysEnum[];
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getHolidayList(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/OptionSet/GetHolidayList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidayList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetHolidayList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IUserClient {
    getAll(): Observable<UserViewModel[]>;
    get(userId: string): Observable<UserViewModel>;
    getOwnUser(): Observable<UserViewModel>;
    activate(userId: string): Observable<void>;
    deactivate(userId: string): Observable<void>;
    getUserProfile(): Observable<OmContact>;
    updateUserProfile(updateUserProfileDTO: UpdateUserProfileDTO): Observable<void>;
    getRentalContractForUser(): Observable<RentalContractViewModel>;
    getOrganisationIdByContactId(id: string): Observable<RentalContractViewModel>;
    getSystemUser(email: string | undefined): Observable<OmContact>;
    getCostCenters(): Observable<boolean>;
    checkIfGsusUser(): Observable<boolean>;
}

@Injectable()
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<UserViewModel[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserViewModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(userId: string): Observable<UserViewModel> {
        let url_ = this.baseUrl + "/api/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOwnUser(): Observable<UserViewModel> {
        let url_ = this.baseUrl + "/api/User/GetOwnUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwnUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwnUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel>;
        }));
    }

    protected processGetOwnUser(response: HttpResponseBase): Observable<UserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activate(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/User/{userId}/activate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivate(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/User/{userId}/deactivate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserProfile(): Observable<OmContact> {
        let url_ = this.baseUrl + "/api/User/GetUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OmContact>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OmContact>;
        }));
    }

    protected processGetUserProfile(response: HttpResponseBase): Observable<OmContact> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OmContact;
            return _observableOf(result200);
            }));
        } else if (status === 424) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateUserProfile(updateUserProfileDTO: UpdateUserProfileDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/User/UpdateUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateUserProfileDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 424) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getRentalContractForUser(): Observable<RentalContractViewModel> {
        let url_ = this.baseUrl + "/api/User/GetRentalContractForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRentalContractForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRentalContractForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RentalContractViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RentalContractViewModel>;
        }));
    }

    protected processGetRentalContractForUser(response: HttpResponseBase): Observable<RentalContractViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentalContractViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 424) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getOrganisationIdByContactId(id: string): Observable<RentalContractViewModel> {
        let url_ = this.baseUrl + "/api/User/GetOrganisationIdByContactId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisationIdByContactId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisationIdByContactId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RentalContractViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RentalContractViewModel>;
        }));
    }

    protected processGetOrganisationIdByContactId(response: HttpResponseBase): Observable<RentalContractViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentalContractViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 424) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getSystemUser(email: string | undefined): Observable<OmContact> {
        let url_ = this.baseUrl + "/api/User/GetSystemUser?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OmContact>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OmContact>;
        }));
    }

    protected processGetSystemUser(response: HttpResponseBase): Observable<OmContact> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OmContact;
            return _observableOf(result200);
            }));
        } else if (status === 424) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getCostCenters(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/GetCostCenters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostCenters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetCostCenters(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    checkIfGsusUser(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/CheckIfGsusUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfGsusUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfGsusUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfGsusUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IAccessOrdererClient {
    createAccessOrderer(request: CreateAccessOrdererRequest): Observable<number>;
    createAccessOrderers(request: CreateAccessOrderersRequest): Observable<number[]>;
    deleteAccessOrderer(id: number | undefined): Observable<void>;
    extendAccessOrderer(id: number | undefined): Observable<number>;
    getAccessOrderers(request: GetAccessOrderersRequest): Observable<AccessOrdererTableEntryViewModel[]>;
    getAccessOrderersHistory(request: BaseSearchOptions): Observable<ResultWrapperOfAccessOrdererHistoryTableEntryViewModel>;
    searchManagerCostCenters(searchTerm: string | null | undefined): Observable<CostCenterSearchResultDto[]>;
    searchCostCenterEmployees(searchTerm: string | null | undefined): Observable<EmploymentSearchResultDto[]>;
    getAssignableCostCentersByEmployeeId(id: string | undefined): Observable<BaseSelectViewModel[]>;
}

@Injectable()
export class AccessOrdererClient implements IAccessOrdererClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createAccessOrderer(request: CreateAccessOrdererRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/AccessOrderer/CreateAccessOrderer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAccessOrderer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAccessOrderer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAccessOrderer(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createAccessOrderers(request: CreateAccessOrderersRequest): Observable<number[]> {
        let url_ = this.baseUrl + "/api/AccessOrderer/CreateAccessOrderers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAccessOrderers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAccessOrderers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processCreateAccessOrderers(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteAccessOrderer(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AccessOrderer/DeleteAccessOrderer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccessOrderer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccessOrderer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAccessOrderer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    extendAccessOrderer(id: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/AccessOrderer/ExtendAccessOrderer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendAccessOrderer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendAccessOrderer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processExtendAccessOrderer(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAccessOrderers(request: GetAccessOrderersRequest): Observable<AccessOrdererTableEntryViewModel[]> {
        let url_ = this.baseUrl + "/api/AccessOrderer/GetAccessOrderers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessOrderers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessOrderers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessOrdererTableEntryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessOrdererTableEntryViewModel[]>;
        }));
    }

    protected processGetAccessOrderers(response: HttpResponseBase): Observable<AccessOrdererTableEntryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessOrdererTableEntryViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAccessOrderersHistory(request: BaseSearchOptions): Observable<ResultWrapperOfAccessOrdererHistoryTableEntryViewModel> {
        let url_ = this.baseUrl + "/api/AccessOrderer/GetAccessOrderersHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessOrderersHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessOrderersHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfAccessOrdererHistoryTableEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfAccessOrdererHistoryTableEntryViewModel>;
        }));
    }

    protected processGetAccessOrderersHistory(response: HttpResponseBase): Observable<ResultWrapperOfAccessOrdererHistoryTableEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfAccessOrdererHistoryTableEntryViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    searchManagerCostCenters(searchTerm: string | null | undefined): Observable<CostCenterSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/AccessOrderer/SearchManagerCostCenters?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchManagerCostCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchManagerCostCenters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterSearchResultDto[]>;
        }));
    }

    protected processSearchManagerCostCenters(response: HttpResponseBase): Observable<CostCenterSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CostCenterSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    searchCostCenterEmployees(searchTerm: string | null | undefined): Observable<EmploymentSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/AccessOrderer/SearchCostCenterEmployees?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCostCenterEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCostCenterEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentSearchResultDto[]>;
        }));
    }

    protected processSearchCostCenterEmployees(response: HttpResponseBase): Observable<EmploymentSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAssignableCostCentersByEmployeeId(id: string | undefined): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/AccessOrderer/GetAssignableCostCentersByEmployeeId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignableCostCentersByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignableCostCentersByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetAssignableCostCentersByEmployeeId(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IApprovalClient {
    getApprovals(request: ApprovalSearchOptions): Observable<ResultWrapperOfApprovalViewModel>;
    answerApproval(request: AnswerApproval): Observable<void>;
    getApprovalDetails(id: string | undefined): Observable<ApprovalDetailViewModel>;
    getTicketApprovals(searchOptions: ApprovalSearchOptions): Observable<ResultWrapperOfApprovalHistoryViewModel>;
    getApprovalStatusOptions(): Observable<BaseSelectViewModel[]>;
}

@Injectable()
export class ApprovalClient implements IApprovalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getApprovals(request: ApprovalSearchOptions): Observable<ResultWrapperOfApprovalViewModel> {
        let url_ = this.baseUrl + "/api/Approval/GetApprovals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfApprovalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfApprovalViewModel>;
        }));
    }

    protected processGetApprovals(response: HttpResponseBase): Observable<ResultWrapperOfApprovalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfApprovalViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    answerApproval(request: AnswerApproval): Observable<void> {
        let url_ = this.baseUrl + "/api/Approval/AnswerApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnswerApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnswerApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAnswerApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getApprovalDetails(id: string | undefined): Observable<ApprovalDetailViewModel> {
        let url_ = this.baseUrl + "/api/Approval/GetApprovalDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovalDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovalDetailViewModel>;
        }));
    }

    protected processGetApprovalDetails(response: HttpResponseBase): Observable<ApprovalDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalDetailViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getTicketApprovals(searchOptions: ApprovalSearchOptions): Observable<ResultWrapperOfApprovalHistoryViewModel> {
        let url_ = this.baseUrl + "/api/Approval/GetTicketApprovals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketApprovals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketApprovals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfApprovalHistoryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfApprovalHistoryViewModel>;
        }));
    }

    protected processGetTicketApprovals(response: HttpResponseBase): Observable<ResultWrapperOfApprovalHistoryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfApprovalHistoryViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getApprovalStatusOptions(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Approval/GetApprovalStatusOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalStatusOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalStatusOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetApprovalStatusOptions(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IAuthClient {
    checkSecurityRoleByIncidentId(incidentId: string | undefined): Observable<boolean>;
    checkSecurityRoleByTaskId(taskid: string | undefined): Observable<boolean>;
    getDtagRoleSelectionForCurrentUser(): Observable<BaseSelectViewModel[]>;
}

@Injectable()
export class AuthClient implements IAuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    checkSecurityRoleByIncidentId(incidentId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Auth/CheckSecurityRoleByIncidentId?";
        if (incidentId === null)
            throw new Error("The parameter 'incidentId' cannot be null.");
        else if (incidentId !== undefined)
            url_ += "incidentId=" + encodeURIComponent("" + incidentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSecurityRoleByIncidentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSecurityRoleByIncidentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckSecurityRoleByIncidentId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    checkSecurityRoleByTaskId(taskid: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Auth/CheckSecurityRoleByTaskId?";
        if (taskid === null)
            throw new Error("The parameter 'taskid' cannot be null.");
        else if (taskid !== undefined)
            url_ += "taskid=" + encodeURIComponent("" + taskid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSecurityRoleByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSecurityRoleByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckSecurityRoleByTaskId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getDtagRoleSelectionForCurrentUser(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Auth/GetDtagRoleSelectionForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDtagRoleSelectionForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDtagRoleSelectionForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetDtagRoleSelectionForCurrentUser(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IBillingAreaClient {
    getBillingAreaNavigation(archobj: string | undefined): Observable<BillingAreaNavigationViewmodel[]>;
    getBillingAreaUsageTable(billingAreaId: string | undefined): Observable<UsageTableViewModelOfBillingAreaUsageShareViewModel>;
    getStrategicBusinessUnitUsageTable(billingAreaId: string | undefined): Observable<UsageTableViewModelOfStrategicBusinessUnitUsageShareViewModel>;
    createStrategicBusinessUnitUsage(request: CreateStrategicBusinessUnitUsageRequest): Observable<void>;
    updateStrategicBusinessUnitUsage(request: UpdateStrategicBusinessUnitUsageRequest): Observable<void>;
    getAvailableWorkspaces(request: GetAvailableWorkspacesRequest): Observable<number>;
    getStrategicBusinessUnitIds(): Observable<BaseSelectViewModel[]>;
    getBillingAreaUsageDetails(id: string | undefined): Observable<BillingAreaUsageDetailsViewmodel>;
    getBillingAreaSbuUsageDetails(id: string | undefined): Observable<BillingAreaSbuUsageDetailsViewmodel>;
    getBillingAreaDetails(id: string | undefined): Observable<BillingAreaDetailsViewmodel>;
    createBillingArea(request: CreateBillingAreaRequest): Observable<void>;
    updateBillingArea(request: UpdateBillingAreaRequest): Observable<void>;
    deleteBillingArea(request: DeleteBillingAreaRequest): Observable<void>;
    getAreaReturnSbuUsageTable(billingAreaId: string | undefined): Observable<AreaReturnSbuUsageTableViewModel[]>;
    getSbuUsagesForChange(billingAreaId: string | undefined): Observable<AreaReturnSbuUsageTableViewModel[]>;
    changeCostCenterOfUsages(request: ChangeUsageCostCenterRequest): Observable<void>;
}

@Injectable()
export class BillingAreaClient implements IBillingAreaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getBillingAreaNavigation(archobj: string | undefined): Observable<BillingAreaNavigationViewmodel[]> {
        let url_ = this.baseUrl + "/api/BillingArea/GetBillingAreaNavigation?";
        if (archobj === null)
            throw new Error("The parameter 'archobj' cannot be null.");
        else if (archobj !== undefined)
            url_ += "archobj=" + encodeURIComponent("" + archobj) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingAreaNavigation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingAreaNavigation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingAreaNavigationViewmodel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingAreaNavigationViewmodel[]>;
        }));
    }

    protected processGetBillingAreaNavigation(response: HttpResponseBase): Observable<BillingAreaNavigationViewmodel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingAreaNavigationViewmodel[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getBillingAreaUsageTable(billingAreaId: string | undefined): Observable<UsageTableViewModelOfBillingAreaUsageShareViewModel> {
        let url_ = this.baseUrl + "/api/BillingArea/GetBillingAreaUsageTable?";
        if (billingAreaId === null)
            throw new Error("The parameter 'billingAreaId' cannot be null.");
        else if (billingAreaId !== undefined)
            url_ += "billingAreaId=" + encodeURIComponent("" + billingAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingAreaUsageTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingAreaUsageTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsageTableViewModelOfBillingAreaUsageShareViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsageTableViewModelOfBillingAreaUsageShareViewModel>;
        }));
    }

    protected processGetBillingAreaUsageTable(response: HttpResponseBase): Observable<UsageTableViewModelOfBillingAreaUsageShareViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsageTableViewModelOfBillingAreaUsageShareViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getStrategicBusinessUnitUsageTable(billingAreaId: string | undefined): Observable<UsageTableViewModelOfStrategicBusinessUnitUsageShareViewModel> {
        let url_ = this.baseUrl + "/api/BillingArea/GetStrategicBusinessUnitUsageTable?";
        if (billingAreaId === null)
            throw new Error("The parameter 'billingAreaId' cannot be null.");
        else if (billingAreaId !== undefined)
            url_ += "billingAreaId=" + encodeURIComponent("" + billingAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStrategicBusinessUnitUsageTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrategicBusinessUnitUsageTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsageTableViewModelOfStrategicBusinessUnitUsageShareViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsageTableViewModelOfStrategicBusinessUnitUsageShareViewModel>;
        }));
    }

    protected processGetStrategicBusinessUnitUsageTable(response: HttpResponseBase): Observable<UsageTableViewModelOfStrategicBusinessUnitUsageShareViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsageTableViewModelOfStrategicBusinessUnitUsageShareViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createStrategicBusinessUnitUsage(request: CreateStrategicBusinessUnitUsageRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/BillingArea/CreateStrategicBusinessUnitUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStrategicBusinessUnitUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStrategicBusinessUnitUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStrategicBusinessUnitUsage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateStrategicBusinessUnitUsage(request: UpdateStrategicBusinessUnitUsageRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/BillingArea/UpdateStrategicBusinessUnitUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStrategicBusinessUnitUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStrategicBusinessUnitUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStrategicBusinessUnitUsage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAvailableWorkspaces(request: GetAvailableWorkspacesRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/BillingArea/GetAvailableWorkspaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableWorkspaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableWorkspaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAvailableWorkspaces(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getStrategicBusinessUnitIds(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/BillingArea/GetStrategicBusinessUnitIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStrategicBusinessUnitIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrategicBusinessUnitIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetStrategicBusinessUnitIds(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getBillingAreaUsageDetails(id: string | undefined): Observable<BillingAreaUsageDetailsViewmodel> {
        let url_ = this.baseUrl + "/api/BillingArea/GetBillingAreaUsageDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingAreaUsageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingAreaUsageDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingAreaUsageDetailsViewmodel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingAreaUsageDetailsViewmodel>;
        }));
    }

    protected processGetBillingAreaUsageDetails(response: HttpResponseBase): Observable<BillingAreaUsageDetailsViewmodel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingAreaUsageDetailsViewmodel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getBillingAreaSbuUsageDetails(id: string | undefined): Observable<BillingAreaSbuUsageDetailsViewmodel> {
        let url_ = this.baseUrl + "/api/BillingArea/GetBillingAreaSbuUsageDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingAreaSbuUsageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingAreaSbuUsageDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingAreaSbuUsageDetailsViewmodel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingAreaSbuUsageDetailsViewmodel>;
        }));
    }

    protected processGetBillingAreaSbuUsageDetails(response: HttpResponseBase): Observable<BillingAreaSbuUsageDetailsViewmodel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingAreaSbuUsageDetailsViewmodel;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getBillingAreaDetails(id: string | undefined): Observable<BillingAreaDetailsViewmodel> {
        let url_ = this.baseUrl + "/api/BillingArea/GetBillingAreaDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingAreaDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingAreaDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingAreaDetailsViewmodel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingAreaDetailsViewmodel>;
        }));
    }

    protected processGetBillingAreaDetails(response: HttpResponseBase): Observable<BillingAreaDetailsViewmodel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingAreaDetailsViewmodel;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createBillingArea(request: CreateBillingAreaRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/BillingArea/CreateBillingArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBillingArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillingArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBillingArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateBillingArea(request: UpdateBillingAreaRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/BillingArea/UpdateBillingArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBillingArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillingArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBillingArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteBillingArea(request: DeleteBillingAreaRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/BillingArea/DeleteBillingArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBillingArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBillingArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBillingArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAreaReturnSbuUsageTable(billingAreaId: string | undefined): Observable<AreaReturnSbuUsageTableViewModel[]> {
        let url_ = this.baseUrl + "/api/BillingArea/GetAreaReturnSbuUsageTable?";
        if (billingAreaId === null)
            throw new Error("The parameter 'billingAreaId' cannot be null.");
        else if (billingAreaId !== undefined)
            url_ += "billingAreaId=" + encodeURIComponent("" + billingAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaReturnSbuUsageTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaReturnSbuUsageTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaReturnSbuUsageTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaReturnSbuUsageTableViewModel[]>;
        }));
    }

    protected processGetAreaReturnSbuUsageTable(response: HttpResponseBase): Observable<AreaReturnSbuUsageTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AreaReturnSbuUsageTableViewModel[];
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getSbuUsagesForChange(billingAreaId: string | undefined): Observable<AreaReturnSbuUsageTableViewModel[]> {
        let url_ = this.baseUrl + "/api/BillingArea/GetSbuUsagesForChange?";
        if (billingAreaId === null)
            throw new Error("The parameter 'billingAreaId' cannot be null.");
        else if (billingAreaId !== undefined)
            url_ += "billingAreaId=" + encodeURIComponent("" + billingAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSbuUsagesForChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSbuUsagesForChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaReturnSbuUsageTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaReturnSbuUsageTableViewModel[]>;
        }));
    }

    protected processGetSbuUsagesForChange(response: HttpResponseBase): Observable<AreaReturnSbuUsageTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AreaReturnSbuUsageTableViewModel[];
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    changeCostCenterOfUsages(request: ChangeUsageCostCenterRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/BillingArea/ChangeCostCenterOfUsages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCostCenterOfUsages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCostCenterOfUsages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeCostCenterOfUsages(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IContactClient {
    retrieve(contactId: string): Observable<ContactViewModel>;
    search(searchTerm: string | undefined, maxResults: number | undefined): Observable<ContactViewModel[]>;
}

@Injectable()
export class ContactClient implements IContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    retrieve(contactId: string): Observable<ContactViewModel> {
        let url_ = this.baseUrl + "/api/Contact/{contactId}";
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactViewModel>;
        }));
    }

    protected processRetrieve(response: HttpResponseBase): Observable<ContactViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(searchTerm: string | undefined, maxResults: number | undefined): Observable<ContactViewModel[]> {
        let url_ = this.baseUrl + "/api/Contact?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (maxResults === null)
            throw new Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactViewModel[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ContactViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICostCenterClient {
    getCostCenters(): Observable<CostCenterViewModel[]>;
    getCostCenterForUser(): Observable<CostCenterSearchResultDto>;
    searchCostCentersForAutoComplete(searchterm: string | null | undefined, searchExact: boolean | undefined, sbuId: string | null | undefined): Observable<CostCenterSearchResultDto[]>;
    getCostCenterUsageTable(ids: string[]): Observable<UsageTableViewModelOfCostCenterUsageShareViewModel>;
    getCostCenterUsageDetails(id: string | undefined): Observable<CostCenterUsageDetailsViewModel>;
    createRoomUsage(req: UpdateCostCenterUsageRequest): Observable<boolean>;
    deleteRoomUsage(req: DeleteCostCenterUsageRequest): Observable<boolean>;
    updateRoomUsage(req: UpdateCostCenterUsageRequest): Observable<boolean>;
    createWorkspaceUsage(req: UpdateCostCenterUsageRequest): Observable<boolean>;
    updateWorkspaceUsage(req: UpdateCostCenterUsageRequest): Observable<boolean>;
    checkWorkspaceAvailability(req: CheckWorkspaceAvailabilityRequest): Observable<boolean>;
    getAvailableRoomArea(req: GetAvailableRoomAreaRequest): Observable<number>;
    deleteWorkspaceUsage(req: DeleteWorkspaceUsageRequest): Observable<FileResponse>;
    getUsagesForLocationAndCostcenter(locationId: string | undefined, costcenterId: string | undefined): Observable<AreaManagementUsageTableViewModel[]>;
    getCostcenterUsagesForChange(locationId: string | undefined, costcenterId: string | null | undefined): Observable<AreaManagementUsageTableViewModel[]>;
    changeCostCenterOfUsages(request: ChangeUsageCostCenterRequest): Observable<void>;
}

@Injectable()
export class CostCenterClient implements ICostCenterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCostCenters(): Observable<CostCenterViewModel[]> {
        let url_ = this.baseUrl + "/api/CostCenter/GetCostCenters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostCenters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterViewModel[]>;
        }));
    }

    protected processGetCostCenters(response: HttpResponseBase): Observable<CostCenterViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CostCenterViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getCostCenterForUser(): Observable<CostCenterSearchResultDto> {
        let url_ = this.baseUrl + "/api/CostCenter/GetCostCenterForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostCenterForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostCenterForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterSearchResultDto>;
        }));
    }

    protected processGetCostCenterForUser(response: HttpResponseBase): Observable<CostCenterSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CostCenterSearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CostCenterSearchResultDto;
            return _observableOf(result204);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    searchCostCentersForAutoComplete(searchterm: string | null | undefined, searchExact: boolean | undefined, sbuId: string | null | undefined): Observable<CostCenterSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/CostCenter/SearchCostCentersForAutoComplete?";
        if (searchterm !== undefined && searchterm !== null)
            url_ += "searchterm=" + encodeURIComponent("" + searchterm) + "&";
        if (searchExact === null)
            throw new Error("The parameter 'searchExact' cannot be null.");
        else if (searchExact !== undefined)
            url_ += "searchExact=" + encodeURIComponent("" + searchExact) + "&";
        if (sbuId !== undefined && sbuId !== null)
            url_ += "sbuId=" + encodeURIComponent("" + sbuId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCostCentersForAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCostCentersForAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterSearchResultDto[]>;
        }));
    }

    protected processSearchCostCentersForAutoComplete(response: HttpResponseBase): Observable<CostCenterSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CostCenterSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getCostCenterUsageTable(ids: string[]): Observable<UsageTableViewModelOfCostCenterUsageShareViewModel> {
        let url_ = this.baseUrl + "/api/CostCenter/GetCostCenterUsageTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostCenterUsageTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostCenterUsageTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsageTableViewModelOfCostCenterUsageShareViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsageTableViewModelOfCostCenterUsageShareViewModel>;
        }));
    }

    protected processGetCostCenterUsageTable(response: HttpResponseBase): Observable<UsageTableViewModelOfCostCenterUsageShareViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsageTableViewModelOfCostCenterUsageShareViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getCostCenterUsageDetails(id: string | undefined): Observable<CostCenterUsageDetailsViewModel> {
        let url_ = this.baseUrl + "/api/CostCenter/GetCostCenterUsageDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostCenterUsageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostCenterUsageDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterUsageDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterUsageDetailsViewModel>;
        }));
    }

    protected processGetCostCenterUsageDetails(response: HttpResponseBase): Observable<CostCenterUsageDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CostCenterUsageDetailsViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createRoomUsage(req: UpdateCostCenterUsageRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/CostCenter/CreateRoomUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRoomUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRoomUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateRoomUsage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteRoomUsage(req: DeleteCostCenterUsageRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/CostCenter/DeleteRoomUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRoomUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRoomUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteRoomUsage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateRoomUsage(req: UpdateCostCenterUsageRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/CostCenter/UpdateRoomUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoomUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoomUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateRoomUsage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createWorkspaceUsage(req: UpdateCostCenterUsageRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/CostCenter/CreateWorkspaceUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkspaceUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkspaceUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateWorkspaceUsage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateWorkspaceUsage(req: UpdateCostCenterUsageRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/CostCenter/UpdateWorkspaceUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkspaceUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkspaceUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWorkspaceUsage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    checkWorkspaceAvailability(req: CheckWorkspaceAvailabilityRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/CostCenter/CheckWorkspaceAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckWorkspaceAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckWorkspaceAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckWorkspaceAvailability(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAvailableRoomArea(req: GetAvailableRoomAreaRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/CostCenter/GetAvailableRoomArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableRoomArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableRoomArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAvailableRoomArea(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteWorkspaceUsage(req: DeleteWorkspaceUsageRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CostCenter/DeleteWorkspaceUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkspaceUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkspaceUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteWorkspaceUsage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getUsagesForLocationAndCostcenter(locationId: string | undefined, costcenterId: string | undefined): Observable<AreaManagementUsageTableViewModel[]> {
        let url_ = this.baseUrl + "/api/CostCenter/GetUsagesForLocationAndCostcenter?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (costcenterId === null)
            throw new Error("The parameter 'costcenterId' cannot be null.");
        else if (costcenterId !== undefined)
            url_ += "costcenterId=" + encodeURIComponent("" + costcenterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsagesForLocationAndCostcenter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsagesForLocationAndCostcenter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaManagementUsageTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaManagementUsageTableViewModel[]>;
        }));
    }

    protected processGetUsagesForLocationAndCostcenter(response: HttpResponseBase): Observable<AreaManagementUsageTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AreaManagementUsageTableViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getCostcenterUsagesForChange(locationId: string | undefined, costcenterId: string | null | undefined): Observable<AreaManagementUsageTableViewModel[]> {
        let url_ = this.baseUrl + "/api/CostCenter/GetCostcenterUsagesForChange?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (costcenterId !== undefined && costcenterId !== null)
            url_ += "costcenterId=" + encodeURIComponent("" + costcenterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostcenterUsagesForChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostcenterUsagesForChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaManagementUsageTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaManagementUsageTableViewModel[]>;
        }));
    }

    protected processGetCostcenterUsagesForChange(response: HttpResponseBase): Observable<AreaManagementUsageTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AreaManagementUsageTableViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    changeCostCenterOfUsages(request: ChangeUsageCostCenterRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/CostCenter/ChangeCostCenterOfUsages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCostCenterOfUsages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCostCenterOfUsages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeCostCenterOfUsages(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IDataMaintenanceClient {
    correctAreaValues(request: ChangeRoomsRequest): Observable<void>;
    correctOverbookedRooms(request: ChangeRoomsRequest): Observable<void>;
    getOverbookedRooms(): Observable<OverbookedRoomsViewModel[]>;
    getClearingIndicators(): Observable<ClearingIndicatorViewModel[]>;
    removeClearingIndicators(request: ChangeRoomsRequest): Observable<void>;
    getAreaValues(request: GetAreaValuesRequest): Observable<ResultWrapperOfAreaValueViewModel>;
    getInactiveRooms(): Observable<InactiveRoomsViewModel[]>;
    updateInactiveRooms(request: ChangeRoomsRequest): Observable<void>;
    getBuildingManagers(id: string | undefined): Observable<BuildingManagersViewModel[]>;
    getUsageChangeHistory(request: GetUsageChangeHistoryRequest): Observable<ResultWrapperOfUsageChangeHistoryViewModel>;
}

@Injectable()
export class DataMaintenanceClient implements IDataMaintenanceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    correctAreaValues(request: ChangeRoomsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/DataMaintenance/correctAreaValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCorrectAreaValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCorrectAreaValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCorrectAreaValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    correctOverbookedRooms(request: ChangeRoomsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/DataMaintenance/overbooked";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCorrectOverbookedRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCorrectOverbookedRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCorrectOverbookedRooms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOverbookedRooms(): Observable<OverbookedRoomsViewModel[]> {
        let url_ = this.baseUrl + "/api/DataMaintenance/overbooked";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverbookedRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverbookedRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OverbookedRoomsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OverbookedRoomsViewModel[]>;
        }));
    }

    protected processGetOverbookedRooms(response: HttpResponseBase): Observable<OverbookedRoomsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverbookedRoomsViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClearingIndicators(): Observable<ClearingIndicatorViewModel[]> {
        let url_ = this.baseUrl + "/api/DataMaintenance/clearingIndicators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClearingIndicators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClearingIndicators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClearingIndicatorViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClearingIndicatorViewModel[]>;
        }));
    }

    protected processGetClearingIndicators(response: HttpResponseBase): Observable<ClearingIndicatorViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClearingIndicatorViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeClearingIndicators(request: ChangeRoomsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/DataMaintenance/clearingIndicators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveClearingIndicators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveClearingIndicators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveClearingIndicators(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAreaValues(request: GetAreaValuesRequest): Observable<ResultWrapperOfAreaValueViewModel> {
        let url_ = this.baseUrl + "/api/DataMaintenance/areaValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfAreaValueViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfAreaValueViewModel>;
        }));
    }

    protected processGetAreaValues(response: HttpResponseBase): Observable<ResultWrapperOfAreaValueViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfAreaValueViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInactiveRooms(): Observable<InactiveRoomsViewModel[]> {
        let url_ = this.baseUrl + "/api/DataMaintenance/inactive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInactiveRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInactiveRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveRoomsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveRoomsViewModel[]>;
        }));
    }

    protected processGetInactiveRooms(response: HttpResponseBase): Observable<InactiveRoomsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InactiveRoomsViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInactiveRooms(request: ChangeRoomsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/DataMaintenance/inactive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInactiveRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInactiveRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInactiveRooms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBuildingManagers(id: string | undefined): Observable<BuildingManagersViewModel[]> {
        let url_ = this.baseUrl + "/api/DataMaintenance/buildingManagers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingManagers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingManagers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingManagersViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingManagersViewModel[]>;
        }));
    }

    protected processGetBuildingManagers(response: HttpResponseBase): Observable<BuildingManagersViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingManagersViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsageChangeHistory(request: GetUsageChangeHistoryRequest): Observable<ResultWrapperOfUsageChangeHistoryViewModel> {
        let url_ = this.baseUrl + "/api/DataMaintenance/usageChangeHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsageChangeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsageChangeHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfUsageChangeHistoryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfUsageChangeHistoryViewModel>;
        }));
    }

    protected processGetUsageChangeHistory(response: HttpResponseBase): Observable<ResultWrapperOfUsageChangeHistoryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfUsageChangeHistoryViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmploymentClient {
    searchEmployee(searchQuery: string | undefined): Observable<ResultWrapperOfEmploymentSearchResultDto>;
    getEmployeeByEmail(email: string | undefined): Observable<EmploymentSearchResultDto>;
}

@Injectable()
export class EmploymentClient implements IEmploymentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchEmployee(searchQuery: string | undefined): Observable<ResultWrapperOfEmploymentSearchResultDto> {
        let url_ = this.baseUrl + "/api/Employment/SearchEmployee?";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfEmploymentSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfEmploymentSearchResultDto>;
        }));
    }

    protected processSearchEmployee(response: HttpResponseBase): Observable<ResultWrapperOfEmploymentSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfEmploymentSearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getEmployeeByEmail(email: string | undefined): Observable<EmploymentSearchResultDto> {
        let url_ = this.baseUrl + "/api/Employment/GetEmployeeByEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentSearchResultDto>;
        }));
    }

    protected processGetEmployeeByEmail(response: HttpResponseBase): Observable<EmploymentSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentSearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IOrganisationClient {
    get(): Observable<OrganisationViewModel[]>;
}

@Injectable()
export class OrganisationClient implements IOrganisationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<OrganisationViewModel[]> {
        let url_ = this.baseUrl + "/api/Organisation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganisationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganisationViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrganisationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationViewModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRentalListingClient {
    getAllRentalListingObjects(latitude: number | undefined, longitude: number | undefined, radius: number | undefined): Observable<RentalListingOverviewViewModel[]>;
    getAllRentalListingObjectsForEdit(): Observable<RentalListingDto[]>;
    getRentalListingObject(id: number): Observable<RentalListingDetailViewModel>;
    getRentalListingObjectForEdit(id: number): Observable<RentalListingDto>;
    getVideoUrl(): Observable<string>;
    createRentalListing(request: CreateOrUpdateRentalListingRequest): Observable<void>;
    updateRentalListing(id: number, request: CreateOrUpdateRentalListingRequest): Observable<void>;
    deleteRentalListing(id: number): Observable<void>;
}

@Injectable()
export class RentalListingClient implements IRentalListingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllRentalListingObjects(latitude: number | undefined, longitude: number | undefined, radius: number | undefined): Observable<RentalListingOverviewViewModel[]> {
        let url_ = this.baseUrl + "/api/RentalListing?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (radius === null)
            throw new Error("The parameter 'radius' cannot be null.");
        else if (radius !== undefined)
            url_ += "radius=" + encodeURIComponent("" + radius) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRentalListingObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRentalListingObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RentalListingOverviewViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RentalListingOverviewViewModel[]>;
        }));
    }

    protected processGetAllRentalListingObjects(response: HttpResponseBase): Observable<RentalListingOverviewViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentalListingOverviewViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllRentalListingObjectsForEdit(): Observable<RentalListingDto[]> {
        let url_ = this.baseUrl + "/api/RentalListing/edit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRentalListingObjectsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRentalListingObjectsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RentalListingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RentalListingDto[]>;
        }));
    }

    protected processGetAllRentalListingObjectsForEdit(response: HttpResponseBase): Observable<RentalListingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentalListingDto[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRentalListingObject(id: number): Observable<RentalListingDetailViewModel> {
        let url_ = this.baseUrl + "/api/RentalListing/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRentalListingObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRentalListingObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RentalListingDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RentalListingDetailViewModel>;
        }));
    }

    protected processGetRentalListingObject(response: HttpResponseBase): Observable<RentalListingDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentalListingDetailViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRentalListingObjectForEdit(id: number): Observable<RentalListingDto> {
        let url_ = this.baseUrl + "/api/RentalListing/{id}/edit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRentalListingObjectForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRentalListingObjectForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RentalListingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RentalListingDto>;
        }));
    }

    protected processGetRentalListingObjectForEdit(response: HttpResponseBase): Observable<RentalListingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentalListingDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVideoUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/RentalListing/video-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVideoUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVideoUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVideoUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createRentalListing(request: CreateOrUpdateRentalListingRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/RentalListing/CreateRentalListing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRentalListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRentalListing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateRentalListing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRentalListing(id: number, request: CreateOrUpdateRentalListingRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/RentalListing/UpdateRentalListing/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRentalListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRentalListing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRentalListing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRentalListing(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RentalListing/DeleteRentalListing/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRentalListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRentalListing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRentalListing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRoleClient {
    get(): Observable<RoleViewModel[]>;
}

@Injectable()
export class RoleClient implements IRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<RoleViewModel[]> {
        let url_ = this.baseUrl + "/api/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleViewModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISalesClient {
    getVideoUrl(): Observable<string>;
}

@Injectable()
export class SalesClient implements ISalesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getVideoUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/Sales/video-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVideoUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVideoUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVideoUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IStorageClient {
    archiveFileToImageMaster(id: string | undefined): Observable<void>;
    archiveFilesToImageMaster(ids: string[]): Observable<void>;
    deleteDocumentMetadata(id: string): Observable<DocumentMetadata[]>;
    getDocumentMetadata(request: DocumentMetadataRequest): Observable<DocumentMetadata[]>;
    externalGetDocumentMetadata(request: DocumentMetadataWithEmailRequest): Observable<DocumentMetadata[]>;
    getDocumentTypes(configurationTaskId: string | null | undefined): Observable<GetDocumentTypesViewModel>;
    uploadFiles(request: UploadFilesTempStorageRequest): Observable<DocumentMetadata[]>;
    externalUploadFilesWithEmail(request: UploadFilesWithEmailRequest): Observable<DocumentMetadata[]>;
}

@Injectable()
export class StorageClient implements IStorageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    archiveFileToImageMaster(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Storage/ArchiveFileToImageMaster?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveFileToImageMaster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveFileToImageMaster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveFileToImageMaster(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    archiveFilesToImageMaster(ids: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/Storage/ArchiveFilesToImageMaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveFilesToImageMaster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveFilesToImageMaster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveFilesToImageMaster(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDocumentMetadata(id: string): Observable<DocumentMetadata[]> {
        let url_ = this.baseUrl + "/api/Storage/DeleteDocumentMetadata/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentMetadata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentMetadata[]>;
        }));
    }

    protected processDeleteDocumentMetadata(response: HttpResponseBase): Observable<DocumentMetadata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentMetadata[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentMetadata(request: DocumentMetadataRequest): Observable<DocumentMetadata[]> {
        let url_ = this.baseUrl + "/api/Storage/GetDocumentMetadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentMetadata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentMetadata[]>;
        }));
    }

    protected processGetDocumentMetadata(response: HttpResponseBase): Observable<DocumentMetadata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentMetadata[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    externalGetDocumentMetadata(request: DocumentMetadataWithEmailRequest): Observable<DocumentMetadata[]> {
        let url_ = this.baseUrl + "/api/Storage/ExternalGetDocumentMetadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalGetDocumentMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalGetDocumentMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentMetadata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentMetadata[]>;
        }));
    }

    protected processExternalGetDocumentMetadata(response: HttpResponseBase): Observable<DocumentMetadata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentMetadata[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedAccessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentTypes(configurationTaskId: string | null | undefined): Observable<GetDocumentTypesViewModel> {
        let url_ = this.baseUrl + "/api/Storage/GetDocumentTypes?";
        if (configurationTaskId !== undefined && configurationTaskId !== null)
            url_ += "configurationTaskId=" + encodeURIComponent("" + configurationTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentTypesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentTypesViewModel>;
        }));
    }

    protected processGetDocumentTypes(response: HttpResponseBase): Observable<GetDocumentTypesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDocumentTypesViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadFiles(request: UploadFilesTempStorageRequest): Observable<DocumentMetadata[]> {
        let url_ = this.baseUrl + "/api/Storage/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentMetadata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentMetadata[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<DocumentMetadata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentMetadata[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileUploadException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedAccessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    externalUploadFilesWithEmail(request: UploadFilesWithEmailRequest): Observable<DocumentMetadata[]> {
        let url_ = this.baseUrl + "/api/Storage/ExternalUploadFilesWithEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalUploadFilesWithEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalUploadFilesWithEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentMetadata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentMetadata[]>;
        }));
    }

    protected processExternalUploadFilesWithEmail(response: HttpResponseBase): Observable<DocumentMetadata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentMetadata[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileUploadException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedAccessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISubstitutionClient {
    createSubstitutions(request: CreateSubstitutionsRequest): Observable<void>;
    deleteSubstitution(id: number): Observable<void>;
    getAssignableCostCentersForManagerSubstitution(): Observable<BaseSelectViewModel[]>;
    getSubstitutions(request: GetSubstitutionsRequest): Observable<SubstitutionTableEntryViewModel[]>;
}

@Injectable()
export class SubstitutionClient implements ISubstitutionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createSubstitutions(request: CreateSubstitutionsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Substitution/CreateSubstitutionsAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSubstitutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSubstitutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSubstitutions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteSubstitution(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Substitution/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubstitution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubstitution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSubstitution(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAssignableCostCentersForManagerSubstitution(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/Substitution/GetAssignableCostCentersForManagerSubstitutionAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignableCostCentersForManagerSubstitution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignableCostCentersForManagerSubstitution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetAssignableCostCentersForManagerSubstitution(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubstitutions(request: GetSubstitutionsRequest): Observable<SubstitutionTableEntryViewModel[]> {
        let url_ = this.baseUrl + "/api/Substitution/GetSubstitutionsAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubstitutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubstitutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubstitutionTableEntryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubstitutionTableEntryViewModel[]>;
        }));
    }

    protected processGetSubstitutions(response: HttpResponseBase): Observable<SubstitutionTableEntryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubstitutionTableEntryViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface ITaskClient {
    getTasks(searchOptions: TaskSearchOptions): Observable<ResultWrapperOfTaskTableEntryViewModel>;
    getDtagTasks(searchOptions: TaskSearchOptions): Observable<ResultWrapperOfTaskTableEntryViewModel>;
    getTask(id: string | undefined, ignoreStatus: boolean | undefined): Observable<ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping>;
    updateTask(updateTaskDTO: UpdateTaskDTO): Observable<void>;
    createExportExcelFromTask(exportTaskExcelDto: ExportTaskExcelDto): Observable<FileResponse>;
    isTaskUpdated(request: CheckForTaskUpdateRequest): Observable<boolean>;
    getRelatedTaskSubjects(id: string | undefined): Observable<KeyValuePairOfStringAndString[]>;
}

@Injectable()
export class TaskClient implements ITaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getTasks(searchOptions: TaskSearchOptions): Observable<ResultWrapperOfTaskTableEntryViewModel> {
        let url_ = this.baseUrl + "/api/Task/GetTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfTaskTableEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfTaskTableEntryViewModel>;
        }));
    }

    protected processGetTasks(response: HttpResponseBase): Observable<ResultWrapperOfTaskTableEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfTaskTableEntryViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getDtagTasks(searchOptions: TaskSearchOptions): Observable<ResultWrapperOfTaskTableEntryViewModel> {
        let url_ = this.baseUrl + "/api/Task/GetDtagTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDtagTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDtagTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultWrapperOfTaskTableEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultWrapperOfTaskTableEntryViewModel>;
        }));
    }

    protected processGetDtagTasks(response: HttpResponseBase): Observable<ResultWrapperOfTaskTableEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultWrapperOfTaskTableEntryViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getTask(id: string | undefined, ignoreStatus: boolean | undefined): Observable<ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping> {
        let url_ = this.baseUrl + "/api/Task/GetTask?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (ignoreStatus === null)
            throw new Error("The parameter 'ignoreStatus' cannot be null.");
        else if (ignoreStatus !== undefined)
            url_ += "ignoreStatus=" + encodeURIComponent("" + ignoreStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping>;
        }));
    }

    protected processGetTask(response: HttpResponseBase): Observable<ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateTask(updateTaskDTO: UpdateTaskDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/Task/UpdateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTaskDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createExportExcelFromTask(exportTaskExcelDto: ExportTaskExcelDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Task/CreateExportExcelFromTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportTaskExcelDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExportExcelFromTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExportExcelFromTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateExportExcelFromTask(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    isTaskUpdated(request: CheckForTaskUpdateRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Task/IsTaskUpdated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTaskUpdated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTaskUpdated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTaskUpdated(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getRelatedTaskSubjects(id: string | undefined): Observable<KeyValuePairOfStringAndString[]> {
        let url_ = this.baseUrl + "/api/Task/GetRelatedTaskSubjects?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatedTaskSubjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedTaskSubjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfStringAndString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfStringAndString[]>;
        }));
    }

    protected processGetRelatedTaskSubjects(response: HttpResponseBase): Observable<KeyValuePairOfStringAndString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfStringAndString[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface ITaskDocumentTypeClient {
    deleteAssignment(configurationTaskId: string | undefined, documentTypeId: string | undefined): Observable<void>;
    getAssignedDocumentTypes(configurationTaskId: string | undefined, allIfEmpty: boolean | undefined): Observable<GetTaskDocumentTypeAssignmentsViewModel>;
    getUnassignedDocumentTypes(configurationTaskId: string | undefined): Observable<GetTaskDocumentTypeAssignmentsViewModel>;
    createAssignments(incidentClassId: string | undefined, configurationTaskSequence: number | undefined, documentTypeIds: string[]): Observable<void>;
    setDefault(configurationTaskId: string | undefined, documentTypeId: string | null | undefined): Observable<void>;
    takeOverAssignments(configurationTaskId: string | undefined): Observable<void>;
}

@Injectable()
export class TaskDocumentTypeClient implements ITaskDocumentTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    deleteAssignment(configurationTaskId: string | undefined, documentTypeId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TaskDocumentType/DeleteAssignment?";
        if (configurationTaskId === null)
            throw new Error("The parameter 'configurationTaskId' cannot be null.");
        else if (configurationTaskId !== undefined)
            url_ += "configurationTaskId=" + encodeURIComponent("" + configurationTaskId) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "documentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAssignedDocumentTypes(configurationTaskId: string | undefined, allIfEmpty: boolean | undefined): Observable<GetTaskDocumentTypeAssignmentsViewModel> {
        let url_ = this.baseUrl + "/api/TaskDocumentType/GetAssignedDocumentTypes?";
        if (configurationTaskId === null)
            throw new Error("The parameter 'configurationTaskId' cannot be null.");
        else if (configurationTaskId !== undefined)
            url_ += "configurationTaskId=" + encodeURIComponent("" + configurationTaskId) + "&";
        if (allIfEmpty === null)
            throw new Error("The parameter 'allIfEmpty' cannot be null.");
        else if (allIfEmpty !== undefined)
            url_ += "allIfEmpty=" + encodeURIComponent("" + allIfEmpty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskDocumentTypeAssignmentsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskDocumentTypeAssignmentsViewModel>;
        }));
    }

    protected processGetAssignedDocumentTypes(response: HttpResponseBase): Observable<GetTaskDocumentTypeAssignmentsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTaskDocumentTypeAssignmentsViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getUnassignedDocumentTypes(configurationTaskId: string | undefined): Observable<GetTaskDocumentTypeAssignmentsViewModel> {
        let url_ = this.baseUrl + "/api/TaskDocumentType/GetUnassignedDocumentTypes?";
        if (configurationTaskId === null)
            throw new Error("The parameter 'configurationTaskId' cannot be null.");
        else if (configurationTaskId !== undefined)
            url_ += "configurationTaskId=" + encodeURIComponent("" + configurationTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignedDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignedDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskDocumentTypeAssignmentsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskDocumentTypeAssignmentsViewModel>;
        }));
    }

    protected processGetUnassignedDocumentTypes(response: HttpResponseBase): Observable<GetTaskDocumentTypeAssignmentsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTaskDocumentTypeAssignmentsViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createAssignments(incidentClassId: string | undefined, configurationTaskSequence: number | undefined, documentTypeIds: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/TaskDocumentType/CreateAssignments?";
        if (incidentClassId === null)
            throw new Error("The parameter 'incidentClassId' cannot be null.");
        else if (incidentClassId !== undefined)
            url_ += "incidentClassId=" + encodeURIComponent("" + incidentClassId) + "&";
        if (configurationTaskSequence === null)
            throw new Error("The parameter 'configurationTaskSequence' cannot be null.");
        else if (configurationTaskSequence !== undefined)
            url_ += "configurationTaskSequence=" + encodeURIComponent("" + configurationTaskSequence) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentTypeIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateAssignments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    setDefault(configurationTaskId: string | undefined, documentTypeId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TaskDocumentType/SetDefault?";
        if (configurationTaskId === null)
            throw new Error("The parameter 'configurationTaskId' cannot be null.");
        else if (configurationTaskId !== undefined)
            url_ += "configurationTaskId=" + encodeURIComponent("" + configurationTaskId) + "&";
        if (documentTypeId !== undefined && documentTypeId !== null)
            url_ += "documentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefault(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    takeOverAssignments(configurationTaskId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TaskDocumentType/TakeOverAssignments?";
        if (configurationTaskId === null)
            throw new Error("The parameter 'configurationTaskId' cannot be null.");
        else if (configurationTaskId !== undefined)
            url_ += "configurationTaskId=" + encodeURIComponent("" + configurationTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTakeOverAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTakeOverAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTakeOverAssignments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IUserAdministrationClient {
    createUser(request: UserAdministrationIncidentRequest): Observable<IncidentIdResult>;
    requestRoles(request: RoleIncidentRequest): Observable<IncidentIdResult>;
    requestOwnRoles(roles: string[]): Observable<IncidentIdResult>;
    updateUser(request: UserAdministrationIncidentRequest): Observable<IncidentIdResult>;
}

@Injectable()
export class UserAdministrationClient implements IUserAdministrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createUser(request: UserAdministrationIncidentRequest): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/UserAdministration/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestRoles(request: RoleIncidentRequest): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/UserAdministration/RequestRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processRequestRoles(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestOwnRoles(roles: string[]): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/UserAdministration/RequestOwnRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestOwnRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOwnRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processRequestOwnRoles(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(request: UserAdministrationIncidentRequest): Observable<IncidentIdResult> {
        let url_ = this.baseUrl + "/api/UserAdministration/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentIdResult>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<IncidentIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncidentIdResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmartPortalErrorDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWorkingSpaceClient {
    getWorkingSpacesByArea(areaCode: string | undefined): Observable<WorkingSpaceViewModel[]>;
    createWorkingSpaces(createWorkingSpaceRequests: CreateWorkingSpaceRequest[]): Observable<void>;
    updateWorkingSpaces(workingSpaceUpdateRequests: UpdateWorkingSpaceRequest[]): Observable<void>;
    getDummyTypes(): Observable<BaseSelectViewModel[]>;
}

@Injectable()
export class WorkingSpaceClient implements IWorkingSpaceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkingSpacesByArea(areaCode: string | undefined): Observable<WorkingSpaceViewModel[]> {
        let url_ = this.baseUrl + "/api/WorkingSpace/GetWorkingSpacesByArea?";
        if (areaCode === null)
            throw new Error("The parameter 'areaCode' cannot be null.");
        else if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkingSpacesByArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkingSpacesByArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkingSpaceViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkingSpaceViewModel[]>;
        }));
    }

    protected processGetWorkingSpacesByArea(response: HttpResponseBase): Observable<WorkingSpaceViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkingSpaceViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    createWorkingSpaces(createWorkingSpaceRequests: CreateWorkingSpaceRequest[]): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkingSpace/CreateWorkingSpaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createWorkingSpaceRequests);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkingSpaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkingSpaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWorkingSpaces(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateWorkingSpaces(workingSpaceUpdateRequests: UpdateWorkingSpaceRequest[]): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkingSpace/UpdateWorkingSpaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workingSpaceUpdateRequests);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkingSpaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkingSpaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWorkingSpaces(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getDummyTypes(): Observable<BaseSelectViewModel[]> {
        let url_ = this.baseUrl + "/api/WorkingSpace/GetDummyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDummyTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDummyTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseSelectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseSelectViewModel[]>;
        }));
    }

    protected processGetDummyTypes(response: HttpResponseBase): Observable<BaseSelectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseSelectViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface UploadFileResult {
    id: string;
    name: string;
    downloadLink?: string | undefined;
    created?: Date | undefined;
}

export interface UploadFile {
    contentBase64Encoded: string;
    metadata: DocumentDTO;
}

export interface DocumentDTO {
    documentId?: string | undefined;
    name: string;
    guidExternalSystem?: string | undefined;
    crmGuidOriginRecord?: string | undefined;
    filename: string;
    dynamicsUri?: string | undefined;
    publishDocument?: boolean | undefined;
    statusCode?: string | undefined;
    quoteId?: string | undefined;
    workOrderId?: string | undefined;
    contactId?: string | undefined;
    rentalContractId?: string | undefined;
    frameworkAgreementId?: string | undefined;
    taskId?: string | undefined;
    functionalLocationId?: string | undefined;
    accountId?: string | undefined;
    purchaseOrderId?: string | undefined;
    agreementId?: string | undefined;
    incidentId?: string | undefined;
    changeDate?: Date | undefined;
    contentType?: string | undefined;
    propertyBrochureId?: string | undefined;
    documentTypeId?: string | undefined;
    deleted?: boolean | undefined;
    blobFilename?: string | undefined;
    uploaded?: boolean | undefined;
    apiError?: string | undefined;
    apiErrorDetails?: string | undefined;
    deleteDate?: Date | undefined;
    imageMaster?: boolean | undefined;
    isInternal?: boolean;
    visibilityId?: string | undefined;
    filesize?: number | undefined;
    systemUserId?: string | undefined;
    transferredToSupplierAtUtc?: Date | undefined;
    documentType?: DocumentTypeDTO | undefined;
    employeeId?: string | undefined;
    workTaskId?: string | undefined;
    speedikonArchObjId?: string | undefined;
    groupId?: string | undefined;
}

export interface DocumentTypeDTO {
    documentTypeId: string;
    abbreviation?: string | undefined;
    name?: string | undefined;
    externalCode?: string | undefined;
    gefmaCode?: string | undefined;
    deleteDate?: Date | undefined;
    isExternal?: boolean;
    maxFileSizeInBytes?: number;
    abbreviationText?: string | undefined;
    usage?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface DownloadFile {
    id?: string | undefined;
}

export interface DownloadFileExternalRequest {
    documentId?: string | undefined;
    ticketId?: string | undefined;
    email?: string | undefined;
}

export interface DownloadFileResult {
    link?: string | undefined;
}

export interface FmDocument {
    documentId?: string | undefined;
    name: string;
    guidExternalSystem?: string | undefined;
    crmGuidOriginRecord?: string | undefined;
    filename: string;
    dynamicsUri?: string | undefined;
    publishDocument?: boolean | undefined;
    statusCode?: string | undefined;
    quoteId?: string | undefined;
    workOrderId?: string | undefined;
    contactId?: string | undefined;
    rentalContractId?: string | undefined;
    frameworkAgreementId?: string | undefined;
    taskId?: string | undefined;
    functionalLocationId?: string | undefined;
    accountId?: string | undefined;
    purchaseOrderId?: string | undefined;
    agreementId?: string | undefined;
    incidentId?: string | undefined;
    changeDate?: Date | undefined;
    contentType?: string | undefined;
    propertyBrochureId?: string | undefined;
    documentTypeId?: string | undefined;
    deleted?: boolean | undefined;
    blobFilename?: string | undefined;
    uploaded?: boolean | undefined;
    apiError?: string | undefined;
    apiErrorDetails?: string | undefined;
    deleteDate?: Date | undefined;
    imageMaster?: boolean | undefined;
    isInternal?: boolean;
    visibilityId?: string | undefined;
    filesize?: number | undefined;
    systemUserId?: string | undefined;
    employeeId?: string | undefined;
    transferredToSupplierAtUtc?: Date | undefined;
    workTaskId?: string | undefined;
    groupId?: string | undefined;
    speedikonArchObjId?: string | undefined;
    account?: OmOrganisation | undefined;
    agreement?: FmAgreement | undefined;
    contact?: OmContact | undefined;
    documentType?: FmDocumentType | undefined;
    employee?: OmEmployee | undefined;
    frameworkAgreement?: FmFrameworkAgreement | undefined;
    functionalLocation?: DtArchObjHierarchy | undefined;
    incident?: FmIncident | undefined;
    pmRentalContract?: PmRentalContract[] | undefined;
    propertyBrochure?: PmPropertyBrochure | undefined;
    purchaseOrder?: FmPurchaseOrder | undefined;
    quote?: FmQuote | undefined;
    rentalContract?: PmRentalContract | undefined;
    speedikonArchObj?: DtArchObjHierarchy | undefined;
    systemUser?: OmSystemUser | undefined;
    task?: FmTask | undefined;
    visibility?: SysEnum | undefined;
    workOrder?: FmWorkOrder | undefined;
}

export interface OmOrganisation {
    organisationId?: string | undefined;
    parentOrganisationId?: string | undefined;
    name?: string | undefined;
    industry?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
    fax?: string | undefined;
    vatNumber?: string | undefined;
    legalEntity?: boolean | undefined;
    fiscalYearStartDate?: Date | undefined;
    changeDate?: Date | undefined;
    ownershipCode?: string | undefined;
    websiteUrl?: string | undefined;
    primaryContactId?: string | undefined;
    renter?: string | undefined;
    sic?: string | undefined;
    preferredContactMethod?: string | undefined;
    doNotEmail?: boolean | undefined;
    doNotBulkEmail?: boolean | undefined;
    doNotPhone?: boolean | undefined;
    doNotFax?: boolean | undefined;
    doNotPostalmail?: boolean | undefined;
    creditLimit?: number | undefined;
    creditOnHold?: boolean | undefined;
    paymentTerms?: string | undefined;
    shippingMethod?: string | undefined;
    billingAccount?: string | undefined;
    travelChargeType?: string | undefined;
    workOrderInstruction?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    deleteDate?: Date | undefined;
    isAdminPortalRelevant?: boolean;
    fiCostCenter?: FiCostCenter[] | undefined;
    fmAgreementBillingAccountNavigation?: FmAgreement[] | undefined;
    fmAgreementServiceAccountNavigation?: FmAgreement[] | undefined;
    fmBookableRessource?: FmBookableRessource[] | undefined;
    fmConfigurationTask?: FmConfigurationTask[] | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmIncidentOrganisationRole?: FmIncidentOrganisationRole[] | undefined;
    fmOrderInquiry?: FmOrderInquiry[] | undefined;
    fmQuote?: FmQuote[] | undefined;
    fmTask?: FmTask[] | undefined;
    fmWorkOrderBillingAccount?: FmWorkOrder[] | undefined;
    fmWorkOrderExternalServiceProvider?: FmWorkOrder[] | undefined;
    fmWorkOrderServiceAccount?: FmWorkOrder[] | undefined;
    inverseParentOrganisation?: OmOrganisation[] | undefined;
    omContact?: OmContact[] | undefined;
    omCustomer?: OmCustomer[] | undefined;
    omOrganisationAddress?: OmOrganisationAddress[] | undefined;
    omOrganisationArchObjRole?: OmOrganisationArchObjRole[] | undefined;
    omOrganisationRole?: OmOrganisationRole[] | undefined;
    omOrganisationalUnit?: OmOrganisationalUnit[] | undefined;
    parentOrganisation?: OmOrganisation | undefined;
    pmRentalContractOrganisationRole?: PmRentalContractOrganisationRole[] | undefined;
    primaryContact?: OmContact | undefined;
}

export interface FiCostCenter {
    costCenterId?: string | undefined;
    name: string;
    type?: string | undefined;
    organisationId?: string | undefined;
    changeDate?: Date | undefined;
    number?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    deleteDate?: Date | undefined;
    profitcenter?: string | undefined;
    costAccountArea?: string | undefined;
    logSystem?: string | undefined;
    cob?: string | undefined;
    bookable?: boolean | undefined;
    dispoCost?: boolean | undefined;
    manually?: boolean | undefined;
    companyNumber?: string | undefined;
    r3managerId?: string | undefined;
    dynamicsManagerId?: string | undefined;
    managerId?: string | undefined;
    assignmentId?: string | undefined;
    assignment?: SysEnum | undefined;
    companyNumberNavigation?: OmCompany | undefined;
    dynamicsManager?: OmEmployee | undefined;
    fmAreaRequest?: FmAreaRequest[] | undefined;
    fmAreaRequirement?: FmAreaRequirement[] | undefined;
    fmAreaReturn?: FmAreaReturn[] | undefined;
    fmCostCenterUsage?: FmCostCenterUsage[] | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmSbuUsage?: FmSbuUsage[] | undefined;
    fmUsageChangeHistoryNewCostCenter?: FmUsageChangeHistory[] | undefined;
    fmUsageChangeHistoryOldCostCenter?: FmUsageChangeHistory[] | undefined;
    omAccessOrderer?: OmAccessOrderer[] | undefined;
    omEmployee?: OmEmployee[] | undefined;
    omEmployment?: OmEmployment[] | undefined;
    omSubstitution?: OmSubstitution[] | undefined;
    organisation?: OmOrganisation | undefined;
    r3manager?: OmEmployee | undefined;
}

export interface SysEnum {
    id?: string | undefined;
    type: string;
    defaultName: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    budgetTypeMapping?: BudgetTypeMapping | undefined;
    dtArchObjInformation?: DtArchObjInformation[] | undefined;
    fiCostCenter?: FiCostCenter[] | undefined;
    fmApproval?: FmApproval[] | undefined;
    fmAreaRequest?: FmAreaRequest[] | undefined;
    fmAreaRequirement?: FmAreaRequirement[] | undefined;
    fmAreaReturn?: FmAreaReturn[] | undefined;
    fmBasicServiceChangeBasicCleaning?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeCleaningDetails?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeConferenceRoomManagement?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeDayLabour?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeGlassCleaningDetails?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeHinUndWegVertrag?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeInterfaceState?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeJanitorialServicesAttendanceStaff?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeMaintenanceCategory?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeMobileJanitorialServices?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeModification?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangePestControl?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangePestProfilaxeCanteens?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangePestType?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangePlantCareDetails?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangePropertyManagementTfmIfm?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeQualification?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeReceptionQualification?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeReceptionServices?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeSecurityServiceQualification?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeVolumeType?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeWinterServiceDetails?: FmBasicServiceChange[] | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmGeneralRequest?: FmGeneralRequest[] | undefined;
    fmIncidentApprovalRejection?: FmIncident[] | undefined;
    fmIncidentCaseOriginCodeNavigation?: FmIncident[] | undefined;
    fmIncidentClientContact?: FmIncident[] | undefined;
    fmIncidentCommissioningIss?: FmIncident[] | undefined;
    fmIncidentCommonNeeds?: FmIncident[] | undefined;
    fmIncidentCommunicateDecisionNeighbourhoodAgreement?: FmIncident[] | undefined;
    fmIncidentCompanyResidence?: FmIncident[] | undefined;
    fmIncidentDirectNeedForAction?: FmIncident[] | undefined;
    fmIncidentDocumentExamination?: FmIncident[] | undefined;
    fmIncidentEnergyCertificationAvailable?: FmIncident[] | undefined;
    fmIncidentExaminationImpairment?: FmIncident[] | undefined;
    fmIncidentExploratoryInterviewConducted?: FmIncident[] | undefined;
    fmIncidentExternalTransmissionStatus?: FmIncident[] | undefined;
    fmIncidentFacilityManagementProcessStatus?: FmIncident[] | undefined;
    fmIncidentFinalTaskNemo?: FmIncident[] | undefined;
    fmIncidentFireProtection?: FmIncident[] | undefined;
    fmIncidentGksPreparationUploaded?: FmIncident[] | undefined;
    fmIncidentGksSeparationUploadedNavigation?: FmIncident[] | undefined;
    fmIncidentIncidentOriginNavigation?: FmIncident[] | undefined;
    fmIncidentIncidentPriority?: FmIncident[] | undefined;
    fmIncidentIncidentToTender?: FmIncident[] | undefined;
    fmIncidentInitiateRenegotiation?: FmIncident[] | undefined;
    fmIncidentInterfaceState?: FmIncident[] | undefined;
    fmIncidentLandRegisterNotificationAcceptable?: FmIncident[] | undefined;
    fmIncidentLayout?: FmIncident[] | undefined;
    fmIncidentLettingDecision?: FmIncident[] | undefined;
    fmIncidentMarketingType?: FmIncident[] | undefined;
    fmIncidentNeedForActionAfterExamination?: FmIncident[] | undefined;
    fmIncidentNeedJustified?: FmIncident[] | undefined;
    fmIncidentOfferStatus?: FmIncidentOffer[] | undefined;
    fmIncidentOfferType?: FmIncidentOffer[] | undefined;
    fmIncidentPollutants?: FmIncident[] | undefined;
    fmIncidentPowerOfDisposition?: FmIncident[] | undefined;
    fmIncidentProfitableNavigation?: FmIncident[] | undefined;
    fmIncidentQuantityCounterElectricity?: FmIncident[] | undefined;
    fmIncidentQuantityCounterHeating?: FmIncident[] | undefined;
    fmIncidentQuantityCounterWater?: FmIncident[] | undefined;
    fmIncidentReleaseRentalUnit?: FmIncident[] | undefined;
    fmIncidentRequestDeclinable?: FmIncident[] | undefined;
    fmIncidentRequestTypeNavigation?: FmIncident[] | undefined;
    fmIncidentRoofSubject?: FmIncident[] | undefined;
    fmIncidentSeparationConcept?: FmIncident[] | undefined;
    fmIncidentSetupRenterDecision?: FmIncident[] | undefined;
    fmIncidentStatusNavigation?: FmIncident[] | undefined;
    fmIncidentStatusReasonNavigation?: FmIncident[] | undefined;
    fmIncidentSupervisionNecessary?: FmIncident[] | undefined;
    fmIncidentTechnicalBuildingEquipment?: FmIncident[] | undefined;
    fmIncidentUploadLegalMatrix?: FmIncident[] | undefined;
    fmServiceRequestApproval?: FmServiceRequest[] | undefined;
    fmServiceRequestCheckAddendumOffer?: FmServiceRequest[] | undefined;
    fmServiceRequestCheckOffer?: FmServiceRequest[] | undefined;
    fmServiceRequestInterfaceState?: FmServiceRequest[] | undefined;
    fmServiceRequestInvoiceType?: FmServiceRequest[] | undefined;
    fmServiceRequestResultInvoiceCheck?: FmServiceRequest[] | undefined;
    fmServiceRequestResultServiceAcceptance?: FmServiceRequest[] | undefined;
    incidentTransmission?: IncidentTransmission[] | undefined;
    omContactNationality?: OmContact[] | undefined;
    omContactPreferredContactMethodNavigation?: OmContact[] | undefined;
    omContactPreferredLanguage?: OmContact[] | undefined;
    pmIncidentExternalLettingCommonNeeds?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingEnergyCertificationAvailable?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingFireProtection?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingLayout?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingLettingDecision?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingMaintenanceMeasures?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingPaymentAdditionalCostsElectricity?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingPaymentAdditionalCostsHeating?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingPaymentAdditionalCostsOperation?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingPollutants?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingQuantityCounterElectricity?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingQuantityCounterHeating?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingQuantityCounterWater?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingRejectTenant?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingRoofSubject?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingSetupRenterDecision?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingStopMarketing?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingTechnicalBuildingEquipment?: PmIncidentExternalLetting[] | undefined;
    pmIncidentRealEstateDecisionExpectedStrategyIet?: PmIncidentRealEstateDecision[] | undefined;
    pmIncidentRealEstateDecisionGksseparationUploadedIet?: PmIncidentRealEstateDecision[] | undefined;
    pmIncidentRealEstateDecisionUploadLegalMatrixIet?: PmIncidentRealEstateDecision[] | undefined;
    pmIncidentRentalContractMgmtAddendumPartialPaymentCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtAmvAdjusted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtAmvCreated?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtAreasTransferredGmg?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtAreasTransferredOwnerLessor?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtAssetRecognitionCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtAssetRecognitionTriggered?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtAssetTransferCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtAssetTransferTriggered?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBasicServiceCommissionCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBasicServiceCommissionTriggered?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBasicServiceTerminationCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBasicServiceTerminationInitiated?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBoard?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBranchesInformedPartialTerminationOrExtension?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBranchesInformedTermination?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtClearingAreasCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtClearingAreasTriggered?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtCommissionInvoiceApproved?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtConsultingOrderEmtPosted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtCoordinatedMilestonePlanningAvailable?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtDismantlingCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtDismantlingImplemented?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtDismantlingOfferApproved?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtDismantlingOfferCreated?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtDismantlingOfferPostedFlm?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtDismantlingOfferTriggeredBam?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtDraftContractIssMake?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtDraftsupplementIssMake?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtEasementAdjustmentTriggeredGsusSae?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtElectricityBillingSpecificationRequestedPasm?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtEmtCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtFlmInformedPartialTerminationOrExtension?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtFlmInformedTermination?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtHsinformedAreaRetraction?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtHsinformedPartialTerminationOrExtension?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtHsinformedTermination?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtLanCablingCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtLanCablingTriggered?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtLesserInformedTermination?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtManagementSummaryAdjusted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtNegativeDeviationNegotiationOrder?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtOmvAdjustmentConfirmed?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtOmvCreationSapCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtOwnerInformedPartialTerminationOrExtension?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtPreparationOfferTargetAreasApproved?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtPreparationOfferTargetAreasCreated?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtPreparationOfferTargetAreasPostedFlm?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtPreparationOfferTargetAreasTriggeredBam?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtPreparationTargetAreasCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtPreparationTargetAreasImplemented?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtReleaseTriggered?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtRelocationCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtRelocationtriggeredFlm?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtSeparationCompleted?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtSeparationImplemented?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtSeparationOfferApproved?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtSeparationOfferCreated?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtSeparationOfferPostedFlm?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtSeparationOfferTriggeredBam?: PmIncidentRentalContractMgmt[] | undefined;
    sapBasicServiceChangeChangeOrder?: SapBasicServiceChangeChangeOrder[] | undefined;
    sapInvoiceVerification?: SapInvoiceVerification[] | undefined;
    sysEnumTranslation?: SysEnumTranslation[] | undefined;
    wbsMapping?: WbsMapping[] | undefined;
}

export interface BudgetTypeMapping {
    budgetTypeId?: string | undefined;
    budgetTypeSap?: number;
    budgetType?: SysEnum | undefined;
}

export interface DtArchObjInformation {
    id?: string | undefined;
    archObjId: string;
    text?: string | undefined;
    infoCategoryId?: string | undefined;
    isPublished?: boolean | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    infoCategory?: SysEnum | undefined;
}

export interface DtArchObjHierarchy {
    archObjId?: string | undefined;
    parentArchObjId?: string | undefined;
    archObjType: string;
    changeDate?: Date | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    measurementGroupId?: string | undefined;
    departmentId?: string | undefined;
    deleteDate?: Date | undefined;
    sapIntreno?: string | undefined;
    alternateKey1?: string | undefined;
    alternateKey2?: string | undefined;
    alternateKey3?: string | undefined;
    isJanitorLocation?: boolean;
    department?: OmDepartment | undefined;
    dtArchObjAddress?: DtArchObjAddress[] | undefined;
    dtArchObjInformation?: DtArchObjInformation[] | undefined;
    dtArchObjMeasurement?: DtArchObjMeasurement[] | undefined;
    dtArchObjNews?: DtArchObjNews[] | undefined;
    dtArchObjTechObj?: DtArchObjTechObj[] | undefined;
    dtArchObjUtilizationHistory?: DtArchObjUtilizationHistory[] | undefined;
    dtBillingArea?: DtBillingArea | undefined;
    dtBuilding?: DtBuilding | undefined;
    dtDistrict?: DtDistrict | undefined;
    dtEquipment?: DtEquipment | undefined;
    dtFloor?: DtFloor | undefined;
    dtLand?: DtLand | undefined;
    dtSite?: DtSite | undefined;
    dtSpace?: DtSpace | undefined;
    dtSubArea?: DtSubArea | undefined;
    dtSubSpace?: DtSubSpace | undefined;
    fmArchObjCategoryValue?: FmArchObjCategoryValue[] | undefined;
    fmAreaRequest?: FmAreaRequest[] | undefined;
    fmAreaReturn?: FmAreaReturn[] | undefined;
    fmBguProject?: FmBguProject[] | undefined;
    fmCostCenterUsage?: FmCostCenterUsage[] | undefined;
    fmDocumentFunctionalLocation?: FmDocument[] | undefined;
    fmDocumentSpeedikonArchObj?: FmDocument[] | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmOrderInquiry?: FmOrderInquiry[] | undefined;
    fmOrderingFurniture?: FmOrderingFurniture[] | undefined;
    fmRelocationOriginAdress?: FmRelocation[] | undefined;
    fmRelocationTargetAdress?: FmRelocation[] | undefined;
    fmServiceRequest?: FmServiceRequest[] | undefined;
    fmUsageChangeHistory?: FmUsageChangeHistory[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
    inverseParentArchObj?: DtArchObjHierarchy[] | undefined;
    measurementGroup?: DtMeasurementGroup | undefined;
    omContactArchObjRole?: OmContactArchObjRole[] | undefined;
    omContactAuthorization?: OmContactAuthorization[] | undefined;
    omEmployee?: OmEmployee[] | undefined;
    omOrganisationArchObjRole?: OmOrganisationArchObjRole[] | undefined;
    omUserArchObjHierarchy?: OmUserArchObjHierarchy[] | undefined;
    parentArchObj?: DtArchObjHierarchy | undefined;
    pmIncidentExternalLetting?: PmIncidentExternalLetting[] | undefined;
    pmRentalContract?: PmRentalContract[] | undefined;
    pmRentalContractArchObj?: PmRentalContractArchObj[] | undefined;
    pmRentalEntityArchObj?: PmRentalEntityArchObj[] | undefined;
    pmRentalListing?: PmRentalListing[] | undefined;
    pmRentalUnit?: PmRentalUnit[] | undefined;
    pmRentalUnitArchObj?: PmRentalUnitArchObj[] | undefined;
    pmRentalUnitArchObjMeasurement?: PmRentalUnitArchObjMeasurement[] | undefined;
    rentalContractSpaceBuildingArchObj?: RentalContractSpace[] | undefined;
    rentalContractSpaceEconomicUnitArchObj?: RentalContractSpace[] | undefined;
    rentalContractSpaceLandArchObj?: RentalContractSpace[] | undefined;
    rentalContractSpaceSpaceArchObj?: RentalContractSpace[] | undefined;
}

export interface OmDepartment {
    departmentId?: string | undefined;
    name: string;
    description?: string | undefined;
    deleteDate?: Date | undefined;
    dtArchObjHierarchy?: DtArchObjHierarchy[] | undefined;
}

export interface DtArchObjAddress {
    archObjId?: string | undefined;
    addressId?: string | undefined;
    changeDate?: Date | undefined;
    validFrom?: Date;
    validUnitl?: Date | undefined;
    smartUsKey?: string | undefined;
    addressType?: string | undefined;
    deleteDate?: Date | undefined;
    address?: OmAddress | undefined;
    archObj?: DtArchObjHierarchy | undefined;
}

export interface OmAddress {
    addressId?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    streetName?: string | undefined;
    houseNumber?: string | undefined;
    additionalInformation?: string | undefined;
    apartmentNumber?: string | undefined;
    district?: string | undefined;
    city: string;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    longitude?: number | undefined;
    latitude?: number | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtArchObjAddress?: DtArchObjAddress[] | undefined;
    dtParcelAddress?: DtParcelAddress[] | undefined;
    dtTechObjAddress?: DtTechObjAddress[] | undefined;
    omContactAddress?: OmContactAddress[] | undefined;
    omOrganisationAddress?: OmOrganisationAddress[] | undefined;
}

export interface DtParcelAddress {
    parcelId?: string | undefined;
    addressId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    address?: OmAddress | undefined;
    parcel?: DtParcel | undefined;
}

export interface DtParcel {
    parcelId?: string | undefined;
    name: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtParcelAddress?: DtParcelAddress[] | undefined;
}

export interface DtTechObjAddress {
    techObjId?: string | undefined;
    addressId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    address?: OmAddress | undefined;
    techObj?: DtTechObjHierarchy | undefined;
}

export interface DtTechObjHierarchy {
    techObjId?: string | undefined;
    parentTechObjId?: string | undefined;
    changeDate?: Date | undefined;
    constructionYear?: Date | undefined;
    serialNumber?: string | undefined;
    manufacturer?: string | undefined;
    barcode?: string | undefined;
    warrantyEndDate?: Date | undefined;
    organisationId?: string | undefined;
    techObjTypeId?: string | undefined;
    name?: string | undefined;
    uniqueName?: string | undefined;
    measurementGroupId?: string | undefined;
    deleteDate?: Date | undefined;
    dtArchObjTechObj?: DtArchObjTechObj[] | undefined;
    dtSystem?: DtSystem | undefined;
    dtTechObjAddress?: DtTechObjAddress[] | undefined;
    dtTechObjMeasurement?: DtTechObjMeasurement[] | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
    inverseParentTechObj?: DtTechObjHierarchy[] | undefined;
    measurementGroup?: DtMeasurementGroup | undefined;
    parentTechObj?: DtTechObjHierarchy | undefined;
    techObjType?: DtTechObjType | undefined;
}

export interface DtArchObjTechObj {
    archObjId?: string | undefined;
    techObjId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    techObj?: DtTechObjHierarchy | undefined;
}

export interface DtSystem {
    systemId?: string | undefined;
    name: string;
    class?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    system?: DtTechObjHierarchy | undefined;
}

export interface DtTechObjMeasurement {
    techObjId?: string | undefined;
    measurementId?: string | undefined;
    value?: number | undefined;
    intValue?: number | undefined;
    floatValue?: number | undefined;
    charValue?: string | undefined;
    dateValue?: Date | undefined;
    bitValue?: boolean | undefined;
    selectedValue?: string | undefined;
    unit?: string | undefined;
    validFrom?: Date;
    changeDate?: Date | undefined;
    validUntil?: Date | undefined;
    isHierarchical?: boolean | undefined;
    deleteDate?: Date | undefined;
    measurement?: DtMeasurement | undefined;
    selectedValueNavigation?: DtMeasurementValue | undefined;
    techObj?: DtTechObjHierarchy | undefined;
}

export interface DtMeasurement {
    measurementId?: string | undefined;
    measurementGroupId?: string | undefined;
    name?: string | undefined;
    defaultUnit?: string | undefined;
    isSumValue?: boolean;
    shortName?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtArchObjMeasurement?: DtArchObjMeasurement[] | undefined;
    dtMeasurementValue?: DtMeasurementValue[] | undefined;
    dtTechObjMeasurement?: DtTechObjMeasurement[] | undefined;
    measurementGroup?: DtMeasurementGroup | undefined;
    pmRentalUnitArchObjMeasurement?: PmRentalUnitArchObjMeasurement[] | undefined;
}

export interface DtArchObjMeasurement {
    archObjId?: string | undefined;
    measurementId?: string | undefined;
    value?: number | undefined;
    intValue?: number | undefined;
    floatValue?: number | undefined;
    charValue?: string | undefined;
    dateValue?: Date | undefined;
    bitValue?: boolean | undefined;
    selectedValue?: string | undefined;
    unit?: string | undefined;
    validFrom?: Date;
    changeDate?: Date | undefined;
    validUntil?: Date | undefined;
    isHierarchical?: boolean | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    measurement?: DtMeasurement | undefined;
    selectedValueNavigation?: DtMeasurementValue | undefined;
}

export interface DtMeasurementValue {
    measurementValueId?: string | undefined;
    measurementId: string;
    numValue?: number | undefined;
    intValue?: number | undefined;
    floatValue?: number | undefined;
    charValue?: string | undefined;
    dateValue?: Date | undefined;
    bitValue?: boolean | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtArchObjMeasurement?: DtArchObjMeasurement[] | undefined;
    dtTechObjMeasurement?: DtTechObjMeasurement[] | undefined;
    measurement?: DtMeasurement | undefined;
}

export interface DtMeasurementGroup {
    measurementGroupId?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    changeDate?: Date | undefined;
    description?: string | undefined;
    shortName: string;
    source?: string | undefined;
    parentMeasurementGroupId?: string | undefined;
    objectType?: string | undefined;
    deleteDate?: Date | undefined;
    dtArchObjHierarchy?: DtArchObjHierarchy[] | undefined;
    dtMeasurement?: DtMeasurement[] | undefined;
    dtTechObjHierarchy?: DtTechObjHierarchy[] | undefined;
}

export interface PmRentalUnitArchObjMeasurement {
    id?: string | undefined;
    archObjId: string;
    rentalUnitId: string;
    measurementId: string;
    value?: number | undefined;
    totalValue?: number | undefined;
    unit?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    measurement?: DtMeasurement | undefined;
    rentalUnit?: PmRentalUnit | undefined;
}

export interface PmRentalUnit {
    rentalUnitId?: string | undefined;
    name?: string | undefined;
    rentalUnitCode?: string | undefined;
    rentedOut?: boolean | undefined;
    usageType?: string | undefined;
    vacancy?: boolean | undefined;
    usageGroup?: string | undefined;
    vacancySince?: Date | undefined;
    rentalSpace?: number | undefined;
    createdFromPtb?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    economicUnitNumber?: string | undefined;
    cashFlowGenerationFrom?: Date | undefined;
    type?: string | undefined;
    changeDate?: Date | undefined;
    siteId?: string | undefined;
    deleteDate?: Date | undefined;
    energyCertificateValid?: string | undefined;
    breakOption?: boolean;
    rentalUnitNumber?: string | undefined;
    fmIncidentRentalUnit?: FmIncident[] | undefined;
    fmIncidentRentalUnitConnection?: FmIncident[] | undefined;
    pmPropertyBrochure?: PmPropertyBrochure[] | undefined;
    pmRentalContractRentalUnit?: PmRentalContractRentalUnit[] | undefined;
    pmRentalUnitArchObj?: PmRentalUnitArchObj[] | undefined;
    pmRentalUnitArchObjMeasurement?: PmRentalUnitArchObjMeasurement[] | undefined;
    site?: DtArchObjHierarchy | undefined;
}

export interface FmIncident {
    incidentId?: string | undefined;
    name: string;
    caseOriginCode?: string | undefined;
    caseOriginCodeId?: string | undefined;
    archObjId?: string | undefined;
    techObjId?: string | undefined;
    description?: string | undefined;
    routingTypeId?: string | undefined;
    masterIncidentId?: string | undefined;
    ticketNumber?: string | undefined;
    externalReference?: string | undefined;
    reasonForComplaint?: string | undefined;
    incidentOrigin?: string | undefined;
    incidentOriginId?: string | undefined;
    incidentTypeId?: string | undefined;
    externalResponse?: string | undefined;
    externalCompletion?: Date | undefined;
    additionalInformationOrComments?: string | undefined;
    status?: string | undefined;
    statusId?: string | undefined;
    statusReason?: string | undefined;
    statusReasonId?: string | undefined;
    incidentPriorty?: string | undefined;
    incidentPriorityId?: string | undefined;
    parentIncidentId?: string | undefined;
    changeDate?: Date | undefined;
    costCenterId?: string | undefined;
    incidentClassId?: string | undefined;
    sla?: string | undefined;
    agreementId?: string | undefined;
    setReminder?: boolean | undefined;
    reminderDate?: Date | undefined;
    rentalUnitConnectionId?: string | undefined;
    rentalUnitId?: string | undefined;
    terminatedTo?: Date | undefined;
    recordingRentalDefect?: Date | undefined;
    rentalContractId?: string | undefined;
    acceptanceDate?: Date | undefined;
    terminationReceived?: Date | undefined;
    terminationFrom?: Date | undefined;
    processor?: string | undefined;
    alternateCity?: string | undefined;
    alternatePostalCode?: string | undefined;
    alternateStateProvince?: string | undefined;
    alternateStreet?: string | undefined;
    echeckNecessary?: boolean | undefined;
    keepBuildingStrategically?: boolean | undefined;
    preparationNecessaryId?: string | undefined;
    property?: boolean | undefined;
    adJoiningProperty?: boolean | undefined;
    commissionMarketingLight?: boolean | undefined;
    commonNeedsId?: string | undefined;
    companyResidenceId?: string | undefined;
    separationCosts?: number | undefined;
    preparationTicketAvailable?: boolean | undefined;
    pricePerSquareMeter?: number | undefined;
    _111costs?: number | undefined;
    setUpCosts?: number | undefined;
    descriptionSetUpCosts?: string | undefined;
    marketingTypeId?: string | undefined;
    rentalContractChecked?: boolean | undefined;
    separationConceptId?: string | undefined;
    lettingDecisionId?: string | undefined;
    lettingDecisionConfirmation?: boolean | undefined;
    lettingDecisionConfirmationFromId?: string | undefined;
    interestedPartyCancel?: boolean | undefined;
    stateOrProvince?: string | undefined;
    plotNumber?: string | undefined;
    deadline?: Date | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    miscellaneousIncidentClass?: string | undefined;
    street?: string | undefined;
    powerOfDispositionId?: string | undefined;
    rentalSpace?: number | undefined;
    orderSheetCreate?: boolean | undefined;
    releaseRentalUnitFromId?: string | undefined;
    profitable?: string | undefined;
    informAboutMarketing?: boolean | undefined;
    setupCostsRenter?: number | undefined;
    startActivities?: boolean | undefined;
    initiateRenegotiationId?: string | undefined;
    uploadRentalContract?: boolean | undefined;
    rentalUnitHandedOver?: boolean | undefined;
    incidentToTenderId?: string | undefined;
    customerBudgetId?: string | undefined;
    maintask?: string | undefined;
    requestType?: string | undefined;
    requestTypeId?: string | undefined;
    paybackPeriod?: number | undefined;
    organisationId?: string | undefined;
    contactId?: string | undefined;
    primaryContactId?: string | undefined;
    responsibleContactId?: string | undefined;
    interestedpartyId?: string | undefined;
    notifyingContactId?: string | undefined;
    additionalContactId?: string | undefined;
    propertyBrochureId?: string | undefined;
    propertyBrochureAvailabilityId?: string | undefined;
    isRenterChecked?: boolean | undefined;
    internalTicketNumber?: string | undefined;
    createdOn?: Date | undefined;
    rentalContractStartDate?: Date | undefined;
    arrivalDate?: Date | undefined;
    rentalContractEndDate?: Date | undefined;
    contactPreferences?: string | undefined;
    incidentGradingId?: string | undefined;
    deleteDate?: Date | undefined;
    accessPermit?: boolean | undefined;
    estimatedCosts?: number | undefined;
    profitableId?: string | undefined;
    facilityManagementProcessStatusId?: string | undefined;
    preferredTimeWindowStart?: Date | undefined;
    preferredTimeWindowEnd?: Date | undefined;
    notary?: boolean | undefined;
    additionalCostsElectricity?: number | undefined;
    additionalCostsHeating?: number | undefined;
    additionalCostsOperation?: number | undefined;
    commentIssOrderForm?: string | undefined;
    energyCertificationAvailableId?: string | undefined;
    fireProtectionId?: string | undefined;
    layoutId?: string | undefined;
    pollutantsId?: string | undefined;
    prospectiveTenants?: string | undefined;
    quantityCounterElectricityId?: string | undefined;
    quantityCounterHeatingId?: string | undefined;
    quantityCounterWaterId?: string | undefined;
    roofSubjectId?: string | undefined;
    setupRenterDecisionId?: string | undefined;
    technicalBuildingEquipmentId?: string | undefined;
    exploratoryInterviewConductedId?: string | undefined;
    exploratoryTalkResult?: string | undefined;
    gksForPreparationIncludingSecurity?: number | undefined;
    gksPreparationUploadedId?: string | undefined;
    specificationsForExploratoryTalks?: string | undefined;
    uploadLegalMatrixId?: string | undefined;
    releaseRentalUnitId?: string | undefined;
    requestDeclinableId?: string | undefined;
    supervisionNecessaryId?: string | undefined;
    dtagResponsibility?: string | undefined;
    source?: string | undefined;
    bguStatus?: string | undefined;
    gksSeparationIncludingSecurity?: number | undefined;
    gksSeparationUploadedId?: string | undefined;
    projectNumberBgu?: string | undefined;
    gksSeparationUploaded?: string | undefined;
    externalTransmissionStatusId?: string | undefined;
    externalTransmissionMessage?: string | undefined;
    incidentClassChanged?: boolean;
    businessUnitId?: string | undefined;
    ciamId?: string | undefined;
    approvalRejectionId?: string | undefined;
    clientContactId?: string | undefined;
    documentExaminationId?: string | undefined;
    examinationImpairmentId?: string | undefined;
    finalTaskNemoId?: string | undefined;
    landRegisterNotificationAcceptableId?: string | undefined;
    needForActionAfterExaminationId?: string | undefined;
    needJustifiedId?: string | undefined;
    commissioningIssId?: string | undefined;
    communicateDecisionNeighbourhoodAgreementId?: string | undefined;
    directNeedForActionId?: string | undefined;
    productId?: string | undefined;
    numberOfInitialDocuments?: number | undefined;
    interfaceStateId?: string | undefined;
    additionalContact?: OmContact | undefined;
    agreement?: FmAgreement | undefined;
    approvalRejection?: SysEnum | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    businessUnit?: OmBusinessUnit | undefined;
    caseOriginCodeNavigation?: SysEnum | undefined;
    clientContact?: SysEnum | undefined;
    commissioningIss?: SysEnum | undefined;
    commonNeeds?: SysEnum | undefined;
    communicateDecisionNeighbourhoodAgreement?: SysEnum | undefined;
    companyResidence?: SysEnum | undefined;
    contact?: OmContact | undefined;
    costCenter?: FiCostCenter | undefined;
    directNeedForAction?: SysEnum | undefined;
    documentExamination?: SysEnum | undefined;
    energyCertificationAvailable?: SysEnum | undefined;
    examinationImpairment?: SysEnum | undefined;
    exploratoryInterviewConducted?: SysEnum | undefined;
    externalTransmissionStatus?: SysEnum | undefined;
    facilityManagementProcessStatus?: SysEnum | undefined;
    finalTaskNemo?: SysEnum | undefined;
    fireProtection?: SysEnum | undefined;
    fmApproval?: FmApproval[] | undefined;
    fmAreaRequest?: FmAreaRequest | undefined;
    fmAreaReturn?: FmAreaReturn | undefined;
    fmBasicServiceChange?: FmBasicServiceChange | undefined;
    fmBguProject?: FmBguProject | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmGeneralRequest?: FmGeneralRequest | undefined;
    fmIncidentCategoryValue?: FmIncidentCategoryValue[] | undefined;
    fmIncidentContactRole?: FmIncidentContactRole[] | undefined;
    fmIncidentIncidentSecState?: FmIncidentIncidentSecState[] | undefined;
    fmIncidentOffer?: FmIncidentOffer[] | undefined;
    fmIncidentOrganisationRole?: FmIncidentOrganisationRole[] | undefined;
    fmOmvTicket?: FmOmvTicket[] | undefined;
    fmOrderingFurniture?: FmOrderingFurniture | undefined;
    fmQuote?: FmQuote[] | undefined;
    fmRelocation?: FmRelocation | undefined;
    fmServiceRequest?: FmServiceRequest | undefined;
    fmTask?: FmTask[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
    gksPreparationUploaded?: SysEnum | undefined;
    gksSeparationUploadedNavigation?: SysEnum | undefined;
    incidentClass?: FmIncidentClass | undefined;
    incidentGrading?: FmIncidentGrading | undefined;
    incidentOriginNavigation?: SysEnum | undefined;
    incidentPriority?: SysEnum | undefined;
    incidentToTender?: SysEnum | undefined;
    incidentTransmission?: IncidentTransmission[] | undefined;
    incidentType?: FmIncidentType | undefined;
    initiateRenegotiation?: SysEnum | undefined;
    interestedparty?: OmContact | undefined;
    interfaceState?: SysEnum | undefined;
    inverseMasterIncident?: FmIncident[] | undefined;
    inverseParentIncident?: FmIncident[] | undefined;
    landRegisterNotificationAcceptable?: SysEnum | undefined;
    layout?: SysEnum | undefined;
    lettingDecision?: SysEnum | undefined;
    lettingDecisionConfirmationFrom?: OmSystemUser | undefined;
    marketingType?: SysEnum | undefined;
    masterIncident?: FmIncident | undefined;
    needForActionAfterExamination?: SysEnum | undefined;
    needJustified?: SysEnum | undefined;
    notifyingContact?: OmContact | undefined;
    omIncidentUserAdministration?: OmIncidentUserAdministration | undefined;
    organisation?: OmOrganisation | undefined;
    parentIncident?: FmIncident | undefined;
    pmIncidentExternalLetting?: PmIncidentExternalLetting | undefined;
    pmIncidentRealEstateDecision?: PmIncidentRealEstateDecision | undefined;
    pmIncidentRentalContractMgmtBguDismantlingsTicket?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBguEmtTicket?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBguPreparationTicket?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBguSeparationTicket?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtBguTicket?: PmIncidentRentalContractMgmt[] | undefined;
    pmIncidentRentalContractMgmtIdNavigation?: PmIncidentRentalContractMgmt | undefined;
    pollutants?: SysEnum | undefined;
    powerOfDisposition?: SysEnum | undefined;
    primaryContact?: OmContact | undefined;
    product?: FmProduct | undefined;
    profitableNavigation?: SysEnum | undefined;
    propertyBrochure?: PmPropertyBrochure | undefined;
    propertyBrochureAvailability?: PmPropertyBrochureAvailability | undefined;
    quantityCounterElectricity?: SysEnum | undefined;
    quantityCounterHeating?: SysEnum | undefined;
    quantityCounterWater?: SysEnum | undefined;
    releaseRentalUnit?: SysEnum | undefined;
    releaseRentalUnitFrom?: OmSystemUser | undefined;
    rentalContract?: PmRentalContract | undefined;
    rentalUnit?: PmRentalUnit | undefined;
    rentalUnitConnection?: PmRentalUnit | undefined;
    requestDeclinable?: SysEnum | undefined;
    requestTypeNavigation?: SysEnum | undefined;
    responsibleContact?: OmContact | undefined;
    roofSubject?: SysEnum | undefined;
    routingType?: FmRoutingType | undefined;
    sapIncidentOrder?: SapIncidentOrder[] | undefined;
    sapIssTicketData?: SapIssTicketData | undefined;
    separationConcept?: SysEnum | undefined;
    setupRenterDecision?: SysEnum | undefined;
    slaNavigation?: FmSla | undefined;
    statusNavigation?: SysEnum | undefined;
    statusReasonNavigation?: SysEnum | undefined;
    supervisionNecessary?: SysEnum | undefined;
    techObj?: DtTechObjHierarchy | undefined;
    technicalBuildingEquipment?: SysEnum | undefined;
    uploadLegalMatrix?: SysEnum | undefined;
}

export interface OmContact {
    contactId?: string | undefined;
    salutation?: string | undefined;
    jobTitle?: string | undefined;
    firstName?: string | undefined;
    lastName: string;
    email?: string | undefined;
    telephone?: string | undefined;
    fax?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    organisationId?: string | undefined;
    mobilePhone?: string | undefined;
    nationalityId?: string | undefined;
    isRenter?: string | undefined;
    gender?: string | undefined;
    preferredContactMethod?: string | undefined;
    preferredContactMethodId?: string | undefined;
    preferredLanguageId?: string | undefined;
    familyStatus?: string | undefined;
    spousesName?: string | undefined;
    birthDate?: Date | undefined;
    anniversary?: Date | undefined;
    doNotSendMm?: boolean;
    creditLimit?: number | undefined;
    creditOnHold?: boolean;
    paymentTerms?: string | undefined;
    shippingMethod?: string | undefined;
    freightTerms?: string | undefined;
    changeDate?: Date | undefined;
    notifyingContact?: string | undefined;
    complianceGuidelinesApprovedOn?: Date | undefined;
    consentDigitalSignature?: boolean | undefined;
    deleteDate?: Date | undefined;
    entityImage?: string | undefined;
    contactFormStreet?: string | undefined;
    contactFormPostalcode?: string | undefined;
    contactFormCity?: string | undefined;
    contactFormState?: string | undefined;
    source?: string | undefined;
    prospectPoolRegistrationOn?: Date | undefined;
    fmBookableRessource?: FmBookableRessource[] | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmIncidentAdditionalContact?: FmIncident[] | undefined;
    fmIncidentContact?: FmIncident[] | undefined;
    fmIncidentContactRole?: FmIncidentContactRole[] | undefined;
    fmIncidentInterestedparty?: FmIncident[] | undefined;
    fmIncidentNotifyingContact?: FmIncident[] | undefined;
    fmIncidentPrimaryContact?: FmIncident[] | undefined;
    fmIncidentResponsibleContact?: FmIncident[] | undefined;
    fmOrderInquiry?: FmOrderInquiry[] | undefined;
    fmQuote?: FmQuote[] | undefined;
    fmServiceRequest?: FmServiceRequest[] | undefined;
    fmTaskExternalProcessor?: FmTask[] | undefined;
    fmTaskModifiedByPortal?: FmTask[] | undefined;
    fmWorkOrderContactOnSite?: FmWorkOrder[] | undefined;
    fmWorkOrderReportedByContact?: FmWorkOrder[] | undefined;
    fmWorkOrderReporter?: FmWorkOrder[] | undefined;
    nationality?: SysEnum | undefined;
    omContactAddress?: OmContactAddress[] | undefined;
    omContactArchObjRole?: OmContactArchObjRole[] | undefined;
    omContactAuthorization?: OmContactAuthorization[] | undefined;
    omContactRole?: OmContactRole[] | undefined;
    omCustomer?: OmCustomer[] | undefined;
    omIncidentUserAdministrationContact?: OmIncidentUserAdministration[] | undefined;
    omIncidentUserAdministrationCreatorContact?: OmIncidentUserAdministration[] | undefined;
    omOrganisation?: OmOrganisation[] | undefined;
    omUserArchObjHierarchy?: OmUserArchObjHierarchy[] | undefined;
    organisation?: OmOrganisation | undefined;
    pmIncidentExternalLetting?: PmIncidentExternalLetting[] | undefined;
    pmRentalContract?: PmRentalContract[] | undefined;
    pmRentalContractContactRole?: PmRentalContractContactRole[] | undefined;
    preferredContactMethodNavigation?: SysEnum | undefined;
    preferredLanguage?: SysEnum | undefined;
}

export interface FmBookableRessource {
    bookableResourceId?: string | undefined;
    resourceType?: string | undefined;
    name?: string | undefined;
    startLocation?: string | undefined;
    endLocation?: string | undefined;
    displayOnScheduleBoard?: boolean | undefined;
    organisationalUnitId?: string | undefined;
    hourlyRate?: number | undefined;
    primaryEmail?: string | undefined;
    displayOnScheduleAssistant?: boolean | undefined;
    contactId?: string | undefined;
    accountId?: string | undefined;
    calendarId?: string | undefined;
    poolType?: string | undefined;
    hourlyRateBase?: number | undefined;
    deriveCapacity?: boolean | undefined;
    deleteDate?: Date | undefined;
    userId?: string | undefined;
    account?: OmOrganisation | undefined;
    contact?: OmContact | undefined;
    fmBookableResourceBookableResourceChildBookableResource?: FmBookableResourceBookableResource[] | undefined;
    fmBookableResourceBookableResourceParentBookableResource?: FmBookableResourceBookableResource[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
    organisationalUnit?: OmOrganisationalUnit | undefined;
    user?: OmSystemUser | undefined;
}

export interface FmBookableResourceBookableResource {
    id?: string | undefined;
    name: string;
    parentBookableResourceId: string;
    childBookableResourceId: string;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    childBookableResource?: FmBookableRessource | undefined;
    parentBookableResource?: FmBookableRessource | undefined;
}

export interface FmWorkOrder {
    workOrderId?: string | undefined;
    name: string;
    workOrderTitle?: string | undefined;
    externalServiceProviderId?: string | undefined;
    primaryIncidentType?: string | undefined;
    maintenanceConfirmation?: string | undefined;
    tender?: string | undefined;
    projectId?: string | undefined;
    isAuthorized?: boolean | undefined;
    authorizedDate?: string | undefined;
    internalExternal?: string | undefined;
    frameworkAgreementId?: string | undefined;
    alternateKey?: string | undefined;
    customerAssetId?: string | undefined;
    createdBy?: string | undefined;
    authorizerId?: string | undefined;
    authorizedBy?: string | undefined;
    changeDate?: Date | undefined;
    incidentId?: string | undefined;
    workOrderType?: string | undefined;
    locationId?: string | undefined;
    orderConfirmation?: string | undefined;
    dateWindowStart?: Date | undefined;
    dateWindowEnd?: Date | undefined;
    serviceAccountId?: string | undefined;
    firstArrivedAt?: Date | undefined;
    externalReference?: string | undefined;
    totalAmount?: number | undefined;
    primaryIncidentEstimatedDuration?: number | undefined;
    totalEstimatedDuration?: number | undefined;
    estimatedSubtotalAmount?: number | undefined;
    parentWorkOrderId?: string | undefined;
    agreementId?: string | undefined;
    transactionCurrency?: string | undefined;
    timeToPromised?: Date | undefined;
    timeFromPromised?: Date | undefined;
    timeWindowStart?: Date | undefined;
    timeWindowEnd?: Date | undefined;
    subTotalAmount?: number | undefined;
    systemstatus?: string | undefined;
    substatus?: string | undefined;
    workOrderSummary?: string | undefined;
    completedAt?: Date | undefined;
    billingAccountId?: string | undefined;
    timeClosed?: Date | undefined;
    workLocation?: string | undefined;
    priceListId?: string | undefined;
    primaryIncidentDescription?: string | undefined;
    bookingSummary?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    district?: string | undefined;
    orderType?: string | undefined;
    bookableRessourceId?: string | undefined;
    organisationalUnitId?: string | undefined;
    reporterId?: string | undefined;
    createdOn?: Date | undefined;
    deleteDate?: Date | undefined;
    accessPermit?: boolean | undefined;
    tenantWasPresent?: boolean | undefined;
    reportedByContactId?: string | undefined;
    contactOnSiteId?: string | undefined;
    bookingStart?: Date | undefined;
    bookingEnd?: Date | undefined;
    feedback?: string | undefined;
    feedbackFollowUpJob?: string | undefined;
    rejectionReason?: string | undefined;
    agreement?: FmAgreement | undefined;
    authorizedByNavigation?: OmSystemUser | undefined;
    authorizer?: OmSystemUser | undefined;
    billingAccount?: OmOrganisation | undefined;
    bookableRessource?: FmBookableRessource | undefined;
    contactOnSite?: OmContact | undefined;
    createdByNavigation?: OmSystemUser | undefined;
    customerAsset?: DtTechObjHierarchy | undefined;
    externalServiceProvider?: OmOrganisation | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmOrderInquiry?: FmOrderInquiry[] | undefined;
    fmWorkOrderMilestone?: FmWorkOrderMilestone[] | undefined;
    fmWorkOrderProduct?: FmWorkOrderProduct[] | undefined;
    fmWorkOrderService?: FmWorkOrderService[] | undefined;
    fmWorkOrderServiceTask?: FmWorkOrderServiceTask[] | undefined;
    frameworkAgreement?: FmFrameworkAgreement | undefined;
    incident?: FmIncident | undefined;
    inverseParentWorkOrder?: FmWorkOrder[] | undefined;
    location?: DtArchObjHierarchy | undefined;
    organisationalUnit?: OmOrganisationalUnit | undefined;
    parentWorkOrder?: FmWorkOrder | undefined;
    priceList?: FmPriceList | undefined;
    primaryIncidentTypeNavigation?: FmIncidentType | undefined;
    project?: FmProject | undefined;
    reportedByContact?: OmContact | undefined;
    reporter?: OmContact | undefined;
    serviceAccount?: OmOrganisation | undefined;
    workOrderTypeNavigation?: FmWorkOrderType | undefined;
}

export interface FmAgreement {
    agreementId?: string | undefined;
    agreementNumber?: string | undefined;
    serviceAccount: string;
    billingAccount?: string | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    duration?: number;
    originatingAgreement?: string | undefined;
    agreementDetails?: string | undefined;
    agreementRecordGeneration?: Date | undefined;
    taxable?: boolean;
    salesTaxCode?: string | undefined;
    dateCancelled?: Date | undefined;
    deleteDate?: Date | undefined;
    billingAccountNavigation?: OmOrganisation | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
    inverseOriginatingAgreementNavigation?: FmAgreement[] | undefined;
    originatingAgreementNavigation?: FmAgreement | undefined;
    serviceAccountNavigation?: OmOrganisation | undefined;
}

export interface OmSystemUser {
    systemUserId?: string | undefined;
    domainName?: string | undefined;
    firstName?: string | undefined;
    lastName: string;
    title?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    siteId?: string | undefined;
    territoryId?: string | undefined;
    businessUnitId?: string | undefined;
    deleteDate?: Date | undefined;
    businessUnit?: OmBusinessUnit | undefined;
    fmBookableRessource?: FmBookableRessource[] | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmIncidentLettingDecisionConfirmationFrom?: FmIncident[] | undefined;
    fmIncidentReleaseRentalUnitFrom?: FmIncident[] | undefined;
    fmWorkOrderAuthorizedByNavigation?: FmWorkOrder[] | undefined;
    fmWorkOrderAuthorizer?: FmWorkOrder[] | undefined;
    fmWorkOrderCreatedByNavigation?: FmWorkOrder[] | undefined;
    omIncidentUserAdministration?: OmIncidentUserAdministration[] | undefined;
    omUserArchObjHierarchy?: OmUserArchObjHierarchy[] | undefined;
    pmIncidentExternalLettingLettingDecisionConfirmationFrom?: PmIncidentExternalLetting[] | undefined;
    pmIncidentExternalLettingRentalContractCheckedFrom?: PmIncidentExternalLetting[] | undefined;
    pmRentalContractFirstSignee?: PmRentalContract[] | undefined;
    pmRentalContractOwner?: PmRentalContract[] | undefined;
    pmRentalContractSecondSignee?: PmRentalContract[] | undefined;
    site?: DtSite | undefined;
}

export interface OmBusinessUnit {
    businessUnitId?: string | undefined;
    name?: string | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmTask?: FmTask[] | undefined;
    omSystemUser?: OmSystemUser[] | undefined;
}

export interface FmTask {
    taskId?: string | undefined;
    isActive?: boolean | undefined;
    dueDays?: number | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    result?: string | undefined;
    status?: string | undefined;
    dueDate?: Date | undefined;
    configurationTaskId?: string | undefined;
    incidentId?: string | undefined;
    organisationId?: string | undefined;
    deleteDate?: Date | undefined;
    externalProcessorId?: string | undefined;
    feedbackPortal?: string | undefined;
    modifiedByPortalId?: string | undefined;
    businessUnitId?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    businessUnit?: OmBusinessUnit | undefined;
    configurationTask?: FmConfigurationTask | undefined;
    externalProcessor?: OmContact | undefined;
    fmDocument?: FmDocument[] | undefined;
    incident?: FmIncident | undefined;
    modifiedByPortal?: OmContact | undefined;
    organisation?: OmOrganisation | undefined;
}

export interface FmConfigurationTask {
    configurationTaskId?: string | undefined;
    isActive?: boolean | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    incidentClassId?: string | undefined;
    priorityCode?: string | undefined;
    dueDays?: number | undefined;
    accountId?: string | undefined;
    sendToPortal?: boolean | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    defaultDocumentTypeId?: string | undefined;
    version?: number | undefined;
    sequence?: number | undefined;
    account?: OmOrganisation | undefined;
    defaultDocumentType?: FmDocumentType | undefined;
    fmConfigurationRow?: FmConfigurationRow[] | undefined;
    fmConfigurationTaskDocumentType?: FmConfigurationTaskDocumentType[] | undefined;
    fmTask?: FmTask[] | undefined;
    incidentClass?: FmIncidentClass | undefined;
}

export interface FmDocumentType {
    documentTypeId?: string | undefined;
    abbreviation?: string | undefined;
    name?: string | undefined;
    externalCode?: string | undefined;
    gefmaCode?: string | undefined;
    deleteDate?: Date | undefined;
    isExternal?: boolean;
    maxFileSizeInBytes?: number;
    abbreviationText?: string | undefined;
    usage?: string | undefined;
    fmConfigurationTask?: FmConfigurationTask[] | undefined;
    fmConfigurationTaskDocumentType?: FmConfigurationTaskDocumentType[] | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmDocumentTypeContentType?: FmDocumentTypeContentType[] | undefined;
    fmIncidentClassDocumentType?: FmIncidentClassDocumentType[] | undefined;
    gefmaCodeNavigation?: FmGefmaCode | undefined;
}

export interface FmConfigurationTaskDocumentType {
    configurationTaskId?: string | undefined;
    documentTypeId?: string | undefined;
    createDate?: Date;
    configurationTask?: FmConfigurationTask | undefined;
    documentType?: FmDocumentType | undefined;
}

export interface FmDocumentTypeContentType {
    documentTypeId?: string | undefined;
    contentType?: string | undefined;
    documentType?: FmDocumentType | undefined;
}

export interface FmIncidentClassDocumentType {
    incidentClassId?: string | undefined;
    documentTypeId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    documentType?: FmDocumentType | undefined;
    incidentClass?: FmIncidentClass | undefined;
}

export interface FmIncidentClass {
    incidentClassId?: string | undefined;
    incidentClass: string;
    incidentType: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    securityRole?: string | undefined;
    fmConfigurationTask?: FmConfigurationTask[] | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmIncidentClassDocumentType?: FmIncidentClassDocumentType[] | undefined;
    product?: FmProduct[] | undefined;
}

export interface FmProduct {
    productId?: string | undefined;
    segment?: string | undefined;
    name: string;
    description: string;
    contingent?: boolean;
    sachkonto?: number | undefined;
    fmIfmMaterial?: FmIfmMaterial[] | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmProductBilling?: FmProductBilling[] | undefined;
    fmWorkOrderProduct?: FmWorkOrderProduct[] | undefined;
    fmWorkOrderService?: FmWorkOrderService[] | undefined;
    productMaterialClass?: ProductMaterialClass | undefined;
    sapInvoiceVerification?: SapInvoiceVerification[] | undefined;
    wbsMapping?: WbsMapping[] | undefined;
    incidentClass?: FmIncidentClass[] | undefined;
}

export interface FmIfmMaterial {
    produkt: string;
    material?: string | undefined;
    name: string;
    default?: boolean | undefined;
    selectable?: boolean | undefined;
    produktNavigation?: FmProduct | undefined;
}

export interface FmProductBilling {
    productId?: string | undefined;
    year?: number;
    pspElement: string;
    pspElementKontingent?: string | undefined;
    ebeln?: string | undefined;
    innenauftragsnummer?: number;
    innenauftragsname: string;
    budgetart?: string | undefined;
    product?: FmProduct | undefined;
}

export interface FmWorkOrderProduct {
    id?: string | undefined;
    name: string;
    estimatedQuantity?: number | undefined;
    unitId: string;
    estimatedTotalAmount?: number | undefined;
    productId: string;
    workOrderId: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    product?: FmProduct | undefined;
    unit?: FmUnit | undefined;
    workOrder?: FmWorkOrder | undefined;
}

export interface FmUnit {
    unitId?: string | undefined;
    name?: string | undefined;
    quantity?: number | undefined;
    baseUnitId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    baseUnit?: FmUnit | undefined;
    fmQuoteDetail?: FmQuoteDetail[] | undefined;
    fmWorkOrderProduct?: FmWorkOrderProduct[] | undefined;
    fmWorkOrderService?: FmWorkOrderService[] | undefined;
    inverseBaseUnit?: FmUnit[] | undefined;
}

export interface FmQuoteDetail {
    quoteDetailId?: string | undefined;
    name: string;
    quoteId?: string | undefined;
    orderInquiryPositionId?: string | undefined;
    isProductOverridden?: boolean | undefined;
    unitId?: string | undefined;
    productId?: string | undefined;
    productDescription?: string | undefined;
    isPriceOverridden?: boolean | undefined;
    pricePerUnit?: number | undefined;
    volumeDiscount?: number | undefined;
    quantity?: number | undefined;
    baseAmount?: number | undefined;
    manualDiscount?: number | undefined;
    tax?: number | undefined;
    totalAmount?: number | undefined;
    posNo?: number | undefined;
    deleteDate?: Date | undefined;
    orderInquiryPosition?: FmOrderInquiryPosition | undefined;
    quote?: FmQuote | undefined;
    unit?: FmUnit | undefined;
}

export interface FmOrderInquiryPosition {
    orderInquiryPositionId?: string | undefined;
    name: string;
    description?: string | undefined;
    comments?: string | undefined;
    noOffer?: boolean | undefined;
    price?: number | undefined;
    orderInquiryId: string;
    amount?: number | undefined;
    unit?: string | undefined;
    materialProductService?: string | undefined;
    changeDate?: Date | undefined;
    status?: string | undefined;
    statusReason?: string | undefined;
    linePosition?: number | undefined;
    deleteDate?: Date | undefined;
    fmQuoteDetail?: FmQuoteDetail[] | undefined;
    orderInquiry?: FmOrderInquiry | undefined;
}

export interface FmOrderInquiry {
    orderInquiryId?: string | undefined;
    name: string;
    orderId?: string | undefined;
    submitOrderRequest?: string | undefined;
    type?: string | undefined;
    workOrderId?: string | undefined;
    changeDate?: Date | undefined;
    validity?: Date | undefined;
    totalOfferPossible?: boolean | undefined;
    totalOfferPrice?: number | undefined;
    acceptOrderInquiry?: boolean | undefined;
    orderInquiryActiveInPortal?: boolean | undefined;
    description?: string | undefined;
    purchaseProjectId?: string | undefined;
    serviceCompanyId?: string | undefined;
    frameworkAgreementId?: string | undefined;
    initialOfferReceived?: boolean | undefined;
    functionalLocationId?: string | undefined;
    comments?: string | undefined;
    offerValidUntil?: Date | undefined;
    externalOfferId?: string | undefined;
    responsibleContactId?: string | undefined;
    deviatingContactName?: string | undefined;
    deviatingContactEmail?: string | undefined;
    deviatingContactTelephone?: string | undefined;
    earliestStartDate?: Date | undefined;
    latestEndDate?: Date | undefined;
    status?: string | undefined;
    statusReason?: string | undefined;
    deleteDate?: Date | undefined;
    fmOrderInquiryPosition?: FmOrderInquiryPosition[] | undefined;
    fmPurchaseOrder?: FmPurchaseOrder[] | undefined;
    frameworkAgreement?: FmFrameworkAgreement | undefined;
    functionalLocation?: DtArchObjHierarchy | undefined;
    order?: FmPurchaseOrder | undefined;
    purchaseProject?: FmProject | undefined;
    responsibleContact?: OmContact | undefined;
    serviceCompany?: OmOrganisation | undefined;
    workOrder?: FmWorkOrder | undefined;
}

export interface FmPurchaseOrder {
    purchaseOrderId?: string | undefined;
    gu: string;
    template: string;
    budgetType?: string | undefined;
    priorityCodeNemo: string;
    auxillaryAssignment: string;
    functionalLocation: string;
    name: string;
    estimatedBudget?: number;
    purchaseOrderType: string;
    alternateKey?: string | undefined;
    sendPurchaseOrder?: boolean;
    orderInquiry?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmOrderInquiry?: FmOrderInquiry[] | undefined;
    orderInquiryNavigation?: FmOrderInquiry | undefined;
}

export interface FmFrameworkAgreement {
    frameworkAgreementId?: string | undefined;
    name: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmOrderInquiry?: FmOrderInquiry[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
}

export interface FmProject {
    projectId?: string | undefined;
    name?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    fmOrderInquiry?: FmOrderInquiry[] | undefined;
    fmProjectMilestone?: FmProjectMilestone[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
}

export interface FmProjectMilestone {
    projectId?: string | undefined;
    milestoneNo?: number;
    fixedDate?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    project?: FmProject | undefined;
}

export interface FmQuote {
    quoteId?: string | undefined;
    name: string;
    orderInquiry?: string | undefined;
    incident?: string | undefined;
    sla?: string | undefined;
    quoteNumber?: string | undefined;
    alternateKey?: string | undefined;
    changeDate?: Date | undefined;
    billingAddressCity?: string | undefined;
    billingAddressContactName?: string | undefined;
    billingAddressCountry?: string | undefined;
    billingAddressStreet1?: string | undefined;
    billingAddressStreet2?: string | undefined;
    billingAddressName?: string | undefined;
    billingAddressPostalCode?: string | undefined;
    billingAddressStateOrProvince?: string | undefined;
    billingAddressPhone?: string | undefined;
    closedOn?: Date | undefined;
    contactId?: string | undefined;
    customerId?: string | undefined;
    description?: string | undefined;
    discount?: number | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    totalAmount?: number | undefined;
    termsOfPaymentCode?: string | undefined;
    priceListId?: string | undefined;
    revisionNumber?: number | undefined;
    status?: string | undefined;
    statusReason?: string | undefined;
    netAmount?: number | undefined;
    tax?: number | undefined;
    versionNumber?: number | undefined;
    reasonForRejection?: string | undefined;
    deleteDate?: Date | undefined;
    contact?: OmContact | undefined;
    customer?: OmOrganisation | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmQuoteDetail?: FmQuoteDetail[] | undefined;
    incidentNavigation?: FmIncident | undefined;
    priceList?: FmPriceList | undefined;
    slaNavigation?: FmSla | undefined;
}

export interface FmPriceList {
    priceListId?: string | undefined;
    name: string;
    deleteDate?: Date | undefined;
    fmQuote?: FmQuote[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
    fmWorkOrderType?: FmWorkOrderType[] | undefined;
}

export interface FmWorkOrderType {
    workOrderTypeId?: string | undefined;
    name?: string | undefined;
    importSequenceNumber?: string | undefined;
    priceListId?: string | undefined;
    taxable?: boolean | undefined;
    deleteDate?: Date | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
    priceList?: FmPriceList | undefined;
}

export interface FmSla {
    slaId?: string | undefined;
    description: string;
    allowePauseResume?: boolean | undefined;
    slaType?: string | undefined;
    applicableFrom?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmQuote?: FmQuote[] | undefined;
}

export interface FmWorkOrderService {
    id?: string | undefined;
    name: string;
    estimatedDurationMinutes?: number | undefined;
    unitId: string;
    estimatedTotalAmount?: number | undefined;
    serviceId: string;
    workOrderId: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    service?: FmProduct | undefined;
    unit?: FmUnit | undefined;
    workOrder?: FmWorkOrder | undefined;
}

export interface ProductMaterialClass {
    productId?: string | undefined;
    materialClass: string;
    product?: FmProduct | undefined;
}

export interface SapInvoiceVerification {
    id?: string | undefined;
    serviceRequestId: string;
    externalId?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    workTaskId?: string | undefined;
    invoiceNumber?: string | undefined;
    netValue?: number | undefined;
    productId?: string | undefined;
    completionDate?: Date | undefined;
    currency?: string | undefined;
    invoiceTypeId?: string | undefined;
    invoiceDate?: Date | undefined;
    vatType?: string | undefined;
    additionalCostsKey?: string | undefined;
    createDate?: Date | undefined;
    location?: string | undefined;
    invoiceType?: SysEnum | undefined;
    product?: FmProduct | undefined;
    serviceRequest?: FmServiceRequest | undefined;
}

export interface FmServiceRequest {
    id?: string | undefined;
    deviatingAddress?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    structuralPart?: string | undefined;
    contactId?: string | undefined;
    completionDate?: Date | undefined;
    creatorId: string;
    statusId?: string | undefined;
    currentEditorId?: string | undefined;
    desiredDateBegin?: Date | undefined;
    desiredDateEnd?: Date | undefined;
    initialAssignment?: boolean | undefined;
    quantity?: number | undefined;
    startDate?: Date | undefined;
    value?: number | undefined;
    workTaskId?: string | undefined;
    budgetAssignment?: string | undefined;
    budgetAssignmentComment?: string | undefined;
    containerSize?: string | undefined;
    createDate?: Date | undefined;
    deliveryDate?: Date | undefined;
    owner?: number | undefined;
    equipmentId?: string | undefined;
    garbageType?: string | undefined;
    invoiceValue?: number | undefined;
    offerValue?: number | undefined;
    orderValue?: number | undefined;
    partialEstimateInvoice?: boolean | undefined;
    pickupDate?: Date | undefined;
    projectedDate?: Date | undefined;
    sapOrderId?: string | undefined;
    serviceAcceptanceComment?: string | undefined;
    serviceAcceptanceDate?: Date | undefined;
    serviceAcceptanceUserId?: string | undefined;
    useDummyEconomicUnit?: boolean | undefined;
    volumeType?: string | undefined;
    nbrRequestedKeys?: number | undefined;
    interfaceStateId?: string | undefined;
    approvalType?: string | undefined;
    approvalText?: string | undefined;
    approvalReviewId?: string | undefined;
    requestId?: string | undefined;
    categoryValueId?: string | undefined;
    numberKw?: number | undefined;
    periodFrom?: Date | undefined;
    timeSlot?: string | undefined;
    timeSlotUntil?: string | undefined;
    addendum?: number | undefined;
    resultServiceAcceptanceId?: string | undefined;
    invoiceTypeId?: string | undefined;
    limited?: boolean | undefined;
    approvalId?: string | undefined;
    contactPersonId?: string | undefined;
    contactPersonEmployeeId?: string | undefined;
    coordinationWorksCouncil?: boolean | undefined;
    coordinationRegionalFm?: boolean | undefined;
    destination?: string | undefined;
    formInternal?: boolean | undefined;
    checkAddendumOfferId?: string | undefined;
    resultInvoiceCheckId?: string | undefined;
    additionalCosts?: string | undefined;
    durationDays?: number | undefined;
    ticketNumberExternal?: string | undefined;
    leadDays?: number | undefined;
    desiredDate?: Date | undefined;
    checkOfferId?: string | undefined;
    comment?: string | undefined;
    incidentId: string;
    issofferAvailable?: boolean | undefined;
    approvalReady?: number | undefined;
    approvalReadyCalculated?: number | undefined;
    isContingentOrder?: boolean | undefined;
    isDataCenter?: boolean | undefined;
    finalTaskNemo?: boolean | undefined;
    invoiceValueAlreadyApproved?: number | undefined;
    invoiceAlreadyApprovedDate?: Date | undefined;
    invoiceAlreadyApprovedStateId?: string | undefined;
    invoiceAuditComment?: string | undefined;
    invoiceValueToBeApproved?: number | undefined;
    invoiceToBeApprovedDate?: Date | undefined;
    invoiceToBeApprovedStateId?: string | undefined;
    orderCreatedManually?: boolean | undefined;
    periodUntil?: Date | undefined;
    timeslotArea?: string | undefined;
    longtext?: string | undefined;
    mails?: string | undefined;
    approval?: SysEnum | undefined;
    categoryValue?: FmCategoryValue | undefined;
    checkAddendumOffer?: SysEnum | undefined;
    checkOffer?: SysEnum | undefined;
    contact?: OmEmployee | undefined;
    contactPerson?: OmContact | undefined;
    contactPersonEmployee?: OmEmployee | undefined;
    creator?: OmEmployee | undefined;
    currentEditor?: OmEmployee | undefined;
    destinationNavigation?: DtArchObjHierarchy | undefined;
    incident?: FmIncident | undefined;
    interfaceState?: SysEnum | undefined;
    invoiceType?: SysEnum | undefined;
    resultInvoiceCheck?: SysEnum | undefined;
    resultServiceAcceptance?: SysEnum | undefined;
    sapInvoiceVerification?: SapInvoiceVerification[] | undefined;
    serviceAcceptanceUser?: OmEmployee | undefined;
    status?: FmIncidentstate | undefined;
}

export interface FmCategoryValue {
    id?: string | undefined;
    category: string;
    value: string;
    changeDate?: Date | undefined;
    fmArchObjCategoryValue?: FmArchObjCategoryValue[] | undefined;
    fmIncidentCategoryValue?: FmIncidentCategoryValue[] | undefined;
    fmServiceRequest?: FmServiceRequest[] | undefined;
}

export interface FmArchObjCategoryValue {
    id?: string | undefined;
    archObjId: string;
    categoryValueId: string;
    source: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    categoryValue?: FmCategoryValue | undefined;
}

export interface FmIncidentCategoryValue {
    id?: string | undefined;
    incidentId: string;
    categoryValueId: string;
    categoryValue?: FmCategoryValue | undefined;
    incident?: FmIncident | undefined;
}

export interface OmEmployee {
    id?: string | undefined;
    lastname?: string | undefined;
    firstname?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    sex?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    managerId?: string | undefined;
    costCenterId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    workspaceId?: string | undefined;
    teamId?: string | undefined;
    costCenter?: FiCostCenter | undefined;
    dtArchObjUtilizationHistoryChangedByNavigation?: DtArchObjUtilizationHistory[] | undefined;
    dtArchObjUtilizationHistoryCreatedByNavigation?: DtArchObjUtilizationHistory[] | undefined;
    fiCostCenterDynamicsManager?: FiCostCenter[] | undefined;
    fiCostCenterR3manager?: FiCostCenter[] | undefined;
    fmApprovalEmployee?: FmApproval[] | undefined;
    fmApprovalReportedBackBy?: FmApproval[] | undefined;
    fmAreaRequestContactPerson?: FmAreaRequest[] | undefined;
    fmAreaRequestCreator?: FmAreaRequest[] | undefined;
    fmAreaReturnContactPerson?: FmAreaReturn[] | undefined;
    fmAreaReturnCreator?: FmAreaReturn[] | undefined;
    fmBasicServiceChangeContact?: FmBasicServiceChange[] | undefined;
    fmBasicServiceChangeCreator?: FmBasicServiceChange[] | undefined;
    fmCostCenterUsage?: FmCostCenterUsage[] | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmGeneralRequestCreator?: FmGeneralRequest[] | undefined;
    fmGeneralRequestReporter?: FmGeneralRequest[] | undefined;
    fmKeyRequest?: FmKeyRequest[] | undefined;
    fmOrderingFurnitureContactPerson?: FmOrderingFurniture[] | undefined;
    fmOrderingFurnitureCreator?: FmOrderingFurniture[] | undefined;
    fmRelocationContactPerson?: FmRelocation[] | undefined;
    fmRelocationCreator?: FmRelocation[] | undefined;
    fmServiceRequestContact?: FmServiceRequest[] | undefined;
    fmServiceRequestContactPersonEmployee?: FmServiceRequest[] | undefined;
    fmServiceRequestCreator?: FmServiceRequest[] | undefined;
    fmServiceRequestCurrentEditor?: FmServiceRequest[] | undefined;
    fmServiceRequestServiceAcceptanceUser?: FmServiceRequest[] | undefined;
    fmUsageChangeHistory?: FmUsageChangeHistory[] | undefined;
    inverseManager?: OmEmployee[] | undefined;
    manager?: OmEmployee | undefined;
    omAccessOrderer?: OmAccessOrderer[] | undefined;
    omAzureRoleMembership?: OmAzureRoleMembership[] | undefined;
    omEmployment?: OmEmployment[] | undefined;
    omIncidentUserAdministration?: OmIncidentUserAdministration[] | undefined;
    omSubstitutionSubstituteEmployee?: OmSubstitution[] | undefined;
    omSubstitutionSubstitutedEmployee?: OmSubstitution[] | undefined;
    omUserArchObjHierarchy?: OmUserArchObjHierarchy[] | undefined;
    team?: OmTeam | undefined;
    workspace?: DtArchObjHierarchy | undefined;
}

export interface DtArchObjUtilizationHistory {
    id?: string | undefined;
    archObjId: string;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    usageTypeId?: string | undefined;
    detailAreaType?: string | undefined;
    createDate?: Date | undefined;
    createdBy?: string | undefined;
    changeDate?: Date | undefined;
    changedBy?: string | undefined;
    status?: string | undefined;
    sapGuid?: string | undefined;
    buildingClassId?: string | undefined;
    changeReason?: string | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    buildingClass?: DtBuildingClass | undefined;
    changeReasonNavigation?: FmChangeReason | undefined;
    changedByNavigation?: OmEmployee | undefined;
    createdByNavigation?: OmEmployee | undefined;
    detailAreaTypeNavigation?: DtDetailAreaType | undefined;
    usageType?: DtUsageType | undefined;
}

export interface DtBuildingClass {
    buildingClassId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtArchObjUtilizationHistory?: DtArchObjUtilizationHistory[] | undefined;
    dtBuilding?: DtBuilding[] | undefined;
}

export interface DtBuilding {
    buildingId?: string | undefined;
    name: string;
    buildingCode?: string | undefined;
    primaryTypeOfBuilding?: string | undefined;
    secondaryTypeOfBuilding?: string | undefined;
    energyEfficiencyClass?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    constructionYear?: Date | undefined;
    yearOfLastRefurbisment?: Date | undefined;
    monumentProtection?: boolean | undefined;
    typeOfOwnership?: string | undefined;
    selfUse?: boolean | undefined;
    tenantStructure?: string | undefined;
    parkingSpaces?: number | undefined;
    primaryEnergyType?: string | undefined;
    primaryWaterType?: string | undefined;
    primaryHeatingType?: string | undefined;
    secondaryHeatingType?: string | undefined;
    airConditioning?: boolean | undefined;
    changeDate?: Date | undefined;
    imk?: string | undefined;
    name2?: string | undefined;
    name3?: string | undefined;
    deleteDate?: Date | undefined;
    usageType?: string | undefined;
    assetStrategy?: string | undefined;
    displayname?: string | undefined;
    buildingNumber?: number | undefined;
    typeOfOwnershipSap?: string | undefined;
    typeOfOwnershipAgg?: string | undefined;
    siteCode?: string | undefined;
    buildingClass?: string | undefined;
    wmCluster?: string | undefined;
    changeReason?: string | undefined;
    aoid?: string | undefined;
    realValidFrom?: Date | undefined;
    realValidUntil?: Date | undefined;
    building?: DtArchObjHierarchy | undefined;
    buildingClassNavigation?: DtBuildingClass | undefined;
    changeReasonNavigation?: FmChangeReason | undefined;
    pmRentalEntity?: PmRentalEntity[] | undefined;
    wmClusterNavigation?: DtWmvCluster | undefined;
}

export interface FmChangeReason {
    changeReason?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtArchObjUtilizationHistory?: DtArchObjUtilizationHistory[] | undefined;
    dtBillingArea?: DtBillingArea[] | undefined;
    dtBuilding?: DtBuilding[] | undefined;
    dtFloor?: DtFloor[] | undefined;
    dtSpace?: DtSpace[] | undefined;
    dtSubSpace?: DtSubSpace[] | undefined;
    fmCostCenterUsage?: FmCostCenterUsage[] | undefined;
    fmSbuUsage?: FmSbuUsage[] | undefined;
    fmUsageChangeHistory?: FmUsageChangeHistory[] | undefined;
}

export interface DtBillingArea {
    billingAreaId?: string | undefined;
    name: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    changeReason?: string | undefined;
    billingArea?: DtArchObjHierarchy | undefined;
    changeReasonNavigation?: FmChangeReason | undefined;
    dtSpace?: DtSpace[] | undefined;
    fmAreaReturn?: FmAreaReturn[] | undefined;
    fmSbuUsage?: FmSbuUsage[] | undefined;
    roomWorkingSpaceHistory?: RoomWorkingSpaceHistory[] | undefined;
}

export interface DtSpace {
    name?: string | undefined;
    spaceCode?: string | undefined;
    spaceNumber?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    spaceId?: string | undefined;
    spaceHeightUsable?: number | undefined;
    spaceHeight?: number | undefined;
    spaceVolumeGross?: number | undefined;
    spaceVolumeNet?: number | undefined;
    primaryFloorMaterial?: string | undefined;
    primaryCeilingMaterial?: string | undefined;
    rentability?: boolean | undefined;
    effectZonesHeating?: number | undefined;
    effectZonesCooling?: number | undefined;
    effectZonesVentiliation?: number | undefined;
    climateHeated?: boolean | undefined;
    climateCooled?: boolean | undefined;
    coUseArea?: boolean | undefined;
    maximumOccupancy?: number | undefined;
    ventilationType?: string | undefined;
    changeDate?: Date | undefined;
    spaceTypeId?: string | undefined;
    name2?: string | undefined;
    name3?: string | undefined;
    deleteDate?: Date | undefined;
    typeOfUse?: string | undefined;
    detailAreaType?: string | undefined;
    aoid?: string | undefined;
    architecturalFunction?: string | undefined;
    displayname?: string | undefined;
    cntWorkspacesPlanned?: number | undefined;
    cntWorkspacesAvailable?: number | undefined;
    cntWorkspacesOccupied?: number | undefined;
    userArea?: number | undefined;
    tiFlag?: boolean | undefined;
    isWmv?: boolean | undefined;
    wmProdIndi?: string | undefined;
    wmProd?: string | undefined;
    rentalEntityId?: string | undefined;
    statusSveAo?: string | undefined;
    deleteFlag?: boolean;
    fmArea?: number | undefined;
    wmClusterInfo?: string | undefined;
    centralInfo?: string | undefined;
    changeReason?: string | undefined;
    cntWorkspacesSpecialArea?: number | undefined;
    cntWorkspacesAnchorArea?: number | undefined;
    cntWorkspacesSharedSpaces?: number | undefined;
    cntWorkspacesFunctionalSharedSpaces?: number | undefined;
    measurement?: string | undefined;
    architecturalArea?: number | undefined;
    rentalAreaRem?: number | undefined;
    wmClusterIndi?: string | undefined;
    routineCleaning?: boolean | undefined;
    calculationType?: string | undefined;
    magentaOfficeAreaType?: string | undefined;
    billingAreaId?: string | undefined;
    nonVisibleFlag?: boolean;
    realValidFrom?: Date | undefined;
    realValidUntil?: Date | undefined;
    billingArea?: DtBillingArea | undefined;
    calculationTypeNavigation?: DtCalculationType | undefined;
    centralInfoNavigation?: DtCentralInfo | undefined;
    changeReasonNavigation?: FmChangeReason | undefined;
    detailAreaTypeNavigation?: DtDetailAreaType | undefined;
    magentaOfficeAreaTypeNavigation?: DtMagentaOfficeAreaType | undefined;
    roomWorkingSpaceHistory?: RoomWorkingSpaceHistory[] | undefined;
    space?: DtArchObjHierarchy | undefined;
    spaceType?: DtSpaceType | undefined;
    typeOfUseNavigation?: DtUsageType | undefined;
    wmClusterIndiNavigation?: DtWmvCluster | undefined;
    wmClusterInfoNavigation?: DtWmvClusterInfo | undefined;
    wmProdIndiNavigation?: DtWmvProduct | undefined;
}

export interface DtCalculationType {
    calculationTypeId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    name?: string | undefined;
    dtSpace?: DtSpace[] | undefined;
}

export interface DtCentralInfo {
    centralInfoId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtSpace?: DtSpace[] | undefined;
}

export interface DtDetailAreaType {
    detailAreaTypeId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtArchObjUtilizationHistory?: DtArchObjUtilizationHistory[] | undefined;
    dtSpace?: DtSpace[] | undefined;
    dtUsageDetailArea?: DtUsageDetailArea[] | undefined;
}

export interface DtUsageDetailArea {
    usageTypeId?: string | undefined;
    detailAreaTypeId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    detailAreaType?: DtDetailAreaType | undefined;
    usageType?: DtUsageType | undefined;
}

export interface DtUsageType {
    usageTypeId?: string | undefined;
    wmprod?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    category?: string | undefined;
    dtArchObjUtilizationHistory?: DtArchObjUtilizationHistory[] | undefined;
    dtSpace?: DtSpace[] | undefined;
    dtUsageDetailArea?: DtUsageDetailArea[] | undefined;
    wmprodNavigation?: DtWmvProduct | undefined;
}

export interface DtWmvProduct {
    wmvProductId?: string | undefined;
    individual?: boolean | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtSpace?: DtSpace[] | undefined;
    dtUsageType?: DtUsageType[] | undefined;
    wmvPriceMatrix?: WmvPriceMatrix[] | undefined;
}

export interface WmvPriceMatrix {
    wmvClusterId?: string | undefined;
    wmvProductId?: string | undefined;
    simulation?: boolean;
    price?: number | undefined;
    currency?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    wmvCluster?: DtWmvCluster | undefined;
    wmvProduct?: DtWmvProduct | undefined;
}

export interface DtWmvCluster {
    wmvClusterId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtBuilding?: DtBuilding[] | undefined;
    dtSpace?: DtSpace[] | undefined;
    wmvPriceMatrix?: WmvPriceMatrix[] | undefined;
}

export interface DtMagentaOfficeAreaType {
    magentaOfficeAreaTypeId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtSpace?: DtSpace[] | undefined;
}

export interface RoomWorkingSpaceHistory {
    id?: string;
    spaceId: string;
    billingAreaId?: string | undefined;
    workingSpaceCount?: number;
    validFrom?: Date;
    validUntil?: Date;
    aoid?: string | undefined;
    billingArea?: DtBillingArea | undefined;
    space?: DtSpace | undefined;
}

export interface DtSpaceType {
    spaceTypeId?: string | undefined;
    name?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    source?: string | undefined;
    classification?: string | undefined;
    dtSpace?: DtSpace[] | undefined;
}

export interface DtWmvClusterInfo {
    wmvClusterInfoId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtSpace?: DtSpace[] | undefined;
}

export interface FmAreaReturn {
    id?: string | undefined;
    archObjId?: string | undefined;
    requestedDate?: Date | undefined;
    spaceTypeId?: string | undefined;
    costCenterId?: string | undefined;
    creatorId?: string | undefined;
    contactPersonId?: string | undefined;
    orgUnit?: string | undefined;
    department?: string | undefined;
    costCenterSociety?: string | undefined;
    billingAreaId?: string | undefined;
    mails?: string | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    billingArea?: DtBillingArea | undefined;
    contactPerson?: OmEmployee | undefined;
    costCenter?: FiCostCenter | undefined;
    creator?: OmEmployee | undefined;
    fmAreaReturnCostCenterUsage?: FmAreaReturnCostCenterUsage[] | undefined;
    fmAreaReturnSbuUsage?: FmAreaReturnSbuUsage[] | undefined;
    idNavigation?: FmIncident | undefined;
    spaceType?: SysEnum | undefined;
}

export interface FmAreaReturnCostCenterUsage {
    areaReturnId?: string | undefined;
    costCenterUsageId?: string | undefined;
    requestedDate?: Date | undefined;
    areaReturn?: FmAreaReturn | undefined;
    costCenterUsage?: FmCostCenterUsage | undefined;
}

export interface FmCostCenterUsage {
    id?: string | undefined;
    archObjId: string;
    costCenterId: string;
    floorArea?: number | undefined;
    usageFrom?: Date;
    usageUntil?: Date;
    remarks?: string | undefined;
    changeDate?: Date | undefined;
    changeReason?: string | undefined;
    employeeId?: string | undefined;
    deleteDate?: Date | undefined;
    transferredToSap?: boolean;
    cntWorkspaces?: number | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    changeReasonNavigation?: FmChangeReason | undefined;
    costCenter?: FiCostCenter | undefined;
    employee?: OmEmployee | undefined;
    fmAreaReturnCostCenterUsage?: FmAreaReturnCostCenterUsage[] | undefined;
}

export interface FmAreaReturnSbuUsage {
    areaReturnId?: string | undefined;
    sbuUsageId?: string | undefined;
    requestedDate?: Date | undefined;
    menge?: number | undefined;
    areaReturn?: FmAreaReturn | undefined;
    sbuUsage?: FmSbuUsage | undefined;
}

export interface FmSbuUsage {
    id?: string | undefined;
    billingAreaId: string;
    sbuid: string;
    usageFrom?: Date;
    usageUntil?: Date;
    cntWorkspaces?: number;
    remarks?: string | undefined;
    changeDate?: Date | undefined;
    changeReason?: string | undefined;
    deleteDate?: Date | undefined;
    transferredToSap?: boolean;
    costCenterId?: string | undefined;
    billingArea?: DtBillingArea | undefined;
    changeReasonNavigation?: FmChangeReason | undefined;
    costCenter?: FiCostCenter | undefined;
    fmAreaReturnSbuUsage?: FmAreaReturnSbuUsage[] | undefined;
    sbu?: OmStrategicBusinessUnit | undefined;
}

export interface OmStrategicBusinessUnit {
    sbuid?: string | undefined;
    changeDate?: Date | undefined;
    displayColor: string;
    fmSbuUsage?: FmSbuUsage[] | undefined;
    omCompany?: OmCompany[] | undefined;
}

export interface OmCompany {
    companyId?: string | undefined;
    companyName?: string | undefined;
    companyCode?: string | undefined;
    companyCodeName?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    changeDate?: Date | undefined;
    billingProcedure?: string | undefined;
    businessPartner?: string | undefined;
    releaseMail?: string | undefined;
    isNew?: boolean | undefined;
    changedOn?: Date | undefined;
    changedBy?: string | undefined;
    tsisCompanyNr?: string | undefined;
    tsisCompanyName?: string | undefined;
    isWmvRelevant?: boolean | undefined;
    sbuid?: string | undefined;
    fiCostCenter?: FiCostCenter[] | undefined;
    sbu?: OmStrategicBusinessUnit | undefined;
}

export interface DtFloor {
    floorId?: string | undefined;
    name: string;
    floorCode?: string | undefined;
    floorNumber?: number | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    name2?: string | undefined;
    name3?: string | undefined;
    deleteDate?: Date | undefined;
    displayname?: string | undefined;
    changeReason?: string | undefined;
    realValidFrom?: Date | undefined;
    realValidUntil?: Date | undefined;
    changeReasonNavigation?: FmChangeReason | undefined;
    floor?: DtArchObjHierarchy | undefined;
}

export interface DtSubSpace {
    subSpaceId?: string | undefined;
    name?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    name2?: string | undefined;
    name3?: string | undefined;
    deleteDate?: Date | undefined;
    number?: number | undefined;
    status?: string | undefined;
    isCreated?: boolean | undefined;
    isValid?: boolean | undefined;
    sapStatus?: string | undefined;
    isDummy?: boolean | undefined;
    dummyType?: string | undefined;
    magentaOfficeAreaType?: string | undefined;
    changeReasonId?: string | undefined;
    changeReason?: FmChangeReason | undefined;
    dummyTypeNavigation?: DtDummyType | undefined;
    subSpace?: DtArchObjHierarchy | undefined;
}

export interface DtDummyType {
    dummyType?: string | undefined;
    dtSubSpace?: DtSubSpace[] | undefined;
}

export interface FmUsageChangeHistory {
    id?: number;
    archObjId: string;
    usageFrom?: Date;
    usageUntil?: Date;
    floorArea?: number;
    oldCostCenterId: string;
    newCostCenterId: string;
    employeeId: string;
    changeReason?: string | undefined;
    changeDate?: Date;
    changeOverDate?: Date;
    workspaces?: number | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    changeReasonNavigation?: FmChangeReason | undefined;
    employee?: OmEmployee | undefined;
    newCostCenter?: FiCostCenter | undefined;
    oldCostCenter?: FiCostCenter | undefined;
}

export interface PmRentalEntity {
    id?: string | undefined;
    name?: string | undefined;
    number?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    buildingId?: string | undefined;
    building?: DtBuilding | undefined;
    pmRentalEntityArchObj?: PmRentalEntityArchObj[] | undefined;
}

export interface PmRentalEntityArchObj {
    id?: string | undefined;
    archObjId: string;
    rentalEntityId: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    rentalEntity?: PmRentalEntity | undefined;
}

export interface FmApproval {
    id?: string | undefined;
    employeeId?: string | undefined;
    teamId?: string | undefined;
    reportedBackById?: string | undefined;
    reportedBackOn?: Date | undefined;
    approvalStatusId?: string | undefined;
    sequence?: number | undefined;
    returnMessage?: string | undefined;
    azureRoleId?: string | undefined;
    incidentId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    isActive?: boolean | undefined;
    isCanceled?: boolean | undefined;
    requestNewQuote?: boolean | undefined;
    createApprovalPurchase?: boolean | undefined;
    approvalStatus?: SysEnum | undefined;
    azureRole?: OmAzureRole | undefined;
    employee?: OmEmployee | undefined;
    incident?: FmIncident | undefined;
    reportedBackBy?: OmEmployee | undefined;
    team?: OmTeam | undefined;
}

export interface OmAzureRole {
    id?: string | undefined;
    name: string;
    firstResponsibleEmployeeId?: string | undefined;
    secondResponsibleEmployeeId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    description?: string | undefined;
    skipApprovalProcess?: boolean | undefined;
    fmApproval?: FmApproval[] | undefined;
    omAzureRoleMembership?: OmAzureRoleMembership[] | undefined;
    omIncidentUserAdministration?: OmIncidentUserAdministration[] | undefined;
}

export interface OmAzureRoleMembership {
    id?: string | undefined;
    employeeId?: string | undefined;
    azureRoleId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    azureRole?: OmAzureRole | undefined;
    employee?: OmEmployee | undefined;
}

export interface OmIncidentUserAdministration {
    incidentId?: string | undefined;
    roleId?: string | undefined;
    firstName: string;
    lastName: string;
    email: string;
    contactId?: string | undefined;
    systemUserId?: string | undefined;
    b2cuserId?: string | undefined;
    creatorId?: string | undefined;
    creatorContactId?: string | undefined;
    contact?: OmContact | undefined;
    creator?: OmEmployee | undefined;
    creatorContact?: OmContact | undefined;
    incident?: FmIncident | undefined;
    role?: OmAzureRole | undefined;
    systemUser?: OmSystemUser | undefined;
}

export interface OmTeam {
    id?: string | undefined;
    name: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    fmApproval?: FmApproval[] | undefined;
    omEmployee?: OmEmployee[] | undefined;
}

export interface FmAreaRequest {
    id?: string | undefined;
    desiredAdressId?: string | undefined;
    requestedDate?: Date | undefined;
    quantityM2?: number | undefined;
    spaceTypeId?: string | undefined;
    costCenterId?: string | undefined;
    creatorId?: string | undefined;
    contactPersonId?: string | undefined;
    omvTicketId?: string | undefined;
    mails?: string | undefined;
    contactPerson?: OmEmployee | undefined;
    costCenter?: FiCostCenter | undefined;
    creator?: OmEmployee | undefined;
    desiredAdress?: DtArchObjHierarchy | undefined;
    fmAreaRequirement?: FmAreaRequirement[] | undefined;
    idNavigation?: FmIncident | undefined;
    omvTicket?: FmOmvTicket | undefined;
    spaceType?: SysEnum | undefined;
}

export interface FmAreaRequirement {
    id?: string | undefined;
    areaRequestId?: string | undefined;
    numberOfSqm?: number | undefined;
    costCenterId?: string | undefined;
    typeId?: string | undefined;
    areaRequest?: FmAreaRequest | undefined;
    costCenter?: FiCostCenter | undefined;
    type?: SysEnum | undefined;
}

export interface FmOmvTicket {
    ticketnumber?: string | undefined;
    incidentType: string;
    title?: string | undefined;
    statusOmv?: string | undefined;
    description?: string | undefined;
    desiredDate?: Date | undefined;
    validFrom?: Date | undefined;
    functionalLocation?: string | undefined;
    contract?: string | undefined;
    contractValue?: number | undefined;
    firstApprovalGsus?: boolean | undefined;
    secondApproval?: boolean | undefined;
    genehmigung3Gsus?: boolean | undefined;
    genehmigung4Gsus?: boolean | undefined;
    genehmigung1Iss?: boolean | undefined;
    genehmigung2Iss?: boolean | undefined;
    ticket?: string | undefined;
    ticketklasse?: string | undefined;
    "kündigungZum"?: Date | undefined;
    changeDate?: Date;
    fmAreaRequest?: FmAreaRequest[] | undefined;
    ticketNavigation?: FmIncident | undefined;
}

export interface FmBasicServiceChange {
    id?: string | undefined;
    deviatingAddress?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    structuralPart?: string | undefined;
    contactId?: string | undefined;
    completionDate?: Date | undefined;
    creatorId: string;
    statusId?: string | undefined;
    startDate?: Date | undefined;
    value?: number | undefined;
    workTaskId?: string | undefined;
    flowerCount?: number | undefined;
    hinUndWegVertragId?: string | undefined;
    pestTypeId?: string | undefined;
    pflegeKategorie?: string | undefined;
    qualificationId?: string | undefined;
    timeSpanWeek?: string | undefined;
    volumeTypeId?: string | undefined;
    additionRemovalAreaInQm?: number | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;
    modificationId?: string | undefined;
    cleaningDetailsId?: string | undefined;
    glassCleaningDetailsId?: string | undefined;
    plantCareDetailsId?: string | undefined;
    winterServiceDetailsId?: string | undefined;
    securityServiceQualificationId?: string | undefined;
    receptionQualificationId?: string | undefined;
    conferenceRoomManagementId?: string | undefined;
    propertyManagementTfmIfmId?: string | undefined;
    janitorialServicesAttendanceStaffId?: string | undefined;
    mobileJanitorialServicesId?: string | undefined;
    pestProfilaxeCanteensId?: string | undefined;
    basicCleaningId?: string | undefined;
    pestControlId?: string | undefined;
    dayLabourId?: string | undefined;
    receptionServicesId?: string | undefined;
    weeklyHoursTotal?: number | undefined;
    numberEmployee?: number | undefined;
    maintenanceCategoryId?: string | undefined;
    incidentId: string;
    interfaceStateId?: string | undefined;
    longtext?: string | undefined;
    amountFte?: number | undefined;
    basicCleaning?: SysEnum | undefined;
    cleaningDetails?: SysEnum | undefined;
    conferenceRoomManagement?: SysEnum | undefined;
    contact?: OmEmployee | undefined;
    creator?: OmEmployee | undefined;
    dayLabour?: SysEnum | undefined;
    glassCleaningDetails?: SysEnum | undefined;
    hinUndWegVertrag?: SysEnum | undefined;
    incident?: FmIncident | undefined;
    interfaceState?: SysEnum | undefined;
    janitorialServicesAttendanceStaff?: SysEnum | undefined;
    maintenanceCategory?: SysEnum | undefined;
    mobileJanitorialServices?: SysEnum | undefined;
    modification?: SysEnum | undefined;
    pestControl?: SysEnum | undefined;
    pestProfilaxeCanteens?: SysEnum | undefined;
    pestType?: SysEnum | undefined;
    plantCareDetails?: SysEnum | undefined;
    propertyManagementTfmIfm?: SysEnum | undefined;
    qualification?: SysEnum | undefined;
    receptionQualification?: SysEnum | undefined;
    receptionServices?: SysEnum | undefined;
    sapBasicServiceChangeChangeOrder?: SapBasicServiceChangeChangeOrder[] | undefined;
    securityServiceQualification?: SysEnum | undefined;
    status?: FmIncidentstate | undefined;
    volumeType?: SysEnum | undefined;
    winterServiceDetails?: SysEnum | undefined;
}

export interface SapBasicServiceChangeChangeOrder {
    id?: string | undefined;
    basicServiceChangeId: string;
    changeTypeId: string;
    serviceValidFrom?: Date | undefined;
    serviceValidUntil?: Date | undefined;
    material?: string | undefined;
    amount?: number | undefined;
    unit?: string | undefined;
    frequencyJanuary?: string | undefined;
    frequencyFebruary?: string | undefined;
    frequencyMarch?: string | undefined;
    frequencyApril?: string | undefined;
    frequencyMay?: string | undefined;
    frequencyJune?: string | undefined;
    frequencyJuly?: string | undefined;
    frequencyAugust?: string | undefined;
    frequencySeptember?: string | undefined;
    frequencyOctober?: string | undefined;
    frequencyNovember?: string | undefined;
    frequencyDecember?: string | undefined;
    daysForPersonalServices?: string | undefined;
    startOfWork?: string | undefined;
    endOfWork?: string | undefined;
    numberOfPersons?: string | undefined;
    qualification?: string | undefined;
    massChangeId?: string | undefined;
    massChangeName?: string | undefined;
    commentValuation?: string | undefined;
    additionalServiceInformation?: string | undefined;
    value?: number | undefined;
    description?: string | undefined;
    numberCareCyles?: number | undefined;
    approved?: boolean | undefined;
    approvalComment?: string | undefined;
    approvalDate?: Date | undefined;
    materialDescription?: string | undefined;
    modification?: string | undefined;
    workTaskId?: string | undefined;
    basicServiceChange?: FmBasicServiceChange | undefined;
    changeType?: SysEnum | undefined;
}

export interface FmIncidentstate {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isSecondaryState?: boolean | undefined;
    statusType?: string | undefined;
    statusSchema?: string | undefined;
    status?: string | undefined;
    changeDate?: Date | undefined;
    fmBasicServiceChange?: FmBasicServiceChange[] | undefined;
    fmGeneralRequest?: FmGeneralRequest[] | undefined;
    fmIncidentIncidentSecState?: FmIncidentIncidentSecState[] | undefined;
    fmServiceRequest?: FmServiceRequest[] | undefined;
}

export interface FmGeneralRequest {
    id?: string | undefined;
    deviatingAddress?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    structuralPart?: string | undefined;
    reporterId?: string | undefined;
    completionDate?: Date | undefined;
    creatorId: string;
    statusId?: string | undefined;
    interfaceStateId?: string | undefined;
    creator?: OmEmployee | undefined;
    idNavigation?: FmIncident | undefined;
    interfaceState?: SysEnum | undefined;
    reporter?: OmEmployee | undefined;
    status?: FmIncidentstate | undefined;
}

export interface FmIncidentIncidentSecState {
    incidentId?: string | undefined;
    incidentStatusId?: string | undefined;
    isDeleted?: boolean | undefined;
    changeDate?: Date | undefined;
    incident?: FmIncident | undefined;
    incidentStatus?: FmIncidentstate | undefined;
}

export interface FmKeyRequest {
    keyRequestId?: string | undefined;
    title?: string | undefined;
    siteId?: string | undefined;
    employeeId?: string | undefined;
    shippingAddressFirstname?: string | undefined;
    shippingAddressLastname?: string | undefined;
    shippingAddressStreet?: string | undefined;
    shippingAddressPostalCode?: string | undefined;
    shippingAddressCity?: string | undefined;
    shippingAddressEmail?: string | undefined;
    additionalInformation?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    employee?: OmEmployee | undefined;
    fmKeyRequestPosition?: FmKeyRequestPosition[] | undefined;
    site?: DtSite | undefined;
}

export interface FmKeyRequestPosition {
    id?: string | undefined;
    keyRequestId: string;
    position?: number;
    manufacturer?: string | undefined;
    keyNumber: string;
    amount?: number;
    roomNumber?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    keyRequest?: FmKeyRequest | undefined;
}

export interface DtSite {
    name: string;
    siteId?: string | undefined;
    type?: string | undefined;
    siteCode?: string | undefined;
    validUntil?: Date | undefined;
    validFrom?: Date | undefined;
    changeDate?: Date | undefined;
    name2?: string | undefined;
    name3?: string | undefined;
    deleteDate?: Date | undefined;
    usageType?: string | undefined;
    marketSegment?: string | undefined;
    aggTypeOfOwnershipBu?: string | undefined;
    aggTypeOfOwnershipLa?: string | undefined;
    commonNeeds?: string | undefined;
    energyCertification?: string | undefined;
    assetStrategy?: string | undefined;
    gmgvacancy?: number | undefined;
    tiflagVacancy?: number | undefined;
    assignableArea?: number | undefined;
    displayname?: string | undefined;
    vpsz?: string | undefined;
    typeOfOwnershipAgg?: string | undefined;
    fmKeyRequest?: FmKeyRequest[] | undefined;
    omSystemUser?: OmSystemUser[] | undefined;
    site?: DtArchObjHierarchy | undefined;
}

export interface FmOrderingFurniture {
    id?: string | undefined;
    requestedDate?: Date | undefined;
    hardFlooring?: boolean;
    softFlooring?: boolean;
    statement?: boolean;
    desk?: boolean;
    specialOrder?: boolean;
    severeHandicap?: boolean;
    teleworking?: boolean;
    contactPersonId?: string | undefined;
    pspItem?: string | undefined;
    shippingAdressId?: string | undefined;
    firstName?: string | undefined;
    lastname?: string | undefined;
    streetNameHouseNumber?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    basketNumber?: string | undefined;
    deliveryDate?: Date | undefined;
    orderNumber?: string | undefined;
    rejectionReason?: string | undefined;
    creatorId?: string | undefined;
    floor?: string | undefined;
    roomNumber?: string | undefined;
    deskNumber?: string | undefined;
    contactPerson?: OmEmployee | undefined;
    creator?: OmEmployee | undefined;
    idNavigation?: FmIncident | undefined;
    shippingAdress?: DtArchObjHierarchy | undefined;
}

export interface FmRelocation {
    id?: string | undefined;
    workersCouncilApproved?: boolean;
    areaChangeCreated?: boolean;
    originAdressId?: string | undefined;
    originFirstName?: string | undefined;
    originLastname?: string | undefined;
    originStreetNameHouseNumber?: string | undefined;
    originPostalCode?: string | undefined;
    originCity?: string | undefined;
    targetAdressId?: string | undefined;
    targetFirstName?: string | undefined;
    targetLastname?: string | undefined;
    targetStreetNameHouseNumber?: string | undefined;
    targetPostalCode?: string | undefined;
    targetCity?: string | undefined;
    requestedDate?: Date | undefined;
    creatorId?: string | undefined;
    contactPersonId?: string | undefined;
    basketNumber?: string | undefined;
    deliveryDate?: Date | undefined;
    orderNumber?: string | undefined;
    rejectionReason?: string | undefined;
    originFloor?: string | undefined;
    originRoomNumber?: string | undefined;
    originDeskNumber?: string | undefined;
    targetRoomNumber?: string | undefined;
    targetDeskNumber?: string | undefined;
    targetFloor?: string | undefined;
    contactPerson?: OmEmployee | undefined;
    creator?: OmEmployee | undefined;
    idNavigation?: FmIncident | undefined;
    originAdress?: DtArchObjHierarchy | undefined;
    targetAdress?: DtArchObjHierarchy | undefined;
}

export interface OmAccessOrderer {
    id?: number;
    costCenterId?: string | undefined;
    employeeId?: string | undefined;
    createDate?: Date | undefined;
    endDate?: Date | undefined;
    deleteDate?: Date | undefined;
    isNominatedInActiveAccess?: boolean;
    costCenter?: FiCostCenter | undefined;
    employee?: OmEmployee | undefined;
}

export interface OmEmployment {
    id?: string | undefined;
    email?: string | undefined;
    costCenterId?: string | undefined;
    employeeId?: string | undefined;
    company?: string | undefined;
    orgUnit?: string | undefined;
    isPrimary?: boolean | undefined;
    companyCode?: string | undefined;
    postcode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    lastSeenOn?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    costCenter?: FiCostCenter | undefined;
    employee?: OmEmployee | undefined;
}

export interface OmSubstitution {
    id?: number;
    substitutedEmployeeId: string;
    substituteEmployeeId: string;
    costCenterId: string;
    validFrom?: Date;
    validUntil?: Date;
    createDate?: Date;
    deleteDate?: Date | undefined;
    costCenter?: FiCostCenter | undefined;
    substituteEmployee?: OmEmployee | undefined;
    substitutedEmployee?: OmEmployee | undefined;
}

export interface OmUserArchObjHierarchy {
    id?: number;
    contactId?: string | undefined;
    archObjId?: string | undefined;
    systemUserId?: string | undefined;
    employeeId?: string | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    contact?: OmContact | undefined;
    employee?: OmEmployee | undefined;
    systemUser?: OmSystemUser | undefined;
}

export interface WbsMapping {
    id?: number;
    productId: string;
    budgetTypeId?: string | undefined;
    internalOrderNumber: string;
    pspElement: string;
    pspElementContingent?: string | undefined;
    additionalCostsKey?: string | undefined;
    year?: number | undefined;
    budgetType?: SysEnum | undefined;
    product?: FmProduct | undefined;
}

export interface FmGefmaCode {
    id?: string | undefined;
    text: string;
    deleteDate?: Date | undefined;
    fmDocumentType?: FmDocumentType[] | undefined;
}

export interface FmConfigurationRow {
    configurationRowId?: string | undefined;
    isActive?: boolean | undefined;
    titleDe?: string | undefined;
    titleEn?: string | undefined;
    fieldName?: string | undefined;
    configurationTaskId: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    name?: string | undefined;
    length?: number | undefined;
    optionSetType?: string | undefined;
    targetEntity?: string | undefined;
    configurationTask?: FmConfigurationTask | undefined;
}

export interface PmIncidentExternalLetting {
    incidentId?: string | undefined;
    additionalCostsElectricity?: number | undefined;
    additionalCostsHeating?: number | undefined;
    additionalCostsOperation?: number | undefined;
    commentsIssorderForm?: string | undefined;
    commonNeedsId?: string | undefined;
    contactInformation?: string | undefined;
    energyCertificationAvailableId?: string | undefined;
    finalTaskNemo?: string | undefined;
    fireProtectionId?: string | undefined;
    layoutId?: string | undefined;
    lettingDecisionId?: string | undefined;
    lettingDecisionConfirmationFromId?: string | undefined;
    pollutantsId?: string | undefined;
    pricePerSquareMeter?: number | undefined;
    prospectiveTenants?: string | undefined;
    quantityCounterElectricityId?: string | undefined;
    quantityCounterHeatingId?: string | undefined;
    quantityCounterWaterId?: string | undefined;
    rentalContractChecked?: boolean | undefined;
    rentalContractCheckedFromId?: string | undefined;
    rentalSpace?: number | undefined;
    rentalUnitHandedOver?: boolean | undefined;
    roofSubjectId?: string | undefined;
    setupRenterDecisionId?: string | undefined;
    technicalBuildingEquipmentId?: string | undefined;
    uploadRentalContract?: boolean | undefined;
    archObjId?: string | undefined;
    lettingDecisionsConfirmationNewId?: string | undefined;
    reasonForCancellation?: string | undefined;
    descriptionTenantSpecificPreparation?: string | undefined;
    durationMonths?: number | undefined;
    flatrateElectricity?: number | undefined;
    flatrateHeating?: number | undefined;
    flatrateWater?: number | undefined;
    incentives?: string | undefined;
    maintenanceMeasuresId?: string | undefined;
    nameOfProspectiveTenantsId?: string | undefined;
    rejectTenantId?: string | undefined;
    rentalPricePerParkingSpace?: number | undefined;
    requestedArea?: number | undefined;
    requestedParkingSpaces?: number | undefined;
    stopMarketingId?: string | undefined;
    reasonForCancellationCs?: string | undefined;
    paymentAdditionalCostsOperationId?: string | undefined;
    paymentAdditionalCostsHeatingId?: string | undefined;
    paymentAdditionalCostsElectricityId?: string | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    commonNeeds?: SysEnum | undefined;
    energyCertificationAvailable?: SysEnum | undefined;
    fireProtection?: SysEnum | undefined;
    incident?: FmIncident | undefined;
    layout?: SysEnum | undefined;
    lettingDecision?: SysEnum | undefined;
    lettingDecisionConfirmationFrom?: OmSystemUser | undefined;
    maintenanceMeasures?: SysEnum | undefined;
    nameOfProspectiveTenants?: OmContact | undefined;
    paymentAdditionalCostsElectricity?: SysEnum | undefined;
    paymentAdditionalCostsHeating?: SysEnum | undefined;
    paymentAdditionalCostsOperation?: SysEnum | undefined;
    pollutants?: SysEnum | undefined;
    quantityCounterElectricity?: SysEnum | undefined;
    quantityCounterHeating?: SysEnum | undefined;
    quantityCounterWater?: SysEnum | undefined;
    rejectTenant?: SysEnum | undefined;
    rentalContractCheckedFrom?: OmSystemUser | undefined;
    roofSubject?: SysEnum | undefined;
    setupRenterDecision?: SysEnum | undefined;
    stopMarketing?: SysEnum | undefined;
    technicalBuildingEquipment?: SysEnum | undefined;
}

export interface PmRentalContract {
    rentalContractId?: string | undefined;
    mainContractId?: string | undefined;
    contractCode?: string | undefined;
    contractType?: string | undefined;
    companyCode?: string | undefined;
    contractName?: string | undefined;
    contractGroup?: string | undefined;
    rentBeginDate?: Date | undefined;
    rentEndDate?: Date | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    periodOfNotice?: string | undefined;
    paymentInAdvance?: boolean | undefined;
    paymentPeriod?: string | undefined;
    shortTermLease?: boolean | undefined;
    tenantSector?: string | undefined;
    turnoverReportingInterval?: string | undefined;
    contractNumber?: string | undefined;
    changeDate?: Date | undefined;
    contractActivation?: Date | undefined;
    contractCurrency?: string | undefined;
    dateContractSigned?: Date | undefined;
    dateContractSecondSignature?: Date | undefined;
    dateReceiptOfNotice?: Date | undefined;
    reasonForTermination?: string | undefined;
    dateTerminationContract?: Date | undefined;
    contactId?: string | undefined;
    renterContactId?: string | undefined;
    accountId?: string | undefined;
    rentalSecurtiyCharacteristic?: boolean | undefined;
    depositAmount?: string | undefined;
    archObjId?: string | undefined;
    createdBy?: string | undefined;
    responsiblePerson?: string | undefined;
    firstContractEnddate?: Date | undefined;
    ownerId?: string | undefined;
    contractCategory?: string | undefined;
    firstSigneeId?: string | undefined;
    secondSigneeId?: string | undefined;
    signatureStatus?: string | undefined;
    helloSignEmailSubject?: string | undefined;
    helloSignEmailBody?: string | undefined;
    helloSignDocumentId?: string | undefined;
    stateHba?: string | undefined;
    maximumExtension?: Date | undefined;
    nextEndOfContract?: Date | undefined;
    possibleOwnTermination?: Date | undefined;
    possibleTerminationPartner?: Date | undefined;
    monthsOptionPeriod?: number | undefined;
    monthsTerminationPeriod?: number | undefined;
    deleteDate?: Date | undefined;
    netColdMonth?: number | undefined;
    ancillaryCostsMonth?: number | undefined;
    objectRentalAgreement?: boolean | undefined;
    startHba?: Date | undefined;
    leadTimeMonths?: number | undefined;
    nextDecisionUntil?: Date | undefined;
    optionPullup?: Date | undefined;
    cancelUntil?: Date | undefined;
    nextEndTermination?: Date | undefined;
    nextEndTerminationRenter?: Date | undefined;
    isAngl?: boolean | undefined;
    isAktv?: boolean | undefined;
    isCleaningRelevant?: boolean | undefined;
    hasDemolitionCommitment?: boolean | undefined;
    resubmissionDate?: Date | undefined;
    resubmissionInfo?: string | undefined;
    optionCount?: number | undefined;
    optionYears?: number | undefined;
    terminationClause?: string | undefined;
    extensionClause?: string | undefined;
    extensionType?: string | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    contractTypeNavigation?: PmRentalContractType | undefined;
    firstSignee?: OmSystemUser | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmIncident?: FmIncident[] | undefined;
    helloSignDocument?: FmDocument | undefined;
    owner?: OmSystemUser | undefined;
    pmRentalCondition?: PmRentalCondition[] | undefined;
    pmRentalContractArchObj?: PmRentalContractArchObj[] | undefined;
    pmRentalContractContactRole?: PmRentalContractContactRole[] | undefined;
    pmRentalContractOption?: PmRentalContractOption[] | undefined;
    pmRentalContractOrganisationRole?: PmRentalContractOrganisationRole[] | undefined;
    pmRentalContractRentalUnit?: PmRentalContractRentalUnit[] | undefined;
    rentalContractSpace?: RentalContractSpace[] | undefined;
    renterContact?: OmContact | undefined;
    secondSignee?: OmSystemUser | undefined;
}

export interface PmRentalContractType {
    rentalContractTypeId?: string | undefined;
    name?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    pmRentalContract?: PmRentalContract[] | undefined;
}

export interface PmRentalCondition {
    rentalConditionId?: string | undefined;
    transactionCurrencyId?: string | undefined;
    firstBookingFrom?: Date | undefined;
    rentalConditionType?: string | undefined;
    price?: number | undefined;
    rentalContract?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    uniqueCondition?: boolean | undefined;
    calculationRuleParameterOne?: string | undefined;
    calculationRuleParameterTwo?: string | undefined;
    deleteIndicator?: boolean | undefined;
    deleteDate?: Date | undefined;
    rentalConditionTypeNavigation?: PmRentalConditionType | undefined;
    rentalContractNavigation?: PmRentalContract | undefined;
}

export interface PmRentalConditionType {
    rentalConditionTypeId?: string | undefined;
    name?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    pmRentalCondition?: PmRentalCondition[] | undefined;
}

export interface PmRentalContractArchObj {
    rentalContractId?: string | undefined;
    archObjId?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    typeOfAssignment?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    rentalContract?: PmRentalContract | undefined;
}

export interface PmRentalContractContactRole {
    rentalContractId: string;
    contactId: string;
    roleId: string;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    rentalContractContactRoleId?: string | undefined;
    deleteDate?: Date | undefined;
    contact?: OmContact | undefined;
    rentalContract?: PmRentalContract | undefined;
    role?: OmRole | undefined;
}

export interface OmRole {
    roleId?: string | undefined;
    name?: string | undefined;
    validFrom?: Date;
    validUntil?: Date;
    changeDate?: Date | undefined;
    description?: string | undefined;
    category?: string | undefined;
    deleteDate?: Date | undefined;
    fmIncidentContactRole?: FmIncidentContactRole[] | undefined;
    fmIncidentOrganisationRole?: FmIncidentOrganisationRole[] | undefined;
    omContactArchObjRole?: OmContactArchObjRole[] | undefined;
    omContactRole?: OmContactRole[] | undefined;
    omOrganisationArchObjRole?: OmOrganisationArchObjRole[] | undefined;
    omOrganisationRole?: OmOrganisationRole[] | undefined;
    pmRentalContractContactRole?: PmRentalContractContactRole[] | undefined;
    pmRentalContractOrganisationRole?: PmRentalContractOrganisationRole[] | undefined;
}

export interface FmIncidentContactRole {
    incidentId?: string | undefined;
    contactId?: string | undefined;
    roleId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    contact?: OmContact | undefined;
    incident?: FmIncident | undefined;
    role?: OmRole | undefined;
}

export interface FmIncidentOrganisationRole {
    incidentId?: string | undefined;
    organisationId?: string | undefined;
    roleId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    incident?: FmIncident | undefined;
    organisation?: OmOrganisation | undefined;
    role?: OmRole | undefined;
}

export interface OmContactArchObjRole {
    contactId?: string | undefined;
    archObjId?: string | undefined;
    roleId?: string | undefined;
    validFrom?: Date;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    contact?: OmContact | undefined;
    role?: OmRole | undefined;
}

export interface OmContactRole {
    contactId?: string | undefined;
    roleId?: string | undefined;
    validFrom?: Date;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    contact?: OmContact | undefined;
    role?: OmRole | undefined;
}

export interface OmOrganisationArchObjRole {
    organisationId?: string | undefined;
    archObjId?: string | undefined;
    roleId?: string | undefined;
    validFrom?: Date;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    organisation?: OmOrganisation | undefined;
    role?: OmRole | undefined;
}

export interface OmOrganisationRole {
    organisationId?: string | undefined;
    roleId?: string | undefined;
    validFrom?: Date;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    organisation?: OmOrganisation | undefined;
    role?: OmRole | undefined;
}

export interface PmRentalContractOrganisationRole {
    rentalContractId: string;
    organisationId: string;
    roleId: string;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    rentalContractOrgRoleId?: string | undefined;
    deleteDate?: Date | undefined;
    organisation?: OmOrganisation | undefined;
    rentalContract?: PmRentalContract | undefined;
    role?: OmRole | undefined;
}

export interface PmRentalContractOption {
    id?: string | undefined;
    ruleNo?: string | undefined;
    optionIsCurrent?: boolean | undefined;
    optionType?: string | undefined;
    currentOptionDrawing?: number | undefined;
    optionStatus?: string | undefined;
    optionCount?: number | undefined;
    optionYears?: number | undefined;
    optionMonths?: number | undefined;
    optionDays?: number | undefined;
    optionRounding?: string | undefined;
    notificationYears?: number | undefined;
    notificationMonths?: number | undefined;
    notificationDays?: number | undefined;
    notificationWeeks?: number | undefined;
    notificationRounding?: string | undefined;
    rentalContractId?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    rentalContract?: PmRentalContract | undefined;
}

export interface PmRentalContractRentalUnit {
    rentalContractId?: string | undefined;
    rentalUnitId?: string | undefined;
    validFrom?: Date;
    validUnitl?: Date | undefined;
    typeOfRentalUnitAssignment?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    rentalContract?: PmRentalContract | undefined;
    rentalUnit?: PmRentalUnit | undefined;
}

export interface RentalContractSpace {
    id?: string | undefined;
    rentalContractId?: string | undefined;
    economicUnitArchObjId?: string | undefined;
    landArchObjId?: string | undefined;
    buildingArchObjId?: string | undefined;
    spaceArchObjId?: string | undefined;
    changeDate?: Date | undefined;
    buildingArchObj?: DtArchObjHierarchy | undefined;
    economicUnitArchObj?: DtArchObjHierarchy | undefined;
    landArchObj?: DtArchObjHierarchy | undefined;
    rentalContract?: PmRentalContract | undefined;
    spaceArchObj?: DtArchObjHierarchy | undefined;
}

export interface FmWorkOrderMilestone {
    workOrderId?: string | undefined;
    milestoneNo?: number;
    fixedDate?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    workOrder?: FmWorkOrder | undefined;
}

export interface FmWorkOrderServiceTask {
    workOrderServiceTaskId?: string | undefined;
    workOrderId?: string | undefined;
    serviceTaskTypeId?: string | undefined;
    description?: string | undefined;
    name: string;
    maintenanceGroupId?: string | undefined;
    completed?: boolean | undefined;
    checkListId?: string | undefined;
    taskPosition?: number | undefined;
    deleteDate?: Date | undefined;
    checkList?: FmChecklistVersion | undefined;
    fmChecklistResponse?: FmChecklistResponse[] | undefined;
    maintenanceGroup?: FmBookableResourceCategory | undefined;
    serviceTaskType?: FmServiceTaskType | undefined;
    workOrder?: FmWorkOrder | undefined;
}

export interface FmChecklistVersion {
    id?: string | undefined;
    title: string;
    description?: string | undefined;
    requiredToAnswer?: boolean;
    version?: number;
    versionNumber: string;
    checkListId: string;
    checkList?: FmChecklist | undefined;
    fmChecklistGroup?: FmChecklistGroup[] | undefined;
    fmWorkOrderServiceTask?: FmWorkOrderServiceTask[] | undefined;
}

export interface FmChecklist {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    fmChecklistVersion?: FmChecklistVersion[] | undefined;
    fmServiceTaskType?: FmServiceTaskType[] | undefined;
}

export interface FmServiceTaskType {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
    estimatedDuration?: number | undefined;
    inspectionEnabled?: boolean | undefined;
    inspectionId?: string | undefined;
    deleteDate?: Date | undefined;
    checkListId?: string | undefined;
    checkList?: FmChecklist | undefined;
    fmWorkOrderServiceTask?: FmWorkOrderServiceTask[] | undefined;
}

export interface FmChecklistGroup {
    id?: string | undefined;
    title: string;
    description?: string | undefined;
    name: string;
    checkListVersionId: string;
    checkListVersion?: FmChecklistVersion | undefined;
    fmChecklistEntry?: FmChecklistEntry[] | undefined;
}

export interface FmChecklistEntry {
    id?: string | undefined;
    checklistGroupId: string;
    name: string;
    required?: boolean | undefined;
    title?: string | undefined;
    checklistEntryType?: number;
    dataType?: string | undefined;
    checklistGroup?: FmChecklistGroup | undefined;
    fmChecklistEntryChoice?: FmChecklistEntryChoice[] | undefined;
    fmChecklistResponse?: FmChecklistResponse[] | undefined;
}

export interface FmChecklistEntryChoice {
    id?: string | undefined;
    checklistEntryId: string;
    order?: number;
    text?: string | undefined;
    checklistEntry?: FmChecklistEntry | undefined;
}

export interface FmChecklistResponse {
    id?: string | undefined;
    checklistEntryId: string;
    workOrderServiceTaskId: string;
    charResponse?: string | undefined;
    numResponse?: number | undefined;
    dateResponse?: Date | undefined;
    boolResponse?: boolean | undefined;
    checklistEntry?: FmChecklistEntry | undefined;
    workOrderServiceTask?: FmWorkOrderServiceTask | undefined;
}

export interface FmBookableResourceCategory {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
    fmWorkOrderServiceTask?: FmWorkOrderServiceTask[] | undefined;
}

export interface OmOrganisationalUnit {
    organisationalUnitId?: string | undefined;
    name?: string | undefined;
    deleteDate?: Date | undefined;
    serviceProviderId?: string | undefined;
    fmBookableRessource?: FmBookableRessource[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
    serviceProvider?: OmOrganisation | undefined;
}

export interface FmIncidentType {
    incidentTypeId?: string | undefined;
    litArtCode?: string | undefined;
    regIsDataRetrieval?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    name?: string | undefined;
    fmIncident?: FmIncident[] | undefined;
    fmWorkOrder?: FmWorkOrder[] | undefined;
}

export interface OmContactAddress {
    contactId?: string | undefined;
    addressId?: string | undefined;
    changeDate?: Date | undefined;
    validFrom?: Date;
    validUnitl?: Date | undefined;
    addressType?: string | undefined;
    deleteDate?: Date | undefined;
    address?: OmAddress | undefined;
    contact?: OmContact | undefined;
}

export interface OmContactAuthorization {
    archObjAuthorizationId?: string | undefined;
    contactId: string;
    archObjId: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    contact?: OmContact | undefined;
}

export interface OmCustomer {
    id?: string | undefined;
    name1?: string | undefined;
    name2?: string | undefined;
    name3?: string | undefined;
    name4?: string | undefined;
    contactId?: string | undefined;
    organisationId?: string | undefined;
    changeDate?: Date | undefined;
    contact?: OmContact | undefined;
    organisation?: OmOrganisation | undefined;
}

export interface FmBguProject {
    id?: string | undefined;
    name: string;
    archObjId?: string | undefined;
    ticketNumber?: string | undefined;
    externalReference?: string | undefined;
    bguStatus?: string | undefined;
    budgetType?: string | undefined;
    generalContractor?: string | undefined;
    auxAccountAssignment?: string | undefined;
    priority?: string | undefined;
    product?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    bguStatusText?: string | undefined;
    budgetTypeText?: string | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    fmBguProjectMilestone?: FmBguProjectMilestone[] | undefined;
    idNavigation?: FmIncident | undefined;
}

export interface FmBguProjectMilestone {
    id?: string | undefined;
    bguProjectId: string;
    bguMilestoneId: string;
    milestoneDate?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    bguMilestone?: FmBguMilestone | undefined;
    bguProject?: FmBguProject | undefined;
}

export interface FmBguMilestone {
    id?: string | undefined;
    description: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    fmBguProjectMilestone?: FmBguProjectMilestone[] | undefined;
}

export interface FmIncidentOffer {
    id?: string | undefined;
    offerId: string;
    incidentId: string;
    typeId: string;
    value?: number;
    authorizationChain?: number;
    statusId: string;
    createDate?: Date;
    validUntil?: Date | undefined;
    incident?: FmIncident | undefined;
    status?: SysEnum | undefined;
    type?: SysEnum | undefined;
}

export interface FmIncidentGrading {
    incidentGradingId?: string | undefined;
    name?: string | undefined;
    deleteDate?: Date | undefined;
    fmIncident?: FmIncident[] | undefined;
}

export interface IncidentTransmission {
    id?: number;
    incidentId: string;
    transmissionState: string;
    externalIncidentId?: string | undefined;
    changedAtUtc?: Date | undefined;
    createdAtUtc?: Date;
    interfaceStateId: string;
    referenceObjectId?: string | undefined;
    incident?: FmIncident | undefined;
    interfaceState?: SysEnum | undefined;
}

export interface PmIncidentRealEstateDecision {
    incidentId?: string | undefined;
    expectedStrategyIetId?: string | undefined;
    gksforPreparationIncludingSecurityIet?: number | undefined;
    gksforSeparationIncludingSecurityIet?: number | undefined;
    gksseparationUploadedIetId?: string | undefined;
    projectNumberBgupreparationIet?: string | undefined;
    projectNumberBguseparationIet?: string | undefined;
    uploadLegalMatrixIetId?: string | undefined;
    expectedStrategyIet?: SysEnum | undefined;
    gksseparationUploadedIet?: SysEnum | undefined;
    incident?: FmIncident | undefined;
    uploadLegalMatrixIet?: SysEnum | undefined;
}

export interface PmIncidentRentalContractMgmt {
    id?: string | undefined;
    addendumPartialPaymentCompletedId?: string | undefined;
    amvAdjustedId?: string | undefined;
    amvCreatedId?: string | undefined;
    areasReturnDateGmg?: Date | undefined;
    areasReturnDateLessor?: Date | undefined;
    areasTransferredGmgId?: string | undefined;
    areasTransferredOwnerLessorId?: string | undefined;
    assetRecognitionCompletedId?: string | undefined;
    assetRecognitionTriggeredId?: string | undefined;
    assetTransferCompletedId?: string | undefined;
    assetTransferTriggeredId?: string | undefined;
    basicServiceCommissionCompletedId?: string | undefined;
    basicServiceCommissionTriggeredId?: string | undefined;
    basicServiceTerminationCompletedId?: string | undefined;
    basicServiceTerminationInitiatedId?: string | undefined;
    bguTicketId?: string | undefined;
    boardId?: string | undefined;
    branchesInformedTerminationId?: string | undefined;
    branchesInformedPartialTerminationOrExtensionId?: string | undefined;
    clearingAreasCompletedId?: string | undefined;
    clearingAreasTriggeredId?: string | undefined;
    commissionInvoiceApprovedId?: string | undefined;
    consultingOrderEmtPostedId?: string | undefined;
    coordinatedMilestonePlanningAvailableId?: string | undefined;
    dismantlingCompletedId?: string | undefined;
    dismantlingImplementedId?: string | undefined;
    dismantlingOfferApprovedId?: string | undefined;
    dismantlingOfferCreatedId?: string | undefined;
    dismantlingOfferPostedFlmId?: string | undefined;
    dismantlingOfferTriggeredBamId?: string | undefined;
    draftContractIssMakeId?: string | undefined;
    draftsupplementIssMakeId?: string | undefined;
    easementAdjustmentTriggeredGsusSaeId?: string | undefined;
    electricityBillingSpecificationRequestedPasmId?: string | undefined;
    emtCompletedId?: string | undefined;
    flmInformedTerminationId?: string | undefined;
    hsinformedAreaRetractionId?: string | undefined;
    hsinformedPartialTerminationOrExtensionId?: string | undefined;
    hsinformedTerminationId?: string | undefined;
    lanCablingCompletedId?: string | undefined;
    lanCablingTriggeredId?: string | undefined;
    lesserInformedTerminationId?: string | undefined;
    flmInformedPartialTerminationOrExtensionId?: string | undefined;
    managementSummaryAdjustedId?: string | undefined;
    negativeDeviationNegotiationOrderId?: string | undefined;
    omvAdjustmentConfirmedId?: string | undefined;
    omvCreationSapCompletedId?: string | undefined;
    ownerInformedPartialTerminationOrExtensionId?: string | undefined;
    pasmRequestResult?: string | undefined;
    preparationOfferTargetAreasApprovedId?: string | undefined;
    preparationOfferTargetAreasCreatedId?: string | undefined;
    preparationOfferTargetAreasPostedFlmId?: string | undefined;
    preparationOfferTargetAreasTriggeredBamId?: string | undefined;
    preparationTargetAreasCompletedId?: string | undefined;
    preparationTargetAreasImplementedId?: string | undefined;
    releaseTriggeredId?: string | undefined;
    relocationCompletedId?: string | undefined;
    relocationtriggeredFlmId?: string | undefined;
    separationCompletedId?: string | undefined;
    separationImplementedId?: string | undefined;
    separationOfferApprovedId?: string | undefined;
    separationOfferCreatedId?: string | undefined;
    separationOfferPostedFlmId?: string | undefined;
    separationOfferTriggeredBamId?: string | undefined;
    bguEmtTicketId?: string | undefined;
    bguPreparationTicketId?: string | undefined;
    bguDismantlingsTicketId?: string | undefined;
    bguSeparationTicketId?: string | undefined;
    noteInformationField?: string | undefined;
    bguEmtTicketIdtext?: string | undefined;
    bguPreparationTicketIdText?: string | undefined;
    bguDismantlingsTicketIdText?: string | undefined;
    bguSeparationTicketIdText?: string | undefined;
    addendumPartialPaymentCompleted?: SysEnum | undefined;
    amvAdjusted?: SysEnum | undefined;
    amvCreated?: SysEnum | undefined;
    areasTransferredGmg?: SysEnum | undefined;
    areasTransferredOwnerLessor?: SysEnum | undefined;
    assetRecognitionCompleted?: SysEnum | undefined;
    assetRecognitionTriggered?: SysEnum | undefined;
    assetTransferCompleted?: SysEnum | undefined;
    assetTransferTriggered?: SysEnum | undefined;
    basicServiceCommissionCompleted?: SysEnum | undefined;
    basicServiceCommissionTriggered?: SysEnum | undefined;
    basicServiceTerminationCompleted?: SysEnum | undefined;
    basicServiceTerminationInitiated?: SysEnum | undefined;
    bguDismantlingsTicket?: FmIncident | undefined;
    bguEmtTicket?: FmIncident | undefined;
    bguPreparationTicket?: FmIncident | undefined;
    bguSeparationTicket?: FmIncident | undefined;
    bguTicket?: FmIncident | undefined;
    board?: SysEnum | undefined;
    branchesInformedPartialTerminationOrExtension?: SysEnum | undefined;
    branchesInformedTermination?: SysEnum | undefined;
    clearingAreasCompleted?: SysEnum | undefined;
    clearingAreasTriggered?: SysEnum | undefined;
    commissionInvoiceApproved?: SysEnum | undefined;
    consultingOrderEmtPosted?: SysEnum | undefined;
    coordinatedMilestonePlanningAvailable?: SysEnum | undefined;
    dismantlingCompleted?: SysEnum | undefined;
    dismantlingImplemented?: SysEnum | undefined;
    dismantlingOfferApproved?: SysEnum | undefined;
    dismantlingOfferCreated?: SysEnum | undefined;
    dismantlingOfferPostedFlm?: SysEnum | undefined;
    dismantlingOfferTriggeredBam?: SysEnum | undefined;
    draftContractIssMake?: SysEnum | undefined;
    draftsupplementIssMake?: SysEnum | undefined;
    easementAdjustmentTriggeredGsusSae?: SysEnum | undefined;
    electricityBillingSpecificationRequestedPasm?: SysEnum | undefined;
    emtCompleted?: SysEnum | undefined;
    flmInformedPartialTerminationOrExtension?: SysEnum | undefined;
    flmInformedTermination?: SysEnum | undefined;
    hsinformedAreaRetraction?: SysEnum | undefined;
    hsinformedPartialTerminationOrExtension?: SysEnum | undefined;
    hsinformedTermination?: SysEnum | undefined;
    idNavigation?: FmIncident | undefined;
    lanCablingCompleted?: SysEnum | undefined;
    lanCablingTriggered?: SysEnum | undefined;
    lesserInformedTermination?: SysEnum | undefined;
    managementSummaryAdjusted?: SysEnum | undefined;
    negativeDeviationNegotiationOrder?: SysEnum | undefined;
    omvAdjustmentConfirmed?: SysEnum | undefined;
    omvCreationSapCompleted?: SysEnum | undefined;
    ownerInformedPartialTerminationOrExtension?: SysEnum | undefined;
    preparationOfferTargetAreasApproved?: SysEnum | undefined;
    preparationOfferTargetAreasCreated?: SysEnum | undefined;
    preparationOfferTargetAreasPostedFlm?: SysEnum | undefined;
    preparationOfferTargetAreasTriggeredBam?: SysEnum | undefined;
    preparationTargetAreasCompleted?: SysEnum | undefined;
    preparationTargetAreasImplemented?: SysEnum | undefined;
    releaseTriggered?: SysEnum | undefined;
    relocationCompleted?: SysEnum | undefined;
    relocationtriggeredFlm?: SysEnum | undefined;
    separationCompleted?: SysEnum | undefined;
    separationImplemented?: SysEnum | undefined;
    separationOfferApproved?: SysEnum | undefined;
    separationOfferCreated?: SysEnum | undefined;
    separationOfferPostedFlm?: SysEnum | undefined;
    separationOfferTriggeredBam?: SysEnum | undefined;
}

export interface PmPropertyBrochure {
    propertyBrochureId?: string | undefined;
    name: string;
    propertyDescription?: string | undefined;
    locationDescription?: string | undefined;
    nameEn?: string | undefined;
    propertyDescriptionEn?: string | undefined;
    locationDescriptionEn?: string | undefined;
    noOfRooms?: number | undefined;
    basicRent?: number | undefined;
    ancillaryCosts?: number | undefined;
    totalRent?: number | undefined;
    status?: string | undefined;
    changeDate?: Date | undefined;
    rentalUnitId?: string | undefined;
    rentalSpace?: number | undefined;
    occupationType?: string | undefined;
    deviatorRent?: number | undefined;
    deleteDate?: Date | undefined;
    deposit?: number | undefined;
    deviatOrDeposit?: number | undefined;
    minimumRentalTime?: number | undefined;
    fmDocument?: FmDocument[] | undefined;
    fmIncident?: FmIncident[] | undefined;
    pmPropertyBrochureAttribute?: PmPropertyBrochureAttribute[] | undefined;
    pmPropertyBrochureAvailability?: PmPropertyBrochureAvailability[] | undefined;
    rentalUnit?: PmRentalUnit | undefined;
}

export interface PmPropertyBrochureAttribute {
    propertyBrochureAttributeId?: string | undefined;
    description?: string | undefined;
    descriptionEn?: string | undefined;
    statuscode?: string | undefined;
    propertyBrochureId?: string | undefined;
    name: string;
    nameEn?: string | undefined;
    attributeClass?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    propertyBrochure?: PmPropertyBrochure | undefined;
}

export interface PmPropertyBrochureAvailability {
    propertyBrochureAvailabilityId?: string | undefined;
    statusCode?: string | undefined;
    propertyBrochureId: string;
    name?: string | undefined;
    moveInDate?: Date;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    fmIncident?: FmIncident[] | undefined;
    propertyBrochure?: PmPropertyBrochure | undefined;
}

export interface FmRoutingType {
    routingTypeId?: string | undefined;
    name: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    fmIncident?: FmIncident[] | undefined;
}

export interface SapIncidentOrder {
    orderNo?: string | undefined;
    incidentId: string;
    createdOn?: Date;
    incident?: FmIncident | undefined;
    sapIncidentOrderPos?: SapIncidentOrderPos[] | undefined;
}

export interface SapIncidentOrderPos {
    orderNo?: string | undefined;
    posNoPurchaseReceipt?: string | undefined;
    packageNo?: string | undefined;
    rowNumInternal?: string | undefined;
    rowNum?: string | undefined;
    serviceNo?: string | undefined;
    orderNoNavigation?: SapIncidentOrder | undefined;
}

export interface SapIssTicketData {
    incidentId?: string | undefined;
    empsl?: string | undefined;
    leadtime?: string | undefined;
    plantime?: string | undefined;
    requestid?: string | undefined;
    approvalreviewid?: string | undefined;
    incident?: FmIncident | undefined;
}

export interface PmRentalUnitArchObj {
    archObjId?: string | undefined;
    rentalUnitId?: string | undefined;
    validFrom?: Date | undefined;
    validUnitl?: Date | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    rentalUnit?: PmRentalUnit | undefined;
}

export interface DtTechObjType {
    techObjTypeId?: string | undefined;
    parentTechObjTypeId?: string | undefined;
    name?: string | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    dtTechObjHierarchy?: DtTechObjHierarchy[] | undefined;
}

export interface OmOrganisationAddress {
    organisationId?: string | undefined;
    addressId?: string | undefined;
    changeDate?: Date | undefined;
    validFrom?: Date;
    validUnitl?: Date | undefined;
    addressType?: string | undefined;
    deleteDate?: Date | undefined;
    address?: OmAddress | undefined;
    organisation?: OmOrganisation | undefined;
}

export interface DtArchObjNews {
    id?: string | undefined;
    archObjId: string;
    text?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    isPublished?: boolean | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
}

export interface DtDistrict {
    districtId?: string | undefined;
    name: string;
    changeDate?: Date | undefined;
    type: string;
    alternateKey?: string | undefined;
    name2?: string | undefined;
    name3?: string | undefined;
    deleteDate?: Date | undefined;
    district?: DtArchObjHierarchy | undefined;
}

export interface DtEquipment {
    id?: string | undefined;
    idNavigation?: DtArchObjHierarchy | undefined;
}

export interface DtLand {
    landId?: string | undefined;
    name: string;
    landCode?: number | undefined;
    type?: string | undefined;
    landParcelNr?: number | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    servitudeId?: string | undefined;
    georefId?: string | undefined;
    changeDate?: Date | undefined;
    name2?: string | undefined;
    name3?: string | undefined;
    typeOfOwnership?: string | undefined;
    deleteDate?: Date | undefined;
    displayname?: string | undefined;
    landArea?: number | undefined;
    builtUpArea?: number | undefined;
    vehicleSpacePlot?: number | undefined;
    freeStorageArea?: number | undefined;
    agriculturalAndForest?: number | undefined;
    imk?: string | undefined;
    typeOfOwnershipSap?: string | undefined;
    typeOfOwnershipAgg?: string | undefined;
    siteCode?: string | undefined;
    realValidFrom?: Date | undefined;
    realValidUntil?: Date | undefined;
    land?: DtArchObjHierarchy | undefined;
}

export interface DtSubArea {
    id?: string | undefined;
    name?: string | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
    name2?: string | undefined;
    name3?: string | undefined;
    displayname?: string | undefined;
    deleteDate?: Date | undefined;
    idNavigation?: DtArchObjHierarchy | undefined;
}

export interface PmRentalListing {
    id?: number;
    archObjId: string;
    title: string;
    description?: string | undefined;
    link?: string | undefined;
    linkDisplayName?: string | undefined;
    isPublished?: boolean;
    longitude?: number | undefined;
    latitude?: number | undefined;
    primaryDocumentId?: number | undefined;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    createdAt?: Date | undefined;
    archObj?: DtArchObjHierarchy | undefined;
    pmRentalListingDocument?: PmRentalListingDocument[] | undefined;
    primaryDocument?: PmRentalListingDocument | undefined;
}

export interface PmRentalListingDocument {
    id?: number;
    rentalListingId?: number;
    archiveId: string;
    fileName: string;
    pmRentalListing?: PmRentalListing[] | undefined;
    rentalListing?: PmRentalListing | undefined;
}

export interface SysEnumTranslation {
    id?: string | undefined;
    enumId: string;
    language: string;
    name: string;
    changeDate?: Date | undefined;
    deleteDate?: Date | undefined;
    enum?: SysEnum | undefined;
}

export interface VersionedDocumentViewModel extends FmDocument {
    oldVersions?: FmDocument[] | undefined;
}

export interface SetFileVisibility {
    documentId?: string | undefined;
    visibilityId?: string | undefined;
}

export interface Exception {
    Message?: string;
    InnerException?: Exception | undefined;
    Source?: string | undefined;
    StackTrace?: string | undefined;
}

export interface SmartPortalException extends Exception {
    processError?: SmartPortalProcessError;
    message?: string;
}

export enum SmartPortalProcessError {
    USER_DOES_NOT_EXIST_IN_DATABASE = 0,
    GUARD_CLAUSE_FAILED = 1,
    USER_IS_NOT_UNIQUE = 2,
    USER_HAS_NO_ORGANISATIONID = 3,
    TEXT_EXCEEDS_LENGTH = 10,
    MAX_KEY_NUMBER_REACHED = 15,
    ROLE_VIEW_COMBINATION_INVALID = 20,
    OFFERING_RESERVATION_WITH_EMAIL_ALREADY_EXISTS = 1001,
    EXPOSE_CANT_BE_BOOKED_WITH_GIVEN_PARAMS = 1002,
    EXPOSE_COULD_NOT_BE_FOUND = 1003,
    USER_MANDANT_IS_NOT_ALLOWED_TO_ACCESS_VIEW = 2000,
    USER_IS_NOT_ALLOWED_TO_ACCESS_INCIDENT = 2001,
    COULD_NOT_DETERMINE_LOCATION_FOR_INCIDENT_CREATION = 2002,
    USER_IS_NOT_ALLOWED_TO_ACCESS_VIEW = 2003,
    INCIDENT_ALREADY_EXISTS = 2004,
    TASK_COULD_NOT_BE_FOUND_OR_ACCESSED = 3000,
    CONFIGURATION_ROW_HAS_NO_VALID_NAME = 3001,
    COULD_NOT_RESOLVE_ATTRIBUTE_NAME = 3002,
    CONFIGURATION_ROW_HAS_NO_VALID_OPTIONSETTYPE = 3003,
    WORKORDER_COULD_NOT_BE_FOUND_OR_ACCESSED = 4000,
    FUNCTIONAL_LOCATION_COULD_NOT_BE_ACCESSED = 4001,
    USER_HAS_NO_RENTAL_CONTRACT = 5000,
    USER_HAS_ACTIVE_TERMINATION_REQUEST = 5001,
    USER_ID_NOT_RETRIEVABLE = 5002,
    USERTOKEN_DOES_NOT_INCLUDE_EMAIL = 6000,
    NOT_EMPLOYEE_USER = 6010,
    USER_MISSING_ROLE = 6020,
    B2C_MAIL_ALREADY_USED = 8001,
    B2C_USER_NOT_ASSIGNED_TO_MANDANT = 8002,
    ROLES_ALREADY_ASSIGNED_OR_REQUESTED = 8100,
    ROLES_ALREADY_REQUESTED = 8101,
    DATACONTRACT_PROBABLY_NOT_UP_TO_DATE = 10000,
    FILE_UPLOAD_SIZE = 11000,
    FILE_CONTENT_TYPE = 11100,
    FILE_NAME = 11200,
    FILE_NOT_FOUND = 11300,
    FILESIZE_NOT_SET = 11350,
    FILESIZE_DOWNLOAD_LIMIT = 11400,
    FILE_BLOBNAME_NOT_SET = 11500,
    FILE_DELETION_MISSING_AUTHORIZATION = 11600,
    EDIT_VISIBILITY_NOT_ALLOWED = 11700,
    DATE_ALREADY_RESERVED = 11800,
    FROZEN_ZONE_COLLISION = 11900,
    NO_AVAILABLE_SPACE = 12000,
    NOT_DISPO = 12100,
    NOT_USAGE = 12200,
    USAGE_NOT_DELETABLE = 12300,
    ACTIVE_DETAIL_USAGE = 12400,
    ACTIVE_SBU_USAGE = 12500,
    INVALID_DATE_RANGE = 12600,
    CALCULATION_TYPE_NOT_EDITABLE = 12700,
    INVALID_NUMBER_OF_WORKSPACES = 12800,
    INVALID_DATE = 12900,
    BILLING_AREA_REQUIRED_BY_CALCULATION_TYPE = 12950,
    MASSEDITROOMS_ERROR = 13000,
    CONFLICTING_SUBSTITUTIONS = 14000,
}

export interface CreateIncidentFromPortalDTO {
    incidentDTO?: AddIncidentDTO;
    files?: UploadFile[] | undefined;
}

export interface AddIncidentDTO {
    incidentTitle?: string;
    incidentClass?: string;
    incidentType?: IncidentType | undefined;
    incidentClassMiscText?: string | undefined;
    incidentDescription?: string;
    contactInformation?: string | undefined;
    powerOfDisposition?: string | undefined;
    targetLocation?: AddressDTO | undefined;
    concerningLocation?: AddressDTO | undefined;
    requestingContact?: ContactDTO;
    concerningContact?: ContactDTO | undefined;
    requestSource?: RequestSource | undefined;
    ciamId?: string | undefined;
}

export enum IncidentType {
    Eigentuemerbelange = 0,
    Mietmanagement = 1,
    Serviceanfrage = 2,
    Kundenprozesse = 3,
}

export interface AddressDTO {
    archObjId?: string | undefined;
    city?: string | undefined;
    zipcode?: string | undefined;
    street?: string | undefined;
    state?: string | undefined;
    plotNumber?: string | undefined;
    additionalInformation?: string | undefined;
}

export interface ContactDTO {
    firstname?: string;
    lastname?: string;
    salutation?: string | undefined;
    jobTitle?: string | undefined;
    email?: string;
    phonenumber?: string;
    accountString?: string | undefined;
    address?: AddressDTO;
    subscribeNewsletter?: boolean | undefined;
}

export enum RequestSource {
    TaskModule = 0,
    LandingPage = 1,
}

export interface CreateIncidentAuthenticatedFromPortalDTO {
    incidentDTO?: AddIncidentAuthenticatedDTO;
    files?: UploadFile[] | undefined;
}

export interface AddIncidentAuthenticatedDTO {
    incidentTitle: string;
    incidentDescription: string;
    incidentClassId: string;
    incidentType?: IncidentType | undefined;
    createdById: string;
    functionalLocationId?: string | undefined;
    alternateAddress?: AddressDTO | undefined;
    shouldUserReceiveAcknowledgement?: boolean;
    parentIncidentId?: string | undefined;
    externalLetting?: AddExternalLettingDTO | undefined;
    ciamId?: string | undefined;
}

export interface AddExternalLettingDTO {
    nameOfProspectiveTenantsId?: string | undefined;
    requestedArea?: number | undefined;
    requestedParkingSpaces?: number | undefined;
    pricePerSquareMeter?: number | undefined;
    rentalPricePerParkingSpace?: number | undefined;
    durationMonths?: number | undefined;
    setupRenterDecisionId?: string | undefined;
    descriptionTenantSpecificPreparation?: string | undefined;
    maintenanceMeasuresId?: string | undefined;
    incentives?: string | undefined;
}

export interface IncidentIdResult {
    incidentId?: string;
    ticketNumber?: string;
}

export interface CreateEmployeeNotificationRequest {
    employeeNotification?: CreateEmployeeNotificationDTO | undefined;
    files?: UploadFile[] | undefined;
}

export interface CreateEmployeeNotificationDTO {
    incidentTitle?: string | undefined;
    incidentDescription?: string | undefined;
    incidentClass?: string | undefined;
    incidentType?: IncidentType | undefined;
    roomNumber?: string | undefined;
    structuralPart?: string | undefined;
    deviatingAddress?: string | undefined;
    floor?: string | undefined;
    mails?: string | undefined;
    targetLocation?: AddressDTO | undefined;
    creator?: EmployeeDTO | undefined;
    numberOfInitialDocuments?: number;
    source?: string | undefined;
    externalReference?: string | undefined;
}

export interface EmployeeDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export interface ServiceRequestViewModel {
    incidentId?: string;
    ticketNumber?: string;
    blobfilename?: string | undefined;
}

export interface CreateServiceRequestFromPortal {
    serviceRequest?: CreateServiceRequestRequest | undefined;
    files?: UploadFile[] | undefined;
}

export interface CreateServiceRequestRequest {
    incidentTitle?: string | undefined;
    serviceRequestCreatorId?: string | undefined;
    incidentLocationId?: string | undefined;
    deliveryAddressFirstName?: string | undefined;
    deliveryAddressLastName?: string | undefined;
    deliveryAddressEmail?: string | undefined;
    deliveryAddressStreet?: string | undefined;
    deliveryAddressPostal?: string | undefined;
    deliveryAddressState?: string | undefined;
    deliveryAddressOrgunit?: string | undefined;
    deliveryAddressCompany?: string | undefined;
    objectPostalCode?: string | undefined;
    objectCity?: string | undefined;
    objectStreetName?: string | undefined;
    serviceRequestKeyQuantity?: number;
    additionalInfo?: string | undefined;
    mails?: string | undefined;
    keys?: ServiceRequestKey[] | undefined;
    incidentDescription?: string;
    isExceedingCombinedTextLength?: boolean;
    contactCompany?: string | undefined;
    contactRessort?: string | undefined;
    contactFirstAndLastname?: string | undefined;
    contactCreateDate?: string | undefined;
    contactAddress?: string | undefined;
    contactPhone?: string | undefined;
}

export interface ServiceRequestKey {
    manufacturer?: string | undefined;
    number?: string | undefined;
    amount?: number;
    roomNumber?: string | undefined;
}

export interface CreateFurnitureOrderRequest {
    furnitureOrder?: CreateFurnitureOrder | undefined;
    files?: UploadFile[] | undefined;
}

export interface CreateFurnitureOrder {
    incidentTitle?: string | undefined;
    incidentDescription?: string | undefined;
    incidentClass?: string | undefined;
    incidentType?: IncidentType | undefined;
    requestedDate?: Date | undefined;
    floor?: string | undefined;
    roomNumber?: string | undefined;
    deskNumber?: string | undefined;
    flooringHard?: boolean | undefined;
    flooringSoft?: boolean | undefined;
    statementBad?: boolean | undefined;
    electricDesk?: boolean | undefined;
    specialOrder?: boolean | undefined;
    severeDisability?: boolean | undefined;
    teleWork?: boolean | undefined;
    creatorId?: string | undefined;
    contactPersonId?: string | undefined;
    pspElement?: string | undefined;
    archObjId?: string | undefined;
    deliveryAddressFirstName?: string | undefined;
    deliveryAddressLastName?: string | undefined;
    deliveryAddressStreet?: string | undefined;
    deliveryAddressPostalCode?: string | undefined;
    deliveryAddressCity?: string | undefined;
}

export interface CreateRelocationRequest {
    relocation?: CreateRelocation | undefined;
    files?: UploadFile[] | undefined;
}

export interface CreateRelocation {
    incidentTitle?: string | undefined;
    incidentDescription?: string | undefined;
    incidentClass?: string | undefined;
    incidentType?: IncidentType | undefined;
    workersCouncilApproved?: boolean | undefined;
    areaChangeCreated?: boolean | undefined;
    originAdressId?: string | undefined;
    originFirstName?: string | undefined;
    originLastName?: string | undefined;
    originStreetNameHouseNumber?: string | undefined;
    originPostalCode?: string | undefined;
    originCity?: string | undefined;
    targetAdressId?: string | undefined;
    targetFirstName?: string | undefined;
    targetLastName?: string | undefined;
    targetStreetNameHouseNumber?: string | undefined;
    targetPostalCode?: string | undefined;
    targetCity?: string | undefined;
    requestedDate?: Date | undefined;
    creator?: OmEmployee | undefined;
    contactPerson?: OmEmployee | undefined;
    originFloor?: string | undefined;
    originRoom?: string | undefined;
    originWorkplace?: string | undefined;
    targetFloor?: string | undefined;
    targetRoom?: string | undefined;
    targetWorkplace?: string | undefined;
}

export interface IncidentViewModel {
    incidentId?: string;
    name?: string;
    archObjId?: string;
    description?: string;
    ticketNumber?: string;
    statusReason?: string;
    deadline?: Date | undefined;
    changeDate?: Date | undefined;
    createdOn?: Date | undefined;
    documentMetadata?: DocumentMetadata[];
    externalCompletion?: Date | undefined;
    archObj?: DtArchObjHierarchy;
    notifyingContact?: ContactViewModel;
    fmDocument?: FmDocument[];
    statusNavigation?: SysEnum;
    statusReasonNavigation?: SysEnum;
    incidentClass?: IncidentClassViewModel;
    archObjViewModel?: ArchObjViewModel | undefined;
    hasDocuments?: boolean;
    fmTask?: TaskViewModel[];
}

export interface DocumentMetadata {
    rowKey?: string | undefined;
    partitionKey?: string | undefined;
    timestamp?: Date | undefined;
    eTag?: ETag;
    entityId?: string | undefined;
    created?: Date | undefined;
    status?: UploadStatus | undefined;
    targetSystem?: TargetSystem;
    failedUploadAttempts?: number | undefined;
    documentId?: string | undefined;
    name?: string;
    guidExternalSystem?: string | undefined;
    crmGuidOriginRecord?: string | undefined;
    filename?: string;
    dynamicsUri?: string | undefined;
    publishDocument?: boolean | undefined;
    statusCode?: string | undefined;
    quoteId?: string | undefined;
    workOrderId?: string | undefined;
    contactId?: string | undefined;
    rentalContractId?: string | undefined;
    frameworkAgreementId?: string | undefined;
    taskId?: string | undefined;
    functionalLocationId?: string | undefined;
    accountId?: string | undefined;
    purchaseOrderId?: string | undefined;
    agreementId?: string | undefined;
    incidentId?: string | undefined;
    changeDate?: Date | undefined;
    contentType?: string | undefined;
    propertyBrochureId?: string | undefined;
    documentTypeId?: string | undefined;
    deleted?: boolean | undefined;
    blobFilename?: string | undefined;
    uploaded?: boolean | undefined;
    apiError?: string | undefined;
    apiErrorDetails?: string | undefined;
    deleteDate?: Date | undefined;
    imageMaster?: boolean | undefined;
    isInternal?: boolean | undefined;
    visibilityId?: string | undefined;
    filesize?: number | undefined;
    systemUserId?: string | undefined;
}

/** Represents an HTTP ETag. */
export interface ETag {
}

export enum UploadStatus {
    InUebertragung = 0,
    Fehlgeschlagen = 1,
}

export enum TargetSystem {
    Remdoc = 0,
    ImageMaster = 1,
}

export interface ContactViewModel {
    contactId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    telephone?: string;
    organisation?: OrganisationViewModel | undefined;
}

export interface OrganisationViewModel {
    id?: string;
    name?: string;
}

export interface IncidentClassViewModel {
    incidentClass?: string;
}

export interface ArchObjViewModel {
    name?: string;
    changeDate?: Date | undefined;
}

export interface TaskViewModel extends FmTask {
    documentMetadata?: DocumentMetadata[] | undefined;
    externalProcessorFullName?: string;
}

export interface SmartPortalErrorDetails {
    errorCode?: SmartPortalProcessError;
    message?: string | undefined;
}

export interface ResultWrapperOfIncidentTableEntryViewModel {
    entites?: IncidentTableEntryViewModel[];
    totalCount?: number;
}

export interface IncidentTableEntryViewModel {
    id?: string | undefined;
    ticketNumber?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    ticketClass?: string | undefined;
    economicUnit?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    createdOn?: Date | undefined;
    status?: string | undefined;
    hasDocuments?: boolean;
    tasks?: IncidentTableEntryTaskViewModel[] | undefined;
}

export interface IncidentTableEntryTaskViewModel {
    taskId?: string;
    subject?: string | undefined;
    status?: string | undefined;
    organisationId?: string | undefined;
    organisationName?: string | undefined;
    processorId?: string | undefined;
    processorName?: string | undefined;
    isActive?: boolean;
}

export interface BaseSearchOptions {
    orderOptions?: OrderOptions | undefined;
    pagingOptions?: PagingOptions | undefined;
}

export interface IncidentSearchOptions extends BaseSearchOptions {
    filterOptions?: IncidentFilterOptions | undefined;
    viewOptions?: IncidentViewOptions | undefined;
}

export interface BaseFilterOptions {
    streetName?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
}

export interface IncidentFilterOptions extends BaseFilterOptions {
    ticketNumber?: string | undefined;
    locationIdList?: string[] | undefined;
    name?: string | undefined;
    statusreasonList?: string[] | undefined;
    createDateFrom?: Date | undefined;
    createDateRange?: (Date | undefined)[] | undefined;
    deadlineDate?: Date | undefined;
    externalCompletionDateRange?: (Date | undefined)[] | undefined;
    createDateTo?: Date | undefined;
    status?: string | undefined;
    ticketTaskSelection?: string | undefined;
    ticketClassList?: string[] | undefined;
    economicUnit?: string | undefined;
    statusReason?: string | undefined;
    ticketDescription?: string | undefined;
    parentIncidentId?: string | undefined;
    organisation?: string | undefined;
    archObjId?: string | undefined;
    rejectionReason?: string | undefined;
    product?: string | undefined;
}

export interface IncidentViewOptions {
    selectCountOnly?: boolean | undefined;
    selectedView?: IncidentViews | undefined;
    selectedRoles?: string[] | undefined;
}

export enum IncidentViews {
    CreatedByMe = 0,
    VisibleForMe = 1,
    VisibleByTaskAssociation = 2,
    AllIncidents = 3,
    VisibleByOneTaskAssociation = 4,
    VisibleByMyTaskAssociation = 5,
    MyLocationMalfunctions = 6,
    AllDtagIncidentsWithActiveTasks = 7,
    MyDtagIncidents = 8,
    MyDtagIncidentsWithActiveTasks = 9,
}

export interface OrderOptions {
    attributeName: string;
    orderDirection: OrderDirection;
}

export enum OrderDirection {
    None = 0,
    Asc = 1,
    Desc = 2,
}

export interface PagingOptions {
    skip: number;
    take: number;
}

export interface ResultWrapperOfDtagIncidentTableEntryViewModel {
    entites?: DtagIncidentTableEntryViewModel[];
    totalCount?: number;
}

export interface DtagIncidentTableEntryViewModel extends IncidentTableEntryViewModel {
    rejectionReason?: string | undefined;
    product?: string | undefined;
}

export interface BaseIncidentViewModel {
    incidentId?: string;
    archObjId?: string | undefined;
    name?: string;
    description?: string;
    ticketNumber?: string;
    createdOn?: Date | undefined;
    addressString?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    documents?: FmDocument[] | undefined;
    workTaskId?: string | undefined;
}

export interface BuildingFaultIncidentViewModel extends BaseIncidentViewModel {
    requestType?: string;
    room?: string;
    floor?: string | undefined;
    structuralPart?: string | undefined;
    creatorName?: string;
    creatorEmail?: string | undefined;
    reporterName?: string | undefined;
    reporterEmail?: string | undefined;
    deviatingAddress?: string | undefined;
}

export interface ResultWrapperOfBuildingFaultIncidentViewModel {
    entites?: BuildingFaultIncidentViewModel[];
    totalCount?: number;
}

export interface BuildingFaultIncidentRequest extends BaseSearchOptions {
    archObjId?: string | undefined;
    isUserFiltered?: boolean;
    filterOptions?: BuildingFaultFilterOptions | undefined;
}

export interface BuildingFaultFilterOptions extends BaseFilterOptions {
    incidentTicketNumber?: string | undefined;
    incidentName?: string | undefined;
    incidentDescription?: string | undefined;
    incidentAddress?: string | undefined;
    generalRequestRoom?: string | undefined;
    generalRequestFloor?: string | undefined;
    generalRequestStructuralPart?: string | undefined;
    generalRequestDeviatingAddress?: string | undefined;
    dateRangeStart?: Date | undefined;
    dateRangeEnd?: Date | undefined;
}

export interface ResultWrapperOfMyIncidentsViewModel {
    entites?: MyIncidentsViewModel[];
    totalCount?: number;
}

export interface MyIncidentsViewModel {
    incidentId?: string;
    incidentClassId?: string;
    incidentClassName?: string;
    requestType?: string;
    archObjId?: string | undefined;
    name?: string;
    description?: string;
    ticketNumber?: string;
    createdOn?: Date | undefined;
    addressString?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    room?: string;
    floor?: string | undefined;
    structuralPart?: string | undefined;
    deviatingAddress?: string | undefined;
}

export interface MyIncidentsRequest extends BaseSearchOptions {
    archObjId?: string | undefined;
    isUserFiltered?: boolean;
    filterOptions?: MyIncidentsRequestFilterOptions | undefined;
}

export interface MyIncidentsRequestFilterOptions extends BaseFilterOptions {
    incidentTicketNumber?: string | undefined;
    incidentName?: string | undefined;
    incidentDescription?: string | undefined;
    incidentAddress?: string | undefined;
    incidentType?: string | undefined;
    incidentClass?: string | undefined;
    generalRequestRoom?: string | undefined;
    generalRequestFloor?: string | undefined;
    generalRequestStructuralPart?: string | undefined;
    generalRequestDeviatingAddress?: string | undefined;
    dateRangeStart?: Date | undefined;
    dateRangeEnd?: Date | undefined;
}

export interface OrderAccessIncidentViewModel extends BaseIncidentViewModel {
    keyNumber?: string | undefined;
    creatorName?: string;
    creatorEmail?: string | undefined;
    reporterName?: string | undefined;
    reporterEmail?: string | undefined;
    sumOfOrderedKeys?: number | undefined;
}

export interface FurnitureOrderIncidentViewModel extends BaseIncidentViewModel {
    deliveryAddressFirstName?: string | undefined;
    deliveryAddressLastName?: string | undefined;
    deliveryAddressStreet?: string | undefined;
    deliveryAddressPostalCode?: string | undefined;
    deliveryAddressCity?: string | undefined;
    floor?: string | undefined;
    roomNumber?: string | undefined;
    deskNumber?: string | undefined;
    requestedDate?: Date | undefined;
    flooringHard?: boolean | undefined;
    flooringSoft?: boolean | undefined;
    statementBad?: boolean | undefined;
    electricDesk?: boolean | undefined;
    specialOrder?: boolean | undefined;
    severeDisability?: boolean | undefined;
    teleWork?: boolean | undefined;
    creator?: EmployeeViewModel | undefined;
    contactPerson?: EmployeeViewModel | undefined;
    pspElement?: string | undefined;
}

export interface EmployeeViewModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export interface RelocationViewModel extends BaseIncidentViewModel {
    infoConsent?: boolean | undefined;
    spaceRequestReturn?: boolean | undefined;
    creator?: EmployeeViewModel | undefined;
    contactPerson?: EmployeeViewModel | undefined;
    addressStringOrigin?: string | undefined;
    originAddressFirstName?: string | undefined;
    originAddressLastName?: string | undefined;
    originAddressStreet?: string | undefined;
    originAddressPostalCode?: string | undefined;
    originAddressCity?: string | undefined;
    addressStringTarget?: string | undefined;
    targetAddressFirstName?: string | undefined;
    targetAddressLastName?: string | undefined;
    targetAddressStreet?: string | undefined;
    targetAddressPostalCode?: string | undefined;
    targetAddressCity?: string | undefined;
    requestedDate?: Date | undefined;
    originFloor?: string | undefined;
    originRoomNumber?: string | undefined;
    originDeskNumber?: string | undefined;
    targetFloor?: string | undefined;
    targetRoomNumber?: string | undefined;
    targetDeskNumber?: string | undefined;
}

export interface SpaceRequestViewModel extends BaseIncidentViewModel {
    creator?: EmployeeViewModel | undefined;
    contactPerson?: EmployeeViewModel | undefined;
    areaRequirements?: AreaRequirementViewModel[] | undefined;
    requestedDate?: Date | undefined;
}

export interface AreaRequirementViewModel {
    id?: string;
    areaRequestId?: string;
    squareMeters?: string;
    costCenter?: CostCenterViewModel | undefined;
    type?: string;
}

export interface CostCenterViewModel {
    id?: string;
    name?: string;
}

export interface AreaReturnViewModel extends BaseIncidentViewModel {
    creator?: EmployeeViewModel | undefined;
    contactPerson?: EmployeeViewModel | undefined;
    orgUnit?: string | undefined;
    department?: string | undefined;
    costCenterId?: string | undefined;
    billingAreaId?: string | undefined;
    requestedDate?: Date | undefined;
    costCenterSociety?: string | undefined;
    costCenterUsages?: CostCenterUsageViewModel[] | undefined;
    strategicBusinessUnitUsages?: StrategicBusinessUnitUsageViewModel[] | undefined;
}

export interface CostCenterUsageViewModel {
    workSpace?: string | undefined;
    room?: string | undefined;
    floorArea?: number | undefined;
    usageUntil?: Date | undefined;
    costCenterId?: string | undefined;
}

export interface StrategicBusinessUnitUsageViewModel {
    sbuId?: string | undefined;
    usageFrom?: Date | undefined;
    usageUntil?: Date | undefined;
    cntWorkspaces?: number | undefined;
    cntWorkspacesRequested?: number | undefined;
    costCenterId?: string | undefined;
    requestedDate?: Date | undefined;
}

export interface UserAdministrationViewModel {
    createdOn?: Date | undefined;
    incidentClass?: string | undefined;
    name?: string | undefined;
    incidentStatus?: string | undefined;
    creator?: ContactViewModel | undefined;
    user?: ContactViewModel | undefined;
    roleIncidents?: RoleIncidentViewModel[] | undefined;
}

export interface RoleIncidentViewModel {
    incidentClass?: string | undefined;
    incidentStatus?: string | undefined;
    roleName?: string | undefined;
    approvalStatus?: string | undefined;
    reason?: string | undefined;
}

export interface GetIncidentDTO {
    ticketNumber: string;
    primaryContactEmail: string;
}

export interface SubIncidentViewModel {
    incidentId?: string | undefined;
    ticketNumber?: string | undefined;
    requestedArea?: number | undefined;
    requestedParkingSpace?: number | undefined;
    ticketStatusReason?: string | undefined;
}

export interface BaseSelectViewModel {
    id?: any;
    name?: string;
}

export interface RequestFileWrapperOfCreateSpaceRequestRequest {
    entity?: CreateSpaceRequestRequest | undefined;
    files?: UploadFile[];
}

export interface CreateSpaceRequestRequest {
    shortTitle?: string;
    description?: string;
    locationArchObjId?: string;
    requestedDate?: Date;
    areaRequirements?: AreaRequirementViewModel[] | undefined;
    creatorId?: string;
    contactPersonId?: string;
    mails?: string | undefined;
}

export interface RequestFileWrapperOfCostCenterAreaReturnTicketRequest {
    entity?: CostCenterAreaReturnTicketRequest | undefined;
    files?: UploadFile[];
}

export interface BaseAreaReturnTicketRequest {
    title: string;
    description: string;
    organisationalUnit?: string | undefined;
    department?: string | undefined;
    archObjId: string;
    requestedDate: Date;
    costCenterSociety?: string | undefined;
    notifyingContactId: string;
    contactPersonId?: string | undefined;
    mails?: string | undefined;
    areaReturnUsages?: AreaReturnUsage[] | undefined;
}

export interface CostCenterAreaReturnTicketRequest extends BaseAreaReturnTicketRequest {
    costCenterId: string;
}

export interface AreaReturnUsage {
    requestedDate: Date;
    usageId: string;
    quantity?: number | undefined;
}

export interface RequestFileWrapperOfSbuAreaReturnTicketRequest {
    entity?: SbuAreaReturnTicketRequest | undefined;
    files?: UploadFile[];
}

export interface SbuAreaReturnTicketRequest extends BaseAreaReturnTicketRequest {
    billingAreaId: string;
}

export interface IncidentPdfRequest {
    incidentId: string;
}

export interface ConfigurationTaskViewModel {
    id?: string;
    name?: string;
    sequence?: number | undefined;
}

export interface ResultWrapperOfLocationSearchEntryViewModel {
    entites?: LocationSearchEntryViewModel[];
    totalCount?: number;
}

export interface LocationViewModel {
    id?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    streetName?: string | undefined;
    houseNumber?: string | undefined;
}

export interface LocationSearchEntryViewModel extends LocationViewModel {
    isFavorite?: boolean;
}

export interface ArchObjHierarchyViewModel {
    id?: string;
    parentArchObjId?: string;
    archObjType?: string;
    changeDate?: Date | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    dtSite?: DtSite;
    isFavorite?: boolean;
    dtArchObjAddress?: ArchObjToAddressViewModel[];
    incidents?: ArchObjIncidentViewModel[];
}

export interface ArchObjToAddressViewModel {
    archObjId?: string;
    addressId?: string;
    address?: AddressViewModel;
}

export interface AddressViewModel {
    addressId?: string;
    name?: string | undefined;
    type?: string | undefined;
    streetName?: string | undefined;
    houseNumber?: string | undefined;
    additionalInformation?: string | undefined;
    apartmentNumber?: string | undefined;
    district?: string | undefined;
    city?: string;
    state?: string | undefined;
    country?: string | undefined;
    alternateKey?: string | undefined;
    postalCode?: string | undefined;
    longitude?: number | undefined;
    latitude?: number | undefined;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
    changeDate?: Date | undefined;
}

export interface ArchObjIncidentViewModel {
    incidentId?: string;
    name?: string;
    archObjId?: string;
    ticketNumber?: string;
    createdOn?: Date | undefined;
    room?: ArchObjViewModel | undefined;
}

export interface ArchObjLocationInformationViewModel {
    id?: string | undefined;
    archObjId?: string | undefined;
    category?: ArchObjInformationCategoryViewModel | undefined;
    text?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    link?: string | undefined;
    linkName?: string | undefined;
    isPublished?: boolean;
    changeDate?: Date | undefined;
}

export interface ArchObjInformationCategoryViewModel {
    id?: string | undefined;
    name?: string | undefined;
    icon?: any | undefined;
    sortNumber?: number | undefined;
}

export interface LocationNotificationRequest {
    archObjId?: string;
    address?: AddressViewModel;
    additionalRecipients?: string[] | undefined;
    attachements?: AttachmentRequest[] | undefined;
    mailContent?: string;
    subject?: string;
}

export interface AttachmentRequest {
    fileName?: string | undefined;
    content?: string | undefined;
}

export interface BuildingMaintenanceViewModel {
    archObjId?: string;
    name?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    number?: string | undefined;
    buildingClass?: string | undefined;
    wmCluster?: string | undefined;
    changeReason?: string | undefined;
    aoid?: string | undefined;
    buildingClasses?: BuildingClassViewModel[] | undefined;
    buildingFloor?: BuildingFloorViewModel | undefined;
    archObjUtilizationHistories?: ArchObjUtilizationViewModel[] | undefined;
}

export interface BuildingClassViewModel {
    buildingClassId: string;
}

export interface BuildingFloorViewModel {
    floorId?: string | undefined;
    floorDescription?: string | undefined;
    floorName?: string | undefined;
    changeReason?: string | undefined;
}

export interface ArchObjUtilizationViewModel {
    id: string;
    archObjId: string;
    validFrom: Date;
    validUntil: Date;
    usageTypeId: string;
    detailAreaType: string;
    buildingClassId: string;
    createDate: Date;
    createdBy: string;
    changeDate: Date;
    changedBy: string;
    status: string;
    sapGuid: string;
    changeReason?: string | undefined;
}

export interface BuildingRoomViewModel {
    spaceId: string;
    primaryRoomNumber?: string | undefined;
    aoid?: string | undefined;
    magOfficeString?: string | undefined;
    wmProd?: string | undefined;
    measurement?: string | undefined;
    wmCluster?: string | undefined;
    usageTypeDetailAreaType?: string | undefined;
    architecturalArea?: number;
    rentalArea_REM?: number;
    userArea?: number;
    cntWorkspacesAvailable?: number;
    cntWorkspacesOccupied?: number;
    cntWorkspacesPlanned?: number;
    tiFlag?: boolean;
    isWmv?: boolean;
    isWarmRentalContractValid?: boolean;
    isRoutineCleaning?: boolean;
    roomDescription?: string | undefined;
    wmProdIndi?: string | undefined;
    wmClusterIndi?: string | undefined;
    wmClusterInfo?: string | undefined;
    magOfficeDetailAreaType?: string | undefined;
    billingAreaId?: string | undefined;
    calculationType?: string | undefined;
    centralInfo?: string | undefined;
    changeReason?: string | undefined;
    usageCategories?: DtUsageCategoryViewModel[] | undefined;
    archObjUtilizationHistories?: ArchObjUtilizationViewModel[] | undefined;
}

export interface DtUsageCategoryViewModel {
    name?: string | undefined;
    usageTypes?: DtUsageType[] | undefined;
}

export interface UpdateBuildingMaintenanceRoomRequest {
    spaceId: string;
    name?: string | undefined;
    tiFlag?: boolean;
    wmProdIndi?: string | undefined;
    calculationType?: string | undefined;
    centralInfo?: string | undefined;
}

export interface CreateArchObjUtilHistoryRequest {
    validFrom: Date;
    archObjId: string;
    usageTypeId?: string | undefined;
    detailAreaType?: string | undefined;
    buildingClassId?: string | undefined;
    changeReason: string;
}

export interface BaseChangeLocationDto {
    id: string;
    changeReason: string;
    locationIdentifier?: string | undefined;
}

export interface ChangeFloorDto extends BaseChangeLocationDto {
    name2?: string | undefined;
}

export interface UpdateFloorRequest extends ChangeFloorDto {
}

export interface ChangeBuildingDto extends BaseChangeLocationDto {
    wmCluster?: string | undefined;
    buildingClass?: string | undefined;
}

export interface UpdateBuildingRequest extends ChangeBuildingDto {
}

export interface UpdateArchObjUtilHistoryRequest {
    archObjUtilHistoryId: string;
    buildingClassId?: string | undefined;
    usageTypeId?: string | undefined;
    detailAreaType?: string | undefined;
    changeReason: string;
}

export interface ChangeRoomDto extends BaseChangeLocationDto {
    name2?: string | undefined;
    userArea?: number | undefined;
    workspacesPlanned?: number | undefined;
    workspacesAvailable?: number | undefined;
    workspacesOccupied?: number | undefined;
    wmIndividualProduct?: string | undefined;
    wmIndividualCluster?: string | undefined;
    wmClusterInformation?: string | undefined;
    isWMVerrechnung?: boolean | undefined;
    areaType?: string | undefined;
    routineCleaning?: boolean | undefined;
    calculationType?: string | undefined;
    tiFlag?: boolean | undefined;
    centralInfo?: string | undefined;
    typeOfUse?: string | undefined;
    detailAreaType?: string | undefined;
}

export interface UpdateRoomRequest extends ChangeRoomDto {
    billingArea?: string | undefined;
}

export interface FrozenZoneViewModel {
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export interface ArchObjTreeViewModel {
    id?: string | undefined;
    type?: string | undefined;
    displayName?: string | undefined;
    children?: ArchObjTreeViewModel[] | undefined;
    childrenCount?: number;
}

export interface RoomViewModel {
    roomId?: string;
    room?: string | undefined;
    description?: string | undefined;
    aoid?: string | undefined;
    isWmProdManagement?: boolean;
}

export interface MassEditRoomRequest {
    roomIds: string[];
    changeReason: string;
    roomData?: MassUpdateRoomRequest | undefined;
    utilizationHistoryData?: MassUpdateUtilHistoryRequest | undefined;
}

export interface MassUpdateRoomRequest {
    calculationType?: string | undefined;
    billingArea?: string | undefined;
    centralInfo?: string | undefined;
    areaType?: string | undefined;
    tiFlag?: boolean | undefined;
    isRoutineCleaning?: boolean | undefined;
}

export interface MassUpdateUtilHistoryRequest {
    validFromDate: Date;
    usageTypeId?: string | undefined;
    detailAreaType?: string | undefined;
}

export enum EnumType {
    Affinis_nationality = 0,
    Affinis_buildingFloor = 1,
}

export interface UserViewModel {
    id?: string;
    accountEnabled?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    contactId?: string | undefined;
    isTelekomEmployee?: boolean | undefined;
    lastSignIn?: Date | undefined;
    roles?: RoleViewModel[];
}

export interface RoleViewModel {
    id?: string;
    name?: string;
    description?: string;
}

export interface UpdateUserProfileDTO {
    contactId: string;
    telephonenumber?: string | undefined;
    mobilePhonenumber?: string | undefined;
    preferredLanguageEnumId?: string | undefined;
    preferredContactMethodEnumId?: string | undefined;
    subscribeNewsletter?: boolean | undefined;
    deleteProfilePicture?: boolean | undefined;
    profilePictureBase64?: string | undefined;
}

export interface RentalContractViewModel extends PmRentalContract {
    documentMetadata?: DocumentMetadata[];
    contactDocumentMetadata?: DocumentMetadata[];
    contactFmDocuments?: FmDocument[];
}

export interface CreateAccessOrdererRequest {
    costCenterId: string;
    employeeId: string;
}

export interface CreateAccessOrderersRequest {
    costCenterIds: string[];
    employeeId: string;
}

export interface AccessOrdererTableEntryViewModel {
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    employeePhoneNumber?: string | undefined;
    employeeEmail?: string | undefined;
    costCenterId?: string | undefined;
    costCenterName?: string | undefined;
    accessOrdererId?: number | undefined;
    accessOrdererEnddate?: Date | undefined;
    orgUnit?: string | undefined;
    isExtendable?: boolean;
}

export interface GetAccessOrderersRequest {
    costCenterId?: string | undefined;
    employeeId?: string | undefined;
}

export interface ResultWrapperOfAccessOrdererHistoryTableEntryViewModel {
    entites?: AccessOrdererHistoryTableEntryViewModel[];
    totalCount?: number;
}

export interface AccessOrdererHistoryTableEntryViewModel {
    costCenterId?: string | undefined;
    employeeId?: string | undefined;
    employeeLastName?: string | undefined;
    employeeFirstName?: string | undefined;
    kostvLastName?: string | undefined;
    kostvFirstName?: string | undefined;
    accessOrdererId?: number | undefined;
    accessOrdererCreateDate?: Date | undefined;
    accessOrdererEndDate?: Date | undefined;
    accessOrdererDeleteDate?: Date | undefined;
    isValid?: boolean;
}

export interface CostCenterSearchResultDto {
    costCenter?: string | undefined;
    designation?: string | undefined;
    sbuId?: string | undefined;
}

export interface EmploymentSearchResultDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    company?: string | undefined;
    orgUnit?: string | undefined;
    costCenterName?: string | undefined;
}

export interface ResultWrapperOfApprovalViewModel {
    entites?: ApprovalViewModel[];
    totalCount?: number;
}

export interface ApprovalViewModel {
    id?: string;
    name?: string;
    archObjId?: string;
    ticketNumber?: string;
    approvalStatus?: string;
    sequence?: number;
    offerValue?: number | undefined;
    issOfferAvailable?: boolean;
    workTaskId?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
}

export interface ApprovalSearchOptions extends BaseSearchOptions {
    incidentId?: string | undefined;
    filterOptions?: ApprovalFilterOptions | undefined;
}

export interface ApprovalFilterOptions {
    approvalStatusId?: string | undefined;
}

export interface AnswerApproval {
    id?: string;
    approvalState?: AnswerApprovalState;
    reporterId?: string | undefined;
    returnMessage?: string | undefined;
}

export enum AnswerApprovalState {
    Abgelehnt = 0,
    Freigegeben = 1,
    Offen = 2,
    RueckgabeAnFreigeber = 3,
}

export interface ApprovalDetailViewModel {
    id?: string;
    incidentId?: string;
    ticketNumber?: string | undefined;
    ticketTitle?: string | undefined;
    ticketClass?: string | undefined;
    ticketDescription?: string | undefined;
    productNumber?: string | undefined;
    productDescription?: string | undefined;
    rentalUnit?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    ticketCreateDateString?: string | undefined;
    ticketCreatorName?: string | undefined;
    offerValue?: string | undefined;
}

export interface ResultWrapperOfApprovalHistoryViewModel {
    entites?: ApprovalHistoryViewModel[];
    totalCount?: number;
}

export interface ApprovalHistoryViewModel extends ApprovalViewModel {
    reportedByName?: string | undefined;
    reportedOnDateString?: string | undefined;
}

export interface BillingAreaNavigationViewmodel {
    id?: string;
    billingAreaTitle?: string;
    sbuTitle?: string;
    detailsTitle?: string;
    buildings?: ArchObjTreeViewModel[] | undefined;
}

export interface UsageTableViewModelOfBillingAreaUsageShareViewModel {
    groups?: UsageGroupViewModel[] | undefined;
    items?: BillingAreaUsageShareViewModel[] | undefined;
}

export interface UsageGroupViewModel {
    id?: string;
    title?: string;
}

export interface BaseUsageShareViewModel {
    start?: number;
    end?: number;
    popupStart?: number;
    popupEnd?: number;
    color?: string;
}

export interface CostCenterUsageShareViewModel extends BaseUsageShareViewModel {
    id?: string | undefined;
    group_id?: string | undefined;
    title?: string | undefined;
    workspaceTitle?: string | undefined;
    costCenterId?: string | undefined;
    areaString?: string | undefined;
    color?: string;
    isDispo?: boolean;
    isDummy?: boolean;
}

export interface BillingAreaUsageShareViewModel extends CostCenterUsageShareViewModel {
    title?: string | undefined;
    strategicBusinessUnitId?: string | undefined;
    billingAreaName?: string | undefined;
    cntWorkspaces?: number;
    areaPercentage?: number | undefined;
    areaUsed?: number | undefined;
}

export interface UsageTableViewModelOfStrategicBusinessUnitUsageShareViewModel {
    groups?: UsageGroupViewModel[] | undefined;
    items?: StrategicBusinessUnitUsageShareViewModel[] | undefined;
}

export interface StrategicBusinessUnitUsageShareViewModel extends BaseUsageShareViewModel {
    sbuUsageId?: string | undefined;
    id?: string | undefined;
    group_id?: string | undefined;
    title?: string | undefined;
    billingAreaId?: string | undefined;
    costCenterId?: string | undefined;
    strategicBusinessUnitId?: string | undefined;
    color?: string;
    billingAreaName?: string | undefined;
    cntWorkspaces?: number;
    areaPercentage?: number | undefined;
    areaUsed?: number | undefined;
    isDispo?: boolean;
}

export interface BaseStrategicBusinessUnitUsageRequest {
    billingAreaId: string;
    strategicBusinessUnitId: string;
    usageFrom: Date;
    usageUntil: Date;
    numberOfWorkspaces: number;
    changeReason: string;
    costCenterId?: string | undefined;
}

export interface CreateStrategicBusinessUnitUsageRequest extends BaseStrategicBusinessUnitUsageRequest {
    createInitialUsage: boolean;
}

export interface UpdateStrategicBusinessUnitUsageRequest extends BaseStrategicBusinessUnitUsageRequest {
    id: string;
}

export interface GetAvailableWorkspacesRequest {
    billingAreaId?: string;
    usageId?: string | undefined;
    sbuId?: string | undefined;
    from?: Date;
    until?: Date;
}

export interface BillingAreaUsageDetailsBaseViewmodel {
    title?: string;
    strategicBusinessUnitId?: string | undefined;
    workspaceCount?: number;
    freeWorkspaceCount?: number;
    usageFrom?: Date;
    usageUntil?: Date;
}

export interface BillingAreaUsageDetailsViewmodel extends BillingAreaUsageDetailsBaseViewmodel {
    id?: string;
    costCenterId?: string;
}

export interface BillingAreaSbuUsageDetailsViewmodel extends BillingAreaUsageDetailsBaseViewmodel {
    id?: string;
    strategicBusinessUnitId?: string | undefined;
}

export interface BillingAreaDetailsViewmodel {
    id?: string;
    title?: string;
    cntWorkspace?: string;
    cntWorkspaceUsed?: string;
    cntWorkspaceFree?: string;
    area?: string;
    areaPerWorkspace?: string;
    price?: string;
    pricePerWorkspace?: string;
}

export interface CreateBillingAreaRequest {
    changeReason: string;
    name: string;
    siteId: string;
    validFrom?: Date | undefined;
    validUntil?: Date | undefined;
}

export interface UpdateBillingAreaRequest {
    billingAreaId: string;
    changeReason: string;
    name: string;
}

export interface DeleteBillingAreaRequest {
    billingAreaId: string;
    changeReason: string;
}

export interface AreaReturnSbuUsageTableViewModel {
    id?: string;
    costCenterId?: string;
    numberOfWorkspaces?: number;
    sbuId?: string;
    usageUntil?: Date;
}

export interface ChangeUsageCostCenterRequest {
    costCenterId?: string;
    changeReason?: string;
    usages?: UsageChangeRequest[];
}

export interface UsageChangeRequest {
    usageId?: string;
    changeDate?: Date;
}

export interface UsageTableViewModelOfCostCenterUsageShareViewModel {
    groups?: UsageGroupViewModel[] | undefined;
    items?: CostCenterUsageShareViewModel[] | undefined;
}

export interface CostCenterUsageDetailsViewModel {
    id?: string;
    archObjId?: string;
    title?: string | undefined;
    costCenterId?: string;
    costCenterName?: string | undefined;
    reservedArea?: number;
    freeArea?: number;
    remarks?: string | undefined;
    lastChangeInfo?: string | undefined;
    validFromDate?: Date;
    validUntilDate?: Date;
    changeReasonId?: string | undefined;
    isRoom?: boolean;
    isDispo?: boolean;
}

export interface UpdateCostCenterUsageRequest {
    id: string;
    costCenterId: string;
    usageFrom: Date;
    usageUntil: Date;
    area: number;
    remarks?: string | undefined;
    changeReason: string;
}

export interface DeleteCostCenterUsageRequest {
    id: string;
    changeReason: string;
}

export interface CheckWorkspaceAvailabilityRequest {
    id?: string;
    archObjId?: string;
    validFromDate?: Date;
    validUntilDate?: Date;
}

export interface GetAvailableRoomAreaRequest {
    archObjid?: string;
    usageId?: string;
    from?: Date;
    until?: Date;
}

export interface DeleteWorkspaceUsageRequest {
    id: string;
    changeReason: string;
}

export interface AreaManagementUsageTableViewModel {
    id?: string;
    usageUntil?: string;
    roomName?: string | undefined;
    buildingFloorTitle?: string | undefined;
    workspaceName?: string | undefined;
    area?: string | undefined;
    originalUsageUntil?: string;
    costCenter?: string;
}

export interface ChangeRoomsRequest {
    roomIds: string[];
    changeReason: string;
}

export interface ClearingIndicatorViewModel {
    businessUnit?: string | undefined;
    building?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    room?: string | undefined;
    aoid?: string;
    createDate?: Date | undefined;
    rentalProperty?: string | undefined;
    rentalContract?: string | undefined;
    roomId?: string;
}

export interface ResultWrapperOfAreaValueViewModel {
    entites?: AreaValueViewModel[];
    totalCount?: number;
}

export interface AreaValueViewModel {
    spaceId: string;
    aoid?: string | undefined;
    areaDifference?: number;
    areaUser?: number;
    businessUnit?: string | undefined;
    rentalAreaRem?: number;
    room?: string | undefined;
    roomDescription?: string | undefined;
}

export interface GetAreaValuesRequest extends BaseSearchOptions {
    businessUnit?: string | undefined;
    aoid?: string | undefined;
}

export interface OverbookedRoomsViewModel {
    spaceId: string;
    aoid?: string | undefined;
    areaUser?: number;
    businessUnit?: string | undefined;
    room?: string | undefined;
    totalAreaUtilisation?: number;
}

export interface InactiveRoomsViewModel {
    businessUnit?: string | undefined;
    addressString?: string | undefined;
    rooms?: RoomViewModel[];
}

export interface BuildingManagersViewModel {
    buildingId?: string | undefined;
    buildingName?: string | undefined;
    managers?: ManagerViewModel[] | undefined;
}

export interface ManagerViewModel {
    costCenter?: CostCenterViewModel | undefined;
    company?: string | undefined;
    orgUnit?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export interface ResultWrapperOfUsageChangeHistoryViewModel {
    entites?: UsageChangeHistoryViewModel[];
    totalCount?: number;
}

export interface UsageChangeHistoryViewModel {
    archObjId?: string;
    areaType?: string;
    buildingFloorName?: string | undefined;
    roomName?: string | undefined;
    workspaceName?: string | undefined;
    billingAreaName?: string | undefined;
    oldCostCenterId?: string;
    newCostCenterId?: string;
    workspaces?: number | undefined;
    floorArea?: number;
    changeDate?: Date;
    changeOverDate?: Date;
    usageFrom?: Date;
    usageUntil?: Date;
    employee?: EmployeeViewModel;
    location?: LocationViewModel;
}

export interface GetUsageChangeHistoryRequest extends BaseSearchOptions {
    locationId?: string | undefined;
    changeDateFrom?: Date | undefined;
    changeDateTo?: Date | undefined;
    areaType?: string | undefined;
    aoid?: string | undefined;
    oldCostCenterId?: string | undefined;
    newCostCenterId?: string | undefined;
    employee?: string | undefined;
}

export interface ResultWrapperOfEmploymentSearchResultDto {
    entites?: EmploymentSearchResultDto[];
    totalCount?: number;
}

export interface RentalListingOverviewViewModel {
    id?: string | undefined;
    title?: string | undefined;
    imageUrl?: string | undefined;
}

export interface RentalListingDto {
    id?: number;
    archObjId?: string;
    title?: string;
    description?: string | undefined;
    link?: string | undefined;
    linkDisplayName?: string | undefined;
    isPublished?: boolean;
    longitude?: number | undefined;
    latitude?: number | undefined;
    primaryDocumentId?: number | undefined;
    documents?: RentalListingDocumentDto[] | undefined;
    address?: AddressDto | undefined;
    createdAt?: Date | undefined;
}

export interface RentalListingDocumentDto {
    content?: string | undefined;
    id?: number | undefined;
    fileName?: string;
    fileUri?: string | undefined;
}

export interface AddressDto {
    id?: string;
    streetName?: string | undefined;
    houseNumber?: string | undefined;
    district?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
}

export interface RentalListingDetailViewModel extends RentalListingOverviewViewModel {
    description?: string | undefined;
    files?: RentalListingDocumentViewModel[] | undefined;
    link?: string | undefined;
    displayNameLink?: string | undefined;
    latitude?: number;
    longitude?: number;
    createdAt?: Date | undefined;
}

export interface RentalListingDocumentViewModel {
    fileName?: string;
    id?: number;
    uri?: string;
}

export interface CreateOrUpdateRentalListingRequest {
    archObjId: string;
    title: string;
    description?: string | undefined;
    link?: string | undefined;
    linkDisplayName?: string | undefined;
    isPublished?: boolean;
    latitude?: number | undefined;
    longitude?: number | undefined;
    documents?: RentalListingDocument[] | undefined;
}

export interface RentalListingDocument {
    content?: string | undefined;
    fileName?: string | undefined;
    id?: number | undefined;
    isPrimary?: boolean;
}

export interface DocumentMetadataRequest {
    rowkey?: string | undefined;
    entityId?: string | undefined;
    incidentid?: string | undefined;
    taskId?: string | undefined;
    status?: UploadStatus | undefined;
}

export interface SystemException extends Exception {
}

export interface UnauthorizedAccessException extends SystemException {
}

export interface DocumentMetadataWithEmailRequest extends DocumentMetadataRequest {
    ticketNumber: string;
    primaryContactEmail: string;
}

export interface GetDocumentTypesViewModel {
    documentTypes?: DocumentTypeViewModel[];
    defaultDocumentTypeId?: string | undefined;
}

export interface DocumentTypeViewModel {
    documentTypeId?: string | undefined;
    abbreviation?: string | undefined;
    name?: string | undefined;
    externalCode?: string | undefined;
    gefmaCode?: string | undefined;
    gefmaText?: string | undefined;
    deleteDate?: Date | undefined;
    isExternal?: boolean;
    maxFileSizeInBytes?: number | undefined;
    fmDocumentTypeContentType?: ContentTypeViewModel[];
}

export interface ContentTypeViewModel {
    documentTypeId?: string | undefined;
    contentType?: string | undefined;
}

export interface FileUploadException extends Exception {
    errors?: SmartPortalException[];
}

export interface UploadFilesTempStorageRequest {
    targetEntityId: string;
    files: UploadFileTempStorage[];
}

export interface UploadFileTempStorage extends UploadFile {
    targetSystem: TargetSystem;
}

export interface UploadFilesWithEmailRequest extends UploadFilesTempStorageRequest {
    ticketNumber: string;
    primaryContactEmail: string;
}

export interface CreateSubstitutionsRequest {
    costCenterIds: string[];
    substituteEmployeeId: string;
    validFrom: Date;
    validUntil: Date;
}

export interface SubstitutionTableEntryViewModel {
    deleteDate?: Date | undefined;
    employeeId?: string;
    employeeName?: string | undefined;
    employeePhoneNumber?: string | undefined;
    employeeEmail?: string | undefined;
    id?: number;
    costCenterId?: string;
    costCenterName?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export interface GetSubstitutionsRequest {
    costCenterId?: string | undefined;
    employeeId?: string | undefined;
    includeDeleted?: boolean | undefined;
    includeExpired?: boolean | undefined;
}

export interface ResultWrapperOfTaskTableEntryViewModel {
    entites?: TaskTableEntryViewModel[];
    totalCount?: number;
}

export interface TaskTableEntryViewModel {
    taskId?: string;
    taskSubject?: string | undefined;
    taskDescription?: string | undefined;
    taskStatus?: string | undefined;
    taskDueDate?: Date | undefined;
    taskResult?: string | undefined;
    taskOrganisationName?: string | undefined;
    taskProcessorId?: string | undefined;
    taskIsActive?: boolean;
    taskProcessorName?: string | undefined;
    incidentId?: string | undefined;
    incidentTicketNumber?: string | undefined;
    incidentTitle?: string | undefined;
    incidentDescription?: string | undefined;
    incidentTicketClass?: string | undefined;
    incidentEconomicUnit?: string | undefined;
    incidentPostalCode?: string | undefined;
    incidentCity?: string | undefined;
    incidentStreet?: string | undefined;
}

export interface TaskSearchOptions extends BaseSearchOptions {
    filterOptions?: TaskFilterOptions | undefined;
    viewOptions?: TaskViewOptions | undefined;
}

export interface TaskFilterOptions extends BaseFilterOptions {
    subject?: string | undefined;
    description?: string | undefined;
    incidentId?: string | undefined;
    ticketNumber?: string | undefined;
    incidentTitle?: string | undefined;
    state?: string | undefined;
    dueDateFrom?: Date | undefined;
    dueDateTo?: Date | undefined;
    resultText?: string | undefined;
    taskSelection?: string | undefined;
    incidentClass?: string | undefined;
    economicUnit?: string | undefined;
    status?: string | undefined;
    incidentDescription?: string | undefined;
    externalProcessor?: string | undefined;
    organisation?: string | undefined;
}

export interface TaskViewOptions {
    selectCountOnly?: boolean | undefined;
    selectedView?: TaskViewsDtag | undefined;
    selectedRoles?: string[] | undefined;
}

export enum TaskViewsDtag {
    AllTasks = 0,
    AllActiveTasks = 1,
    MyTasks = 2,
    MyActiveTasks = 3,
}

export interface ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping {
    entity?: TaskViewModel | undefined;
    extension?: IncidentFieldMapping[] | undefined;
}

export interface IncidentFieldMapping {
    ibpdiAttributeName: string;
    targetAttributeName: string;
    ibpdiAttributeType: string;
    optionSetType?: string | undefined;
    targetEntity?: string | undefined;
}

export interface UpdateTaskDTO {
    userId?: string | undefined;
    taskId: string;
    result: string;
    status: TaskStatus;
    cancelStatus?: string | undefined;
    updateIncidentDTO?: UpdateIncidentDTO | undefined;
}

export enum TaskStatus {
    InBearbeitung = 0,
    Abgeschlossen = 1,
}

export interface UpdateIncidentDTO {
    incident: FmIncident;
    fieldMapping: IncidentFieldMapping[];
}

export interface ExportTaskExcelDto {
    fileName: string;
    ticketNumber: string;
    subject: string;
    result?: string | undefined;
    newStatus?: TaskStatus | undefined;
    formFields?: { [key: string]: string; } | undefined;
}

export interface CheckForTaskUpdateRequest {
    id: string;
    modifiedOn: Date;
}

export interface KeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;
}

export interface GetTaskDocumentTypeAssignmentsViewModel {
    assignments?: TaskDocumentTypeAssignmentViewModel[];
    defaultDocumentTypeId?: string | undefined;
}

export interface TaskDocumentTypeAssignmentViewModel {
    configurationTaskId?: string;
    documentTypeId?: string;
    documentTypeName?: string;
}

export interface UserAdministrationIncidentRequest {
    firstName?: string;
    lastName?: string;
    email?: string;
    companyId?: string | undefined;
    b2cUserId?: string | undefined;
    contactId?: string | undefined;
    roles?: string[];
}

export interface RoleIncidentRequest {
    email?: string;
    roles?: string[];
}

export interface WorkingSpaceViewModel {
    subSpaceId?: string | undefined;
    isActive?: boolean;
    apNo?: string | undefined;
    name?: string | undefined;
    isDummy?: boolean;
    dummyKind?: string | undefined;
    magentaSpaceType?: string | undefined;
    changeReason?: string | undefined;
    roomId?: string | undefined;
}

export interface CreateWorkingSpaceRequest {
    subSpaceId?: string | undefined;
    isActive?: boolean;
    apNo?: string | undefined;
    name?: string | undefined;
    isDummy?: boolean;
    dummyKind?: string | undefined;
    magentaSpaceType?: string | undefined;
    changeReason?: string | undefined;
    roomId?: string | undefined;
}

export interface UpdateWorkingSpaceRequest {
    subSpaceId?: string | undefined;
    isActive?: boolean;
    apNo?: string | undefined;
    name?: string | undefined;
    isDummy?: boolean;
    dummyKind?: string | undefined;
    magentaSpaceType?: string | undefined;
    changeReason?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}